import React, { useState } from "react";
import classNames from "classnames";

const World = ({ highlightedState }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [highlighted] = highlightedState || useState("US");
  return (
    <div className="relative inline-flex items-center justify-center flex-none w-full">
      <div className="absolute z-0 w-full md:w-[86%] inset-0 -top-6 md:-top-8 mx-auto">
        <svg
          viewBox="0 0 925 483"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
        >
          <path
            d="M925 241.5C925 410.864 738.064 483 462.5 483 186.936 483 0 410.864 0 241.5S186.936 0 462.5 0C738.064 0 925 72.136 925 241.5Z"
            fill="url(#a)"
          />
          <defs>
            <linearGradient
              id="a"
              x1="462.5"
              y1="568.637"
              x2="462.01"
              y2="-35.392"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".186" stopColor="#EBECEF" stopOpacity="0" />
              <stop offset="1" stopColor="#EBECEF" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="relative z-50 w-full md:w-[83%]">
        {/* <!--
*************Map created by Simplemaps.com********************    
*************Attribution is highly appreciated!***************
*************http://simplemaps.com****************************

The MIT License (MIT)

Copyright (c) 2020 Pareto Softare, LLC DBA Simplemaps.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

--> */}
        <svg
          fill="#ececec"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".2"
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 2000 857"
        >
          <path
            d="m1383 261.6 1.5 1.8-2.9.8-2.4 1.1-5.9.8-5.3 1.3-2.4 2.8 1.9 2.7 1.4 3.2-2 2.7.8 2.5-.9 2.3-5.2-.2 3.1 4.2-3.1 1.7-1.4 3.8 1.1 3.9-1.8 1.8-2.1-.6-4 .9-.2 1.7h-4.1l-2.3 3.7.8 5.4-6.6 2.7-3.9-.6-.9 1.4-3.4-.8-5.3 1-9.6-3.3 3.9-5.8-1.1-4.1-4.3-1.1-1.2-4.1-2.7-5.1 1.6-3.5-2.5-1 .5-4.7.6-8 5.9 2.5 3.9-.9.4-2.9 4-.9 2.6-2-.2-5.1 4.2-1.3.3-2.2 2.9 1.7 1.6.2h3l4.3 1.4 1.8.7 3.4-2 2.1 1.2.9-2.9 3.2.1.6-.9-.2-2.6 1.7-2.2 3.3 1.4-.1 2 1.7.3.9 5.4 2.7 2.1 1.5-1.4 2.2-.6 2.5-2.9 3.8.5h5.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AF",
            })}
            id="AF"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AO",
            })}
            d="m1121.2 572 .6 2-.7 3.1.9 3-.9 2.4.4 2.2-11.7-.1-.8 20.5 3.6 5.2 3.6 4-10.4 2.6-13.5-.9-3.8-3-22.7.2-.8.5-3.3-2.9-3.6-.2-3.4 1.1-2.7 1.2-.5-4 .9-5.7 2-5.9.3-2.7 1.9-5.8 1.4-2.6 3.3-4.2 1.9-2.9.6-4.7-.3-3.7-1.6-2.3-1.5-3.9-1.3-3.8.3-1.4 1.7-2.5-1.6-6.2-1.2-4.3-2.8-4.1.6-1.2 2.3-.9 1.7.1 2-.7 16.7.1 1.3 4.7 1.6 3.9 1.3 2.1 2.1 3.3 3.8-.5 1.8-.9 3.1.9.9-1.6 1.5-3.7 3.5-.3.3-1.1h2.9l-.5 2.3 6.8-.1.1 4.1 1.1 2.4-.9 3.9.4 4 1.8 2.4-.4 7.6 1.4-.6 2.4.2 3.5-1 2.6.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AO",
            })}
            d="m1055.3 539-1.5-4.8 2.3-2.8 1.7-1.1 2.1 2.2-2 1.4-1 1.6-.2 2.8-1.4.7Z"
          />
          <path
            d="m1088 228 .4 1.2 1.4-.6 1.2 1.7 1.3.7.6 2.3-.5 2.2 1 2.7 2.3 1.5.1 1.7-1.7.9-.1 2.1-2.2 3.1-.9-.4-.2-1.4-3.1-2.2-.7-3 .1-4.4.5-1.9-.9-1-.5-2.1 1.9-3.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AL",
            })}
            id="AL"
          />
          <path
            d="m1296.2 336.7 1.3 5.1h-2.8v4.2l1.1.9-2.4 1.3.2 2.6-1.3 2.6v2.6l-1 1.4-16.9-3.2-2.7-6.6-.3-1.4.9-.4.4 1.8 4.2-1 4.6.2 3.4.2 3.3-4.4 3.7-4.1 3-4 1.3 2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AE",
            })}
            id="AE"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AR",
            })}
            d="m669.1 851.7-3-.2h-5l-6-13.6 3.1 2.8 4.3 4.6 7.8 3.7 7.3 1.5-.8 3-4.4.3-3.3-2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AR",
            })}
            d="m638.6 644.7 11.3 10.4 4.6 1 7.3 4.8 5.9 2.5 1.1 2.8-4.2 9.8 5.8 1.7 6.3 1 4.2-1 4.3-5 .3-5.6 2.6-1.3 3.2 3.8.4 5.1-4.2 3.5-3.3 2.6-5.3 6.3-6 8.7-.5 5.2-.4 6.6 1.2 6.4-.9 1.4.4 4.1.3 3.4 7.8 5.5.2 4.4 3.9 2.8.3 3.1-3.3 8.2-7 3.5-10.2 1.3-6-.7 2.1 3.9.1 4.7 1.8 3.2-2.5 2.3-5.1.9-5.6-2.4-1.5 1.7 2.5 6.3 4 1.9 2.3-2 2.5 3.3-4.2 2-2.9 4 1.2 6.3-.1 3.4h-4.8l-3 3.2.1 4.8 6.5 4.6 5.2 1.2.2 5.7-4.6 3.5-.6 7.3-3.5 2.4-.9 2.9 4.2 6.5 4.6 3.5-2.1-.3-4.9-1-12.1-.8-3.5-3.6-1.9-4.6-3.1.4-2.6-2.3-3.1-6.5 2.7-2.8.1-3.9-1.8-3.2.7-5.4-1.1-8.3-1.8-3.7 1.8-1.2-1.4-2.4-2.8-1.2.8-2.7-3.1-2.4-3.7-7.3 1.7-1.3-3.3-7.8-.8-6.5-.2-5.7 2.5-2.3-3.3-6.3-1.6-5.8 3-4.2-1.4-5.4 1.6-6.2-1.4-5.9-1.6-1.2-4.9-11.1 2.1-6.6-1.7-6.2.9-5.9 2.6-6 3.3-4-2-2.5.8-2.1-1.6-10.7 5.6-3.1 1.2-6.7-.9-1.6 4-5.8 7.5 1.6 3.7 4.6 1.6-5.2 6.4.3 1 1.4Z"
          />
          <path
            d="m1230.8 253-1.8.2-2.8-3.7-.2-1h-2.3l-1.9-1.7-1 .1-2.4-1.8-4.2-1.6-.1-3.1-1.3-2.2 7-1 1.4 1.6 2.2 1.1-.7 1.6 3.2 2.2-1.1 2.1 2.6 1.7 2.5 1 .9 4.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AM",
            })}
            id="AM"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AU",
            })}
            d="m1743 763.6 3.7 2.2 3.3-.9 4.9-1.2 2.8.4-4.5 7.6-3.3 2.1-4 5.2-.6-1.8-6.6 4.4-.8-.3-3-.2.5-5.4 2-4.2.6-5.6 2-2.9 3 .6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AU",
            })}
            d="m1793.5 590.2 1.2 5 4-2.4 1.4 2.7 2.3 2.5-1.1 2.9.2 5.5.2 3.2 1.3.8.4 5.5-1.2 3.3.8 4.3 5.4 3.4 3.2 3 3.2 2.8-1.1 1.6 2.3 4 .5 7 2.6-1.4 1.5 2.7 1.6-.9-.7 6.8 2.9 3.9 1.9 2.4 2.8 5.2v5.2l-1 3.7-1.8 3.9.7 5.5-2.5 5.7-2.1 3-3.8 5.7-1.5 3.7-3.1 4.6-5 5.8-5.5 3.2-4.4 4.9-3.3 3.2-4.4 5.5-3.7 3.2-3.9 4.8-3.1 4.4-.8 2.1-4.3 2.2-6.1.2-6.3 2.7-3.8 2.4-4.8 2.8-2.7-2.9-2.6-1.1 2.6-3.3-3.5 1.2-7.2 4.6-3.6-1.7-2.4-1-2.8-.5-4.1-1.8-1.3-4 1.5-4.8.4-3.3-1.4-2.6-4.7-.7 3.2-3.2.9-4.7-4.7 4.4-5.3 1.2 4.5-3.5 2.5-3.7 3.5-3.2 1.6-4.7-6.8 5.4-4.3 2.2-4.3 5.1-3-2.6 1.7-3.4-1.4-4.7-1.8-2.4 1.6-1.5-5.3-3.9-3.8-.1-4-3.2-9.9.6-7.9 2.3-6.9 2.2-5-.4-7 3.3-5.3 1.4-2.3 3.4-3 2.6-4.7.2-3.6.5-4.2-1.1-4.2.7-3.8.3-4.5 3.4-1.5-.3-3.4 1.8-3.4 2-3.8-.2h-3.5l-4.1-4.1-2.4-1.2 1.5-3.7 2.9-.9 1.5-1.4.6-2.3 2.3-4.5.7-3.8-.7-6.5.2-3.7 1.4-3.6-.9-4.2.3-1.9-1.7-2.6.7-5-1.9-5.1-.1-2.7 1.8 2.8-.5-6 2.3 1.9 1.1 2.5.6-3.3-1.6-5.1-.1-2-.8-1.9 1.3-3.7 1.5-1.6 1.3-3.2.1-3.8 3.1-4.6-.4 4.9 3.1-4.4 4.9-2.2 3.2-2.7 4.7-2.4 2.6-.5 1.4.8 4.8-2.4 3.5-.7 1.1-1.4 1.5-.6 3.1.2 6.2-1.9 3.5-2.9 2-3.4 3.9-3.2.7-2.6.7-3.5 4.9-5.5 1.4 5.6 2.6-1.3-1.5-3 2.3-3.1 2.2 1.4 1.5-4.9 3.5-3.2 1.8-2.5 2.9-1.1.4-1.8 2.3.7.4-1.6 2.6-.9 2.8-.9 3.7 3 2.6 3.8h3.5l3.5.6-.7-3.5 3.5-5.1 2.7-1.7-.6-1.6 2.9-3.7 3.7-2.3 2.7.8 4.9-1.2.3-3.3-3.9-2.1 3.1-.9 3.6 1.6 2.7 2.6 4.5 1.6 1.7-.6 3.3 2 3.5-1.9 2 .6 1.5-1.3 2.2 3.2-2 3.5-2.5 2.6-1.9.2.3 2.5-2.2 3.2-2.5 3.2.2 1.8 3.8 3.6 4 2 2.5 2.2 3.3 3.8h1.6l2.6 1.7.5 2 4.9 2.1 4.1-2.2 1.8-3.4 1.7-2.9 1.3-3.5 2.6-5.1-.2-3.1.7-1.9-.1-3.6 1.4-4.9 1.3-1.3-.6-2.1 1.8-3.4 1.5-3.5.4-1.9 2.3-2.4 1.3 3.2-.1 4 1.3.8-.1 2.7 1.6 3.2-.1 3.7-.6 2.3Z"
          />
          <path
            d="m1070.6 190.8-.3.8.7 2.1-.2 2.6h-2.8l1.1 1.4-1.3 4-.9 1.1-4.4.1-2.4 1.5-4.2-.5-7.3-1.7-1.3-2.1-4.9 1.1-.5 1.2-3.1-.9-2.6-.2-2.3-1.2.7-1.5-.2-1.1 1.4-.3 2.7 1.7.6-1.7 4.4.3 3.5-1.1 2.4.2 1.7 1.3.4-1.1-1-4.1 1.7-.8 1.6-2.9 3.8 2.1 2.6-2.6 1.7-.5 4 1.9 2.3-.3 2.4 1.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AT",
            })}
            id="AT"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AZ",
            })}
            d="m1229 253.2-3.8-.9-3.2-2.9-1.2-2.5 1-.1 1.9 1.7h2.3l.2 1 2.8 3.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AZ",
            })}
            d="m1235.3 236.2 2.5-2.6 3.5 3.3 3.6 4.6 2.5.3 1.9 1.7-4.2.5.1 5-.4 2.2-1.7 1.5.8 3.1-1.3.4-3.9-3.4 1.2-3.1-1.9-1.9-1.9.5-5.3 4.7-.9-4.5-2.5-1-2.6-1.7 1.1-2.1-3.2-2.2.7-1.6-2.2-1.1-1.4-1.6 1.1-1.1 4.2 1.9 2.9.3.6-.7-3.3-3.5 1.2-.8 1.5.2 4.3 3.8 2.4.5.6-1.6Z"
          />
          <path
            d="m1154.9 530.4-.6.1v-.3l-2-6.1-.01-.06-.09-1.04-1.4-2.9 3.5.5 1.7-3.7 3.1.4.3 2.5 1.2 1.5v2.1l-1.4 1.3-2.3 3.4-2 2.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BI",
            })}
            id="BI"
          />
          <path
            d="m1016.5 177.1-.4 4.2-1.3.2-.4 3.5-4.4-2.9-2.5.5-3.5-2.9-2.4-2.5-2.2-.1-.8-2.2 3.9-1.2 3.6.5 4.5-1.3 3.1 2.7 2.8 1.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BE",
            })}
            id="BE"
          />
          <path
            d="m1006.7 427-.2 2.1 1.3 3.8-1.1 2.6.6 1.7-2.8 4-1.7 2-1.1 4 .2 4.1-.3 10.3-4.7.8-1.4-4.4.3-14.8-1.2-1.3-.2-3.2-2-2.2-1.7-1.9.7-3.4 2-.7 1.1-2.8 2.8-.6 1.2-1.9 1.9-1.9h2l4.3 3.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BJ",
            })}
            id="BJ"
          />
          <path
            d="m988.5 406-.5 3.1.8 2.9 3.1 4.2.2 3.1 6.5 1.5-.1 4.4-1.2 1.9-2.8.6-1.1 2.8-2 .7-4.9-.1-2.6-.5-1.8 1-2.5-.5-9.8.3-.2 3.7.8 4.8-3.9-1.6-2.6.2-2 1.6-2.5-1.3-1-2.2-2.5-1.4-.4-3.7 1.6-2.7-.2-2.2 4.5-5.3.9-4.4 1.5-1.6 2.7.9 2.4-1.3.8-1.7 4.3-2.8 1.1-2 5.3-2.7 3.1-.9 1.4 1.2h3.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BF",
            })}
            id="BF"
          />
          <path
            d="m1500.6 360.3.6 4.6-2.1-1 1.1 5.2-2.1-3.3-.8-3.3-1.5-3.1-2.8-3.7-5.2-.3.9 2.7-1.2 3.5-2.6-1.3-.6 1.2-1.7-.7-2.2-.6-1.6-5.3-2.6-4.8.3-3.9-3.7-1.7.9-2.3 3-2.4-4.6-3.4 1.2-4.4 4.9 2.8 2.7.3 1.2 4.5 5.4.9 5.1-.1 3.4 1.1-1.6 5.4-2.4.4-1.2 3.6 3.6 3.4.3-4.2h1.5l4.4 10.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BD",
            })}
            id="BD"
          />
          <path
            d="m1132.6 221.6-2.3 2.6-1.3 4.5 2.1 3.6-4.6-.8-5 2 .3 3.2-4.6.6-3.9-2.3-4 1.8-3.8-.2-.8-4.2-2.8-2.1.7-.8-.6-.8.6-2 1.8-2-2.8-2.7-.7-2.4 1.1-1.4 1.8 2.6 1.9-.4 4 .9 7.6.4 2.3-1.6 5.9-1.5 4 2.3 3.1.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BG",
            })}
            id="BG"
          />
          <path
            d="m1083 214.3 1.9-.1-1.1 2.8 2.7 2.5-.5 2.9-1.1.3-.9.6-1.6 1.5-.4 3.5-4.8-2.4-2.1-2.7-2.1-1.4-2.5-2.4-1.3-1.9-2.7-3 .8-2.6 2 1.5 1-1.4 2.3-.1 4.5 1.1 3.5-.1 2.4 1.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BA",
            })}
            id="BA"
          />
          <path
            d="m1141.6 162.7-3.9-.2-.8.6 1.5 2 2 4-4.1.3-1.3 1.4.3 3.1-2.1-.6-4.3.3-1.5-1.5-1.7 1.1-1.9-.9-3.9-.1-5.7-1.5-4.9-.5-3.8.2-2.4 1.6-2.3.3-.5-2.8-1.9-2.8 2.8-1.3-.4-2.4-1.7-2.3-.6-2.7h4.7l4.8-2.3.5-3.4 3.6-2-1-2.7 2.7-1 4.6-2.3 5.3 1.5.9 1.5 2.4-.7 4.8 1.4 1.1 2.9-.7 1.6 3.8 4 2.1 1.1v1.1l3.4 1.1 1.7 1.6-1.6 1.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BY",
            })}
            id="BY"
          />
          <path
            d="M487.8 399.8h-1.7l1.3-7.2.7-5.1.1-1 .7-.3.9.8 2.5-3.9 1.1-.1-.1 1h1l-.3 1.8-1.3 2.7.4 1-.9 2.3.3.6-1 3.3-1.3 1.7-1.1.2-1.3 2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BZ",
            })}
            id="BZ"
          />
          <path
            d="m662.5 631.4-.3-2-5.4-3.3-5.2-.1-9.6 1.9-2.1 5.6.2 3.5-1.5 7.7-1-1.4-6.4-.3-1.6 5.2-3.7-4.6-7.5-1.6-4 5.8-3.9.9-3.1-8.9-3.7-7.2 1.1-6.2-3.2-2.7-1.2-4.6-3.2-4.4 2.9-6.9-2.9-5.4 1.1-2.2-1.2-2.4 1.9-3.2-.3-5.4v-4.6l1.1-2.1-5.5-10.4 4.2.6 2.9-.2 1.1-1.9 4.8-2.6 2.9-2.4 7.3-1.1-.4 4.8.9 2.5-.3 4.3 6.5 5.7 6.4 1.1 2.3 2.4 3.9 1.3 2.5 1.8h3.5l3.4 1.9.5 3.7 1.2 1.9.3 2.7-1.7.1 2.8 7.5 10.7.3-.5 3.7.8 2.5 3.2 1.8 1.7 4-.6 5.1-1.3 2.8.8 3.6-1.6 1.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BO",
            })}
            id="BO"
          />
          <path
            d="m665.8 489.6 3.1.6.6-1.4-1-1.2.6-1.9 2.3.6 2.7-.7 3.2 1.4 2.5 1.3 1.7-1.7 1.3.2.8 1.8 2.7-.4 2.2-2.5 1.8-4.7 3.4-5.9 2-.3 1.3 3.6 3 11.2 3.1 1.1.1 4.4-4.3 5.3 1.7 1.9 10.1 1 .2 6.5 4.3-4.2 7.1 2.3 9.5 3.9 2.8 3.7-.9 3.6 6.6-2 11 3.4 8.5-.2 8.4 5.3 7.4 7.2 4.4 1.8 4.8.3 2.1 2 2 8.2 1.1 3.9-2.1 10.6-2.7 4.2-7.7 8.9-3.4 7.3-4 5.5-1.4.2-1.3 4.7.9 12-1.1 9.9-.3 4.2-1.6 2.6-.5 8.6-5.2 8.3-.5 6.7-4.3 2.7-1.1 3.9h-6l-8.5 2.4-3.7 2.9-6 1.9-6.1 5.1-4.1 6.4-.3 4.8 1.3 3.5-.3 6.5-.8 3.1-3.4 3.6-4.5 11.3-4 5-3.2 3.1-1.5 6.1-2.9 3.6-2.1-3.6 1.8-3.1-3.8-4.3-4.8-3.6-6.3-4.1-1.9.2-6.3-5-3.4.7 6-8.7 5.3-6.3 3.3-2.6 4.2-3.5-.4-5.1-3.2-3.8-2.6 1.3.7-3.7.3-3.8-.3-3.6-2.1-1.1-2 1-2.1-.3-.8-2.4-1.1-5.9-1.2-1.9-3.9-1.8-2.2 1.3-5.9-1.3-.4-8.7-2-3.5 1.6-1.4-.8-3.6 1.3-2.8.6-5.1-1.7-4-3.2-1.8-.8-2.5.5-3.7-10.7-.3-2.8-7.5 1.7-.1-.3-2.7-1.2-1.9-.5-3.7-3.4-1.9h-3.5l-2.5-1.8-3.9-1.3-2.3-2.4-6.4-1.1-6.5-5.7.3-4.3-.9-2.5.4-4.8-7.3 1.1-2.9 2.4-4.8 2.6-1.1 1.9-2.9.2-4.2-.6-3.2 1.1-2.6-.7-.1-9.7-4.4 3.7-5-.1-2.3-3.5-3.8-.3 1-2.8-3.3-3.9-2.6-5.8 1.5-1.1-.2-2.8 3.4-1.8-.7-3.5 1.4-2.2.3-3 6.3-4.4 4.6-1.2.8-1 5.1.3 2.2-17.6.1-2.8-.9-3.6-2.6-2.4.1-4.7 3.2-1 1.1.7.2-2.5-3.3-.7v-4l11 .2 1.9-2.3 1.6 2.1 1 3.8 1.1-.8 3.1 3.4 4.4-.4 1.1-2 4.2-1.5 2.4-1.1.7-2.7 4.1-1.8-.3-1.4-4.8-.5-.7-4.1.3-4.3-2.5-1.6 1.1-.6 4.1.8 4.5 1.6 1.7-1.5 4.1-1 6.4-2.4 2.1-2.5-.7-1.8 3-.2 1.2 1.4-.8 2.9 2 .9 1.2 3-1.6 2.3-1 5.4 1.4 3.3.3 3 3.5 3 2.8.3.6-1.3 1.8-.3 2.6-1.1 1.8-1.7 3.2.6 1.3-.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BR",
            })}
            id="BR"
          />
          <path
            d="m1633.1 472.8 2.2-2.4 4.6-3.6-.1 3.2-.1 4.1-2.7-.2-1.1 2.2-2.8-3.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BN",
            })}
            id="BN"
          />
          <path
            d="m1488.8 323.5 2.6 2.1.5 3.9-4.5.2-4.7-.4-3.2 1-5.5-2.5-.4-1.2 2.6-4.8 2.6-1.6 4.3 1.4 2.9.2 2.8 1.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BT",
            })}
            id="BT"
          />
          <path
            d="m1127.6 615.7 1.9 5.1 1.1 1.2 1.6 3.7 6.1 7 2.3.7-.1 2.3 1.5 4.1 4.3 1 3.4 2.9-8.1 4.7-5.2 4.8-2 4.3-1.8 2.4-3 .5-1.2 3.1-.6 2-3.6 1.4-4.5-.3-2.5-1.8-2.3-.7-2.8 1.4-1.5 3.1-2.7 1.9-2.8 2.9-4 .7-1.1-2.3.6-3.9-3-6.1-1.4-1 .6-18.7 5.5-.2.8-22.9 4.2-.2 8.7-2.3 2 2.7 3.7-2.5h1.7l3.2-1.5 1 .5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BW",
            })}
            id="BW"
          />
          <path
            d="m1121.3 446.5 3.9 2.5 3.1 2.6.1 2.1 3.9 3.3 2.4 2.8 1.4 3.8 4.3 2.6.9 2-1.8.7-3.7-.1-4.2-.7-2.1.5-.9 1.6-1.8.2-2.2-1.4-6.3 3.2-2.6-.6-.8.5-1.6 3.9-4.3-1.3-4.1-.6-3.6-2.4-4.7-2.2-3 2.1-2.2 3.2-.5 4.5-3.6-.3-3.9-1.1-3.3 3.4-3 6-.6-1.9-.3-2.9-2.6-2.1-2.1-3.3-.5-2.3-2.7-3.4.5-1.9-.6-2.7.4-5 1.4-1.1 2.8-6.5 4.6-.5 1-1.7 1 .2 1.4 1.4 7.1-2.4 2.4-2.5 2.9-2.3-.6-2.2 1.6-.6 5.5.4 5.2-3 4-7 2.8-2.6 3.6-1.1.7 2.7 3.3 4v2.7l-.8 2.6.4 2 1.9 1.9.5.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CF",
            })}
            id="CF"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m665.9 203.6 3.4.9 4.7-.2-3.3 2.6-2 .4-5.5-2.7-.6-2.1 2.5-1.9.8 3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m680.3 187.6-2.4.1-5.8-1.9-3.5-3 1.9-.5 5.9 1.6 4.2 2.6-.3 1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m372.4 191.3-3.1.9-6.3-2.8v-2.2l-2.9-2.2.3-1.8-4.3-1.1.6-3.4 1.5-1.4 4.1 1.3 2.4 1 4.1.6.2 2.2.4 2.9 3.2 2.6-.2 3.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m711.5 177.8-5 5.4 3.9-2.1 2.9 1.4-2.4 2.1 3.8 1.7 2.8-1.5 4.3 1.9-2.8 4.6 3.8-1.1-.3 3.3.5 3.9-3.6 5.6-2.4.2-2.9-1.2 2.5-5.1-1.2-.8-7.3 5.4-3-.2 4.4-3-4.4-1.5-5.5.4-9.6-.2-.2-1.8 3.8-2.3-1.7-1.6 5.4-3.8 8.2-9.9 4.2-3.5 5-2.1 2.1.2-1.5 1.7-3.8 3.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m351.5 156.4 1.5.8 5-.5-7.2 6.9.3 5h-1.9l-.7-2.8.5-2.9-.8-1.9 1.3-2.7 2-1.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m634.9 108.9-3.6 3-1.7-.5-.1-1.7.4-.4 2.8-1.7 1.7.1.5 1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m625.2 105.7-7.2 3.2-3-.2v-1.5l5-2.7 6 .1-.8 1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m622.1 88.9-.9 2.5 2.7-.9 1.5 1.5 3.5 2 3.8 1.7-1.4 2.7 3.5-.4 1.9 1.9-5 1.8-5.9-1.4-.8-2.6-6.3 3.1-8.2 2.9.7-3.3-6.3.5 5.7-2.8 3.6-4.5 5.1-5.1 2.8.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m667 80.6-4.9.3.7-2.7 3.8-3.1 4.3-.7 2.3 1.5-1.5 2.3-.9.8-3.8 1.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m592.5 69.9-4.1 1.9-4.2-1.6-3.9.5-3.4-2.4 5-1.7 4.9-2.3 3 1.5 1.6 1 .4 1 .7 2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m645.5 212.5-2.2-3.6 2.9-8.5-1.6-1.8-3.7 1-1.1-1.6-5.5 4.7-3.2 4.9-2.8 2.9-2.5 1-1.7.3-1.1 1.5h-9.3l-7.8.1-2.7 1.1-6.8 4.4v-.1l-.9-.4-2 .9-1.9 1.3-1.8-1.1-4.7.8-3.9.9-1.9.8-2.3 2.1 1.8.7 1.7-.4h.3l-.3 1.9-4.8.7-2.8.8-1.7 1-2.6-.6-1.6.3-2.9 1.8-4.6 2-2.7-.4 2-2.2 3.7-3.5 4.1-2.1 1.1-1.8.9-3 3.8-3.5.9-4 1.1 3.9 3.8.9 2.4-2.1-1.4-4.8-.9-2-4-1.2-3.8-.7h-3.9l-3.4-.8-.4-1.4-1.4.9-1.2-.2 1.9-2.1-1.8-.8 1.9-2.4-1.2-1.8 1.7-1.8-5.2-.9-.1-3.6-.8-.8-3.3-.2-4.1-1.2-1.5.8-1.8 1.5-3.3 1-3.1 2.5-5.4-1.7-4.4.8-3.9-1.9-4.6-1-3.3-.4-1-1 .9-3.4h-1.7l-1.3 2.4H377l-5.4-6.1-1.6-2.7-7-2.6 1.3-5.5 3.6-3.7-4.1-2.7 3.1-4.9-2.1-4.4 2.5-3.2 5.1-2.9 3.2-3.8-4.6-3.8 1.4-6.9 1.1-4.2-1.6-2.7-.8-2.4.6-3.1-6.5 1.9-7.6 3.3-.3-3.8-.5-2.6-2.8-1.6-4.2-.2L385.4 87 410 66.6l6 1.3 3.3 2.6 3.7.5 6.3-2.2 7-1.7 5.3.6 8.9-2.3 8.2-1.3.2 2.2 4.5-1.3 3.9-2.5 2.1.6 1.4 4.8 9.5-3.7-3.9 4.1 6-.9 3.2-1.5 4.6.3 3.9 2.2 7.5 2 4.7.9 4.4-.3 2.9 2.8-8.5 2.7 6.4 1.1 11.9-.6 4.4-1 1.4 3.3 7.1-2.7-2.1-2.4 4.5-1.8 5.2-.3 3.9-.5 2.1 1.3 1.5 2.9 5-.4 5.3 2.5 7.2-.9 6 .1 2.4-3.4 4.5-.9 4.9 1.8-4.3 5.2 6.2-4.4 3.2.2 6.4-5.5-1.6-3.3-2.9-2.2 5.5-5.9 8.2-3.8 4.5.9 2 2.3.4 6-5.8 2.6 6.7 1.1-4.4 5.5 8.9-4.2 2.2 3.5-4.3 4 1.3 3.7 7.3-3.9 6.5-4.8 4.7-5.9 5.5.4 5.4.8 3.6 2.7-1.7 2.7-5.1 2.9.9 2.9-2.4 2.7-10.9 3.9-6.5.9-3.2-1.7-3.3 2.8-7.4 4.7-3 2.5-7.7 3.8-6.5.4-5.1 2.4-2.9 3.8-5.7.7-8.7 4.7-9.4 6.5-5 4.6-4.9 6.9 6 1-1.5 5.5-.8 4.6 7.3-1.2 7 2.6 3.3 2.3 1.7 2.8 4.9 1.7 3.6 2.5 7.6.4 4.8.6-3.6 5.2-1.7 6.1.1 6.9 4.4 5.9 4.7-2 5.6-6.4 2.3-9.6-1.7-3.2 9-2.9 7.5-4.2 4.8-4.2 1.7-4-.4-5.1-3.2-4.5 8.9-6.2 1-5.3 3.9-9 3.8-1.4 6.7 1.6 4.2.6 4.5-1.6 3.1 2 3.6 3.4.2 2.2 7.7.5-2.6 4.9-2.3 7.4 3.8 1 1.6 3.5 8.2-3.3 7.5-6.6 4.2-2.7 1.1 5.3 2.6 7.5 2 7.2-3.4 3.8 4.8 3.4 2.9 3.4 6.9 1.6 2.4 1.9v5.2l3.4.8 1.1 2.3-2 6.9-4.3 2.3-4.2 2.2-8.8 2.2-7.9 5-8.6 1.1-10.1-1.4h-7.3l-5.3.4-5.7 4.5-7.4 2.8-10.1 8.2-7.9 5.8 4.7-1 10.9-8.3 12.3-5.2 7.6-.6 3.3 3.1-6.1 4.2-.6 6.7.1 4.8 5.6 3.1 8.6-.9 7.2-7.1-1 4.6 2.5 2.3-7.4 4.1-12.4 3.8-5.8 2.5-7.2 4.6-3.7-.5 1.5-5.3 10.4-5.3-8.1.2-5.9.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m539 48.7-4.7 2.4 10.5-1.5 2.6 2.6 7.3-2.7 1.8 1.7-2.2 5.1 4.3-2.1 2.8-5.3 4.3-.8 3 .8 2.2 2.1-2.7 5.1-2.4 3.7 4.2 2.6 5 2.6-2.6 2.3-7.1.5.8 2-3.2 2-6.7-.8-5.7-1.5-5.1.3-9.5 1.9-11.3.8-7.9.5.3-2.6-4.1-1.4-4.3.6-.6-4.3 3.3-.6 7.3-.9 5.5.3 6.2-1-6.5-1.2-9.1.4-5.7-.1v-1.9l11.7-2.2-6.3.1-5.4-1.4 7.8-3.9 5.2-2.1 14.2-3.1 2.8 1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m578.5 47.2-7 3.4-2.3-3.6 2.1-.8 5.5-.2 1.7 1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m687.1 48.8-.7 1.4-4.1-.1-4.1-.1-4.9.7-.9-.4-2.1-2.7 1.7-1.8 2.2-.4 8.4.6 4.5 2.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m647.3 48.5.3 3.2 7.2-4.1 11.7-2.1 2.3 5.3-3.2 3.4 9-1.5 5.3-2.1 6.8 2.6 3.7 2.5-1.1 2.3 8.2-1.2 1.9 3.4 8.4 2.1 2.2 2.1.9 5.1-9.1 2.5 7.7 3.6 5.9 1.2 3.3 5 6.5.4-3.3 3.9-10.9 6.5-4-2.4-3.8-5.4-5.9.7-2.3 3.3 2.7 3.2 4.5 2.6 1 1.5-.1 5.7-3.6 4.1-4.7-1.6-8.6-4.5 3.6 4.9 2.8 3.5-.3 2-10.9-2.3-7.6-3.4-3.8-2.7 2.4-1.7-4.8-2.9-4.7-2.7-.9 1.6-13.1.9-2.4-1.9 5.4-4.2 8.1-.1 9.3-.7-.2-2 3.1-2.8 8.8-5.4.4-2.5-.5-1.8-4.7-2.7-7.1-1.8 3.5-1.4-2-3.4-3.4-.3-1.9-1.8-3.3 1.6-7.9.7-14-1.2-7.4-1.6-5.9-.8-1.9-1.9 6.3-2.4h-5.7l3.3-5.3 7.1-4.6 6-2.1 11.2-1.4-5.8 3.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m596.9 45 3.6 1.1 7.6-.7-.5 1.5-6.1 2.5 3.8 2.2-5.2 4.7-8.4 2-3.4-.4-.9-2-5.9-4 1.7-1.7 7.4.6-.9-3.3 7.2-2.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m619.5 50.5-7.8 3.9-4.4-.2 1.8-4.6 2.6-2.5 4.2-2.2 5.2-1.4 7.9.2 6.2 1.2-10.1 4.6-5.6 1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m503.7 57.7-13.5 2.6.6-2.3-6-2.8 4.4-2.2 7.5-3.8 7.6-3.4.4-3.1 14-.8 4.2 1.1 9.5.3 1.9 1.4 1.6 2.2-6.5 1.3-13.9 3.6-9.2 3.7-2.6 2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m628.9 39.3-4.1 1.9-5.2-.4-3.2-1.3 4.5-2.2 6.9-1.4 1.4 1.8-.3 1.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m620.1 30.6.2 2.3-2.8 2.5-5.8 3.8-6.9.5-3.2-.8L605 36l-6.6.3 4.3-3.8 3.8.2 7.7-1.7 4.9.3 1-.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m580.7 33.2-.7 1.7 4.4-.8 3.6.2-2.3 2.5-5.1 2.3-13.9.8-12.3 2.2-6 .1 1.5-1.6 10.7-2.3-17.9.6-4.2-.9 11.7-4.8 5.4-1.4 8.3 1.7 2.9 2.9 6.1.4.7-4.7 5.8-1.8 3.1.5-1.8 2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m636.4 28.8 2.3 1.6h7.4l1.4 1.6-2.8 1.8 3.1 1.1 1.2 1.2 4.9.2 5.1.4 7.1-1 8.1-.5 5.8.4 2.3 1.9-1 2-3.6 1.4L671 42l-4.3-.7-11.8.8-8 .1-5.6-.6-8.6-1.6 1.6-2.8 2.1-2.4-1.4-2.2-7-.6-2.6-1.5 3.8-2 7.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m560.7 26.2-5.8 3.7-5.3 1.7-3.8.2-9.9 2.1-7.1.8-3.6-1.1 11.7-3.7 12.2-3.1 5.5.1 6.1-.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m641.9 26.8-1.8.1-6.6-.3.7-1.3 7.2.1 1.6.8-1.1.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m583.1 25.9-8.8 1.4-3.3-1.5 5.1-1.5 6-.5 4.1.7-3.1 1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m590.9 21.7-5.7.9h-6l1-.7 5.7-1.3 1.7.2 3.3.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m637.7 24.2-6.6 1-1.6-1.1.6-1.7 2.2-1.9 4.4.2 1.7.3 2.3 1.6-3 1.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m623.9 23-1.1 1.9-5.3-.5-4-1.5-7.8-.2 5.3-1.3-2.8-1.1 2.2-1.8 6.1.6 7.5 1.7-.1 2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m678 16.9 2.7 1.5-6.5 1.3-10.6 3.5-6.8.3-6.8-.6-1.6-1.9 2.1-1.6 4.3-1.2h-6.6l-2-1.5.4-1.9 4.9-1.9 4.1-1.3 4-.3-.3-1 8.3-.2 1.6 2.2 4.7.9 4.8.9-.7 2.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CA",
            })}
            d="m757.2 2.9 8.7.3 6.7.5 5.2 1-1.1 1-9.8 1.7-9 .8-4 .9h7.5l-10.5 2.5-6.8 1.2-9.3 3.5-8.1.7-3.1 1-11.3.4 4.4.6-3.3.8.7 2.3-5 1.6-6.9 1.3-3.5 1.8-6.6 1.5-.5 1.1 6.5-.2-1.1 1.2-12.7 2.9-8.5-1.4-11.7.8-5-.6-6.8-.3 2.1-2.3 8-1.1 2-3.4 2.6-.3 7.5 2-1.7-3-4.9-.9 5-1.8 7.6-1.1 2.8-1.6-3-1.7 1.1-2.2 9.4.1 2.2.5 7.3-1.6-7.3-.5-12.6.3-4.4-1.4-.8-1.7-2.5-1.2 1.1-1.3 6-.8 4.2-.1 7.4-.6 6.8-1.5 3.9.2 2.4 1.1 5-2 5.2-.6 6.5-.4 10.4-.2 1.3.4 10.3-.6 7 .2 7 .2Z"
          />
          <path
            d="m1034.4 197.5.2 1.1-.7 1.5 2.3 1.2 2.6.2-.3 2.5-2.1 1.1-3.8-.8-1 2.5-2.4.2-.9-1-2.7 2.2-2.5.3-2.2-1.4-1.8-2.7-2.4 1v-2.9l3.6-3.5-.2-1.6 2.3.6 1.3-1.1h4.2l1-1.3 5.5 1.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CH",
            })}
            id="CH"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CN",
            })}
            d="m1602.2 381.9-4.3 3.1-4.9-2-1-5.5 2.2-2.9 5.8-1.8 3.3.1 1.6 2.5-2 2.8-.7 3.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CN",
            })}
            d="m1625.6 185.5 9 4.5 6 5.8h7.6l2.6-2.4 6.9-1.9 1.3 5.7-.3 2.3 2.8 6.8.6 6.2-6.9-1.1-2.9 2.2 4.7 5.4 3.9 7.5-2.5.1 1.9 3.3-5.5-3.8v3.6l-6.4 2.7 2.8 3.4-4.6-.3-3.6-2-1.1 4.6-3.9 3.4-2.1 4.1-6.3 1.8-2.4 3-4.8 1.8 1.3-3-2.3-2.5 2-4.3-4.5-3.3-3.4 2.2-3.6 4.5-1.3 4.1-5 .3-1.3 3 4.8 4.3 4.8 1.1 1.4 2.8 5.1 1.9 3.8-4.6 5.9 2.5 3.5.2 2.3 3.3-6.7 1.8-1 3.5-3.8 3.2-.9 4.5 7.1 3.5 4.6 6.3 5.5 5.9 5.5 4.9 1.6 4.8-2.8 1.8 2.4 3.4 3.9 2 .8 5.2.1 5.1-2.8.6-2.1 6.9-2.3 8.5-3.4 7.6-6.4 5.9-6.6 5.5-6.1.7-2.9 2.8-2.3-2-2.5 3.1-7.2 3.3-5.8.9-.7 6.8-3.1.4-2.2-4.7.9-2.4-7.8-2.1-2.4 1.1-5.9-1.7-3.1-2.6.3-3.7-5.3-1.2-3.1-2.4-4.1 3.4-5.3.8-4.4-.1-2.7 1.6-2.7.9 2 7.4-3-.2-.8-1.5-.5-2.7-3.8 1.9-2.6-1.2-4.5-2.4.8-5.3-3.7-1.3-2.4-5.9-5.6 1.1-.7-7.6 4.2-5.4-.9-5.3-1.3-4.9-2.7-1.5-2.7-3.8-3.1.5-6.1-1 1.2-2.7-3.6-4-3.2 2.7-4.9-1.5-5.4 4-3.9 4.8-4.2.8-2.8-1.7-2.9-.2-4.3-1.4-2.6 1.6-2.6 4.8-1.5-5.1-3.1 1.4-6.5-.7-6.5-1.4-5-2.9-4.5-1.2-2.5-3.1-3.3-.9-6.4-4.2-4.8-2-1.9 1.5-8.6-4.5-6.2-4-3.2-7.1 4.1.9-.6-3.3-3-3.3-.8-5.2-7.7-7.6-9.5-2.5-2.9-5-4.7-3-1.5-1.8-1.8-3.6-.5-2.5-3.7-1.5-1.5.7-3.1-6 1.1-1.4-1.2-1.5 4.1-3 3.2-1.3 5.8.9.6-4.1 6.4-.7 1-2.6 6.9-3.4.2-1.4-1.7-3.7 2.9-1.6-8.8-11 9.1-2.5 2-1.4-1-11.3 10.8 2.1 1.6-2.9-2.5-6.2 3.8-.6 1.9-4.2 1.7-.5 3.3 4.4 5.7 3.3 8.2 2.3 5.8 5.1 1.4 7.3 3 2.8 6.5 1.1 7.2.8 8 4 3.4.7 5 5.8 4.7 3.8 5.6-.2 11.3 1.5 6.4-.9 5.6.9 9.4 3.9h6.2l3.3 1.9 4.4-3.4 7.2-2.2 7.6-.2 4.9-2.2 2-3.4 2.4-2.2-1.9-2.1-2.9-2.4.5-4.1 3.2.6 5.9 1.3 3.2-3.4 6.4-2.4 1.3-4.2 2.5-1.8 6.8-.8 4.4.7-.8-2.2-7.2-4.4-5.2-2-2.5 2.3-5.5-1-2.3.8-2.8-2.5-.3-6.3-.6-4.7 7.4 2.4 4.4-3.9-1.9-2.8-.2-6.5 1.3-2-2.5-3.4-3.7-1.4 1.7-3.1 5.1-1.1 6.2-.2 8.6 1.9 6 2.2 7.7 6.2 3.8 2.7 4.5 3.8 6.2 6 10 2Z"
          />
          <path
            d="m955.9 435.2 2.5 1.4 1 2.2 2.5 1.3 2-1.6 2.6-.2 3.9 1.6 1.5 9.2-2.4 5.3-1.5 7.3 2.4 5.5-.2 2.6h-2.6l-3.9-1.2H960l-6.7 1.2-3.9 1.8-5.6 2.4-1.1-.2.4-5.3.6-.8-.2-2.5-2.4-2.7-1.8-.4-1.6-1.8 1.2-2.9-.5-3.1.2-1.8h.9l.4-2.8-.4-1.3.5-.9 2.1-.7-1.4-5.2-1.3-2.6.5-2.2 1.1-.5.8-.6 1.5 1h4.4l1-1.8 1 .1 1.6-.7.9 2.7 1.3-.8 2.4-1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CI",
            })}
            id="CI"
          />
          <path
            d="m1072.8 454.2-2.8 6.5-1.4 1.1-.4 5 .6 2.7-.5 1.9 2.7 3.4.5 2.3 2.1 3.3 2.6 2.1.3 2.9.6 1.9-.4 3.4-4.5-1.5-4.6-1.7-7.1-.2-.7-.4-3.4.8-3.4-.8-2.7.4-9.3-.1.9-5.1-2.3-4.3-2.6-1-1.1-2.9-1.5-.9.1-1.8 1.4-4.6 2.7-6.2h1.6l3.4-3.8 2.1-.1 3.2 2.7 3.9-2.2.5-2.7 1.3-2.6.8-3.2 3-2.6 1.1-4.5 1.2-1.5.8-3.3 1.4-4.1 4.7-5 .3-2.1.6-1.2-2.3-2.5.2-2.1 1.5-.3 2.3 4.1.5 4.2-.2 4.3 3.2 5.8h-3.2l-1.6.4-2.6-.6-1.2 3 3.4 3.8 2.5 1.1.8 2.6 1.8 4.4-.8 1.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CM",
            })}
            id="CM"
          />
          <path
            d="m1141.3 468.2 3.5 5.3 2.6.8 1.5-1.1 2.6.4 3.1-1.3 1.4 2.7 5.1 4.3-.3 7.5 2.3.9-1.9 2.2-2.1 1.8-2.2 3.3-1.2 3-.3 5.1-1.3 2.5-.1 4.8-1.6 1.8-.2 3.8-.8.5-.6 3.6 1.4 2.9.1 1-1.2 10.3 1.5 3.6-1 2.7 1.8 4.6 3.4 3.5.7 3.5 1.6 1.7-.3 1.1-.9-.3-7.7 1.1-1.5.8-1.7 4.1 1.2 2.8-1.1 7.6-.9 6.4 1.5 1.2 3.9 2.5 1.6-1.2.2 6.9h-4.3l-2.2-3.5-2-2.8-4.3-.9-1.2-3.3-3.5 2-4.4-.9-1.9-2.9-3.5-.6-2.7.1-.3-2-1.9-.1-2.6-.4-3.5 1-2.4-.2-1.4.6.4-7.6-1.8-2.4-.4-4 .9-3.9-1.1-2.4-.1-4.1-6.8.1.5-2.3h-2.9l-.3 1.1-3.5.3-1.5 3.7-.9 1.6-3.1-.9-1.8.9-3.8.5-2.1-3.3-1.3-2.1-1.6-3.9-1.3-4.7-16.7-.1-2 .7-1.7-.1-2.3.9-.8-2 1.4-.7.2-2.8 1-1.6 2-1.4 1.5.7 2-2.5 3.1.1.3 1.8 2.1 1.1 3.4-4 3.3-3.1 1.4-2.1-.1-5.3 2.5-6.2 2.6-3.3 3.7-3.1.7-2 .1-2.4.9-2.2-.3-3.7.7-5.7 1.1-4 1.7-3.4.3-3.9.5-4.5 2.2-3.2 3-2.1 4.7 2.2 3.6 2.4 4.1.6 4.3 1.3 1.6-3.9.8-.5 2.6.6 6.3-3.2 2.2 1.4 1.8-.2.9-1.6 2.1-.5 4.2.7 3.7.1 1.8-.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CD",
            })}
            id="CD"
          />
          <path
            d="m1090.9 479.3-.3 3.9-1.7 3.4-1.1 4-.7 5.7.3 3.7-.9 2.2-.1 2.4-.7 2-3.7 3.1-2.6 3.3-2.5 6.2.1 5.3-1.4 2.1-3.3 3.1-3.4 4-2.1-1.1-.3-1.8-3.1-.1-2 2.5-1.5-.7-2.1-2.2-1.7 1.1-2.3 2.8-4.6-6.8 4.3-3.6-2.1-4.2 2-1.6 3.8-.8.4-2.9 3.1 3.1 5 .3 1.7-3 .7-4.3-.6-5-2.7-3.8 2.5-7.5-1.4-1.2-4.2.5-1.6-3.3.4-2.8 7.1.2 4.6 1.7 4.5 1.5.4-3.4 3-6 3.3-3.4 3.9 1.1 3.6.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CG",
            })}
            id="CG"
          />
          <path
            d="m584.4 426.2-3.7 1.1-1.6 3.2-2.3 1.8-1.8 2.4-.9 4.6-1.8 3.8 2.9.4.6 2.9 1.2 1.5.3 2.5-.7 2.4.1 1.4 1.4.5 1.2 2.2 7.3-.6 3.3.8 3.8 5.6 2.3-.7 4.1.3 3.2-.7 2 1.1-1.2 3.4-1.3 2.2-.6 4.6 1.1 4.3 1.5 1.9.2 1.4-2.9 3.2 2 1.4 1.5 2.3 1.6 6.4-1.1.8-1-3.8-1.6-2.1-1.9 2.3-11-.2v4l3.3.7-.2 2.5-1.1-.7-3.2 1-.1 4.7 2.6 2.4.9 3.6-.1 2.8-2.2 17.6-2.9-3.4-1.7-.1 3.5-6.6-4.4-3-3.4.6-2.1-1.1-3.1 1.7-4.2-.9-3.5-6.7-2.6-1.6-1.8-3.1-3.8-3-1.5.6-2.4-1.5-2.8-2.1-1.6 1-4.8-.9-1.4-2.8-1.1.1-5.6-3.6-.7-2 2.1-.5-.2-3.2 1.4-2.4 2.8-.4 2.5-4 2.2-3.4-2-1.5 1.2-3.7-1.1-5.9 1.3-1.7-.7-5.4-2.2-3.5.9-3.1 1.8.5 1.1-1.9-1.1-3.8.7-.9 2.9.2 4.5-4.5 2.4-.7.1-2.1 1.4-5.5 3.4-2.9 3.5-.2.6-1.3 4.4.5 4.6-3.2 2.3-1.4 2.9-3.1 2 .4 1.3 1.7-1.2 2.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CO",
            })}
            id="CO"
          />
          <path
            d="m514.6 431.6 1.2 3.5 2 2.6 2.5 2.7-2.2.6-.1 2.6 1.1.9-.9.8.2 1.1-.6 1.3-.3 1.3-3-1.4-1.1-1.4.7-1.1-.1-1.4-1.5-1.5-2.2-1.3-1.8-.8-.3-1.9-1.4-1.1.2 1.8-1.2 1.6-1.2-1.8-1.7-.7-.7-1.2.1-2 .9-2-1.5-.9 1.4-1.3.9-.8 3.6 1.7 1.3-.8 1.8.5.8 1.3 1.7.5 1.4-1.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CR",
            })}
            id="CR"
          />
          <path
            d="m544.8 355.7 1.9 2.3 5.2-.7 1.8 1.5 4.2 4 3.2 2.9 1.8-.1 3.2 1.3-.6 1.8 4 .3 3.9 2.6-.8 1.5-3.8.8-3.8.3-3.7-.5-8.1.6 4.2-3.5-2.1-1.7-3.6-.4-1.7-1.9-.8-3.6-3.2.2-5-1.7-1.5-1.4-7.1-1-1.8-1.2 2.3-1.6-5.4-.3-4.4 3.3-2.3.1-1 1.6-2.8.7-2.3-.7 3.2-1.9 1.5-2.4 2.7-1.4 3-1.2 4.3-.6 1.4-.8 4.7.5 4.4.1 4.9 2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CU",
            })}
            id="CU"
          />
          <path
            d="m1059.7 175.2 2.5 2 3.7.5-.2 1.7 2.8 1.3.6-1.6 3.4.7.7 2 3.7.3 2.6 3.1h-1.5l-.7 1.1-1.1.3-.2 1.4-.9.3-.1.6-1.6.6-2.2-.1-.6 1.4-2.4-1.2-2.3.3-4-1.9-1.7.5-2.6 2.6-3.8-2.1-3-2.6-2.6-1.5-.7-2.7-1-1.8 3.4-1.3 1.7-1.6 3.5-1.2 1.1-1.2 1.3.7 2.2-.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CZ",
            })}
            id="CZ"
          />
          <path
            d="m1053.9 158.9 1.4 3.1-1.2 1.7 1.9 2.1 1.5 3.3-.2 2.2 2.4 3.9-2.2.6-1.3-.7-1.1 1.2-3.5 1.2-1.7 1.6-3.4 1.3 1 1.8.7 2.7 2.6 1.5 3 2.6-1.6 2.9-1.7.8 1 4.1-.4 1.1-1.7-1.3-2.4-.2-3.5 1.1-4.4-.3-.6 1.7-2.7-1.7-1.4.3-5.5-1.9-1 1.3h-4.2l.4-4.5 2.4-4.2-7.2-1.2-2.4-1.6.2-2.7-1-1.4.4-4.2-1.1-6.5h2.9l1.2-2.3.9-5.6-.9-2.1.8-1.3 4-.3 1 1.3 3.1-3-1.3-2.3-.4-3.4 3.7.8 2.9-.9.3 2.3 4.9 1.4.1 2.2 4.7-1.2 2.6-1.6 5.6 2.4 2.4 1.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "DE",
            })}
            id="DE"
          />
          <path
            d="m1229.5 428.2-1.9 3.5-1.3-1.2-1.3.5-3.2-.1-.2-2-.5-1.8 1.8-3 1.9-2.8 2.4.6 1.7-1.6 1.4 2-.1 2.6-3.1 1.6 2.4 1.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "DJ",
            })}
            id="DJ"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "DK",
            })}
            d="m1046.1 147.7-2.4 4.9-5.2-3.5-.9-2.5 6.8-2 1.7 3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "DK",
            })}
            d="m1033.3 151.5-2.9.9-3.7-.8-2.1-3.4-.4-6.1.6-1.7 1.3-1.8 4-.3 1.6-1.7 3.6-1.7v3.1l-1.2 2 .7 1.6 2.6.9-1 2.3-1.4-.6-3.1 4.3 1.4 3Z"
          />
          <path
            d="m585.7 386 .3-1.8-1.3-1.9 1.5-1.1.7-2.5-.1-3.4.8-1.1h4.3l3.2 1.6 1.5-.1.7 2.3 3.1-.2-.4 1.9 2.5.3 2.5 2.3-2.3 2.6-2.6-1.4-2.6.3-1.8-.3-1.1 1.2-2.2.4-.7-1.6-1.9.9-2.7 4.4-1.3-1-.1-1.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "DO",
            })}
            id="DO"
          />
          <path
            d="m1031 264.6-1 3.3 1 6.1-1.1 5.3-3.2 3.6.6 4.8 4.5 3.9.1 1.5 3.4 2.6 2.6 11.5 1.9 5.7.4 3-.8 5.2.4 3-.6 3.5.6 4-2.2 2.7 3.4 4.7.2 2.7 2.1 3.6 2.5-1.2 4.5 3 2.5 4-18.8 12.3-16 12.6-7.8 2.8-6.2.7-.1-4.1-2.6-1.1-3.5-1.8-1.3-3-18.7-14-18.6-14-20.5-15.6.1-1.2.1-.4.1-7.6 8.9-4.8 5.4-1 4.5-1.7 2.1-3.2 6.4-2.5.3-4.8 3.1-.6 2.5-2.3 7.1-1.1 1-2.5-1.4-1.4-1.9-6.8-.3-3.9-1.9-4.1 5.1-3.5 5.8-1.1 3.3-2.6 5.1-2 9-1.1 8.8-.5 2.7.9 4.9-2.5 5.7-.1 2.2 1.5 3.6-.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "DZ",
            })}
            id="DZ"
          />
          <path
            d="m559 502.8.8 4.9-1.7 4.1-6.1 6.8-6.7 2.5-3.4 5.6-.9 4.3-3.1 2.7-2.5-3.3-2.3-.7-2.3.5-.3-2.3 1.6-1.5-.7-2.7 2.9-4.8-1.3-2.8-2.1 3-3.5-2.9 1.1-1.8-1-5.8 2-1 1-4 2.1-4.1-.3-2.6 3.1-1.4 3.9-2.5 5.6 3.6 1.1-.1 1.4 2.8 4.8.9 1.6-1 2.8 2.1 2.4 1.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "EC",
            })}
            id="EC"
          />
          <path
            d="m1172.1 301.4 3.9 9.4.7 1.6-1.3 2.6-.7 4.8-1.2 3.4-1.2 1.1-2-2.1-2.7-2.8-4.7-9.2-.5.6 2.8 6.7 3.9 6.5 4.9 10 2.3 3.5 2 3.6 5.4 7.1-1 1.1.4 4.2 6.8 5.8 1.1 1.3h-65.9l-1-23.7-1.3-22.8-2-5.2 1.1-3.9-1-2.8 1.7-3.1 7.2-.1 5.4 1.7 5.5 1.9 2.6 1 4-2 2.1-1.8 4.7-.6 3.9.8 1.8 3.2 1.1-2.1 4.4 1.5 4.3.4 2.5-1.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "EG",
            })}
            id="EG"
          />
          <path
            d="m1228.9 420.3-1.7 1.6-2.4-.6-2-2.1-2.5-3.7-2.6-2.1-1.5-2.2-5-2.6-3.9-.1-1.4-1.3-3.2 1.5-3.6-2.9-1.5 4.8-6.6-1.4-.7-2.5 2-9.5.3-4.2 1.7-2 4-1.1 2.7-3.6 3.6 7.4 1.9 5.9 3.2 3.1 8 6.1 3.3 3.6 3.2 3.8 1.8 2.2 2.9 1.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ER",
            })}
            id="ER"
          />
          <path
            d="m1113.7 124.6.9 1-2.6 3.4 2.4 5.6-1.6 1.9-3.8-.1-4.4-2.2-2.1-.7-3.8 1-.1-3.5-1.5.8-3.3-2.1-1-3.4 5.5-1.7 5.6-.8 5.1.9 4.7-.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "EE",
            })}
            id="EE"
          />
          <path
            d="m1207.3 408.5 3.9.1 5 2.6 1.5 2.2 2.6 2.1 2.5 3.7 2 2.1-1.9 2.8-1.8 3 .5 1.8.2 2 3.2.1 1.3-.5 1.3 1.2-1.2 2.2 2.2 3.6 2.2 3.1 2.2 2.3 18.7 7.6 4.8-.1-15.6 19.3-7.3.3-5 4.5-3.6.1-1.5 2.1h-3.9l-2.3-2.2-5.2 2.7-1.6 2.7-3.8-.6-1.3-.7-1.3.2-1.8-.1-7.2-5.4h-4l-1.9-2.1-.1-3.6-2.9-1.1-3.5-7-2.6-1.5-1-2.6-3-3.1-3.5-.5 1.9-3.6 3-.2.8-1.9-.2-5v-.8l1.5-6.7 2.6-1.8.5-2.6 2.3-5 3.3-3.1 2-6.4.7-5.5 6.6 1.4 1.5-4.8 3.6 2.9 3.2-1.5 1.4 1.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ET",
            })}
            id="ET"
          />
          <path
            d="m1104.1 70.1.4 3.8 7.3 3.7-2.9 4.2 6.5 6.3-1.7 4.8 4.9 4.2-.9 3.8 7.4 3.9-.9 2.9-3.4 3.4-8 7.4-8 .5-7.6 2.1-7.1 1.3-3.2-3.2-4.7-1.9.1-5.8-3-5.2 1.6-3.4 3.3-3.5 8.8-6.2 2.6-1.2-.9-2.4-6.5-2.6-1.8-2.2-1.8-8.5-7.2-3.7-6-2.7 2.2-1.4 5.1 2.8 5.3-.2 4.7 1.3 3.4-2.4 1.1-4 5.9-1.8 5.8 2.1-.8 3.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FI",
            })}
            id="FI"
          />
          <path
            d="m1060.5 487.3-.4 2.8 1.6 3.3 4.2-.5 1.4 1.2-2.5 7.5 2.7 3.8.6 5-.7 4.3-1.7 3-5-.3-3.1-3.1-.4 2.9-3.8.8-2 1.6 2.1 4.2-4.3 3.6-5.8-6.5-3.7-5.3-3.5-6.6.2-2.2 1.3-2 1.3-4.7 1.2-4.8 1.9-.3h8.2v-7.7l2.7-.4 3.4.8 3.4-.8.7.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GA",
            })}
            id="GA"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GB",
            })}
            d="m956.7 158.2-3.5-1.2-3 .1 1.2-3.3-.9-3.2 4-.3 4.9 3.8-2.7 4.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GB",
            })}
            d="m972.6 129.5-5.1 6.5 4.7-.8h5.1l-1.3 4.9-4.3 5.4 4.9.3.3.7 4.2 7.1 3.2 1 2.9 7 1.4 2.4 5.9 1.1-.6 4-2.4 1.8 1.9 3.2-4.4 3.2-6.5-.1-8.4 1.8-2.2-1.3-3.3 2.9-4.5-.7-3.6 2.4-2.5-1.2 7.3-6.5 4.4-1.4-7.6-1-1.3-2.5 5.1-1.9-2.5-3.3 1-4 7.1.6.8-3.6-3.1-3.7-.1-.1-5.7-1.1-1.1-1.6 1.8-2.7-1.5-1.7-2.6 2.9-.1-5.9-2.2-3 1.9-6.2 3.8-4.8 3.6.4 5.6-.5Z"
          />
          <path
            d="m1215.7 227.9 5.1 1.3 2.1 2.6 3.6 1.5-1.2.8 3.3 3.5-.6.7-2.9-.3-4.2-1.9-1.1 1.1-7 1-5.6-3.2-5.5.3.3-2.7-2.1-4.3-3.4-2.4-3-.7-2.2-1.9.4-.8 4.6 1.1 7.7 1 7.6 3.1 1.2 1.2 2.9-1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GE",
            })}
            id="GE"
          />
          <path
            d="m986.5 431.1-.4 2 2.3 3.3v4.7l.6 5 1.4 2.4-1.3 5.7.5 3.2 1.5 4.1 1.3 2.3-8.9 3.7-3.2 2.2-5.1 1.9-5-1.8.2-2.6-2.4-5.5 1.5-7.3 2.4-5.3-1.5-9.2-.8-4.8.2-3.7 9.8-.3 2.5.5 1.8-1 2.6.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GH",
            })}
            id="GH"
          />
          <path
            d="m921.5 421.9.3 2.4h.9l1.5-.9.9.2 1.6 1.7 2.4.5 1.5-1.4 1.9-.9 1.3-.9 1.1.2 1.3 1.4.6 1.8 2.3 2.7-1.1 1.6-.3 2.1 1.2-.6.7.7-.3 1.9 1.7 1.9-1.1.5-.5 2.2 1.3 2.6 1.4 5.2-2.1.7-.5.9.4 1.3-.4 2.8h-.9l-1.6-.2-1.1 2.6h-1.6l-1.1-1.4.4-2.6-2.4-3.9-1.4.7-1.3.2-1.5.3.1-2.3-.9-1.7.2-1.9-1.2-2.7-1.6-2.3h-4.5l-1.3 1.2-1.6.2-1 1.4-.6 1.7-3.1 2.9-2.4-3.8-2.2-2.5-1.4-.9-1.4-1.3-.6-2.8-.8-1.4-1.7-1.1 2.6-3.1 1.7.1 1.5-1 1.2-.1.9-.8-.4-2.1.6-.7.1-2.2 2.7.1 4.1 1.5 1.2-.1.4-.7 3.1.5.8-.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GN",
            })}
            id="GN"
          />
          <path
            d="m891.6 417.4.8-2.9 6.1-.1 1.3-1.6 1.8-.1 2.2 1.6h1.7l1.9-1 1.1 1.8-2.5 1.5-2.4-.2-2.4-1.3-2.1 1.5h-1l-1.4.9-5.1-.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GM",
            })}
            id="GM"
          />
          <path
            d="m909.2 421-.1 2.2-.6.7.4 2.1-.9.8-1.2.1-1.5 1-1.7-.1-2.6 3.1-2.9-2.6-2.4-.5-1.3-1.8.1-1-1.7-1.3-.4-1.4 3-1 1.9.2 1.5-.8 10.4.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GW",
            })}
            id="GW"
          />
          <path
            d="M1050.3 487.3v7.7h-8.2l-1.9.3-1.1-.9 1.9-7.2 9.3.1z"
            id="GQ"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GQ",
            })}
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GR",
            })}
            d="m1112.7 272.6 3.1 2.2 4.1-.4 4 .4v1.2l2.8-.8-.5 1.9-7.6.5-.1-1-6.6-1.3.8-2.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GR",
            })}
            d="m1121.9 239.9-3.2-.2-2.7-.6-6.2 1.6 4 3.6-2.5 1.1h-2.9l-3.1-3.3-.9 1.4 1.6 3.8 2.9 3-1.9 1.4 3.2 2.9 2.8 1.9.4 3.6-5-1.7 1.8 3.3-3.3.6 2.5 5.7-3.5.1-4.6-2.8-2.4-5.1-1.3-4.3-2.3-2.9-3-3.7-.5-1.8 2.2-3.1.1-2.1 1.7-.9-.1-1.7 3.4-.5 1.8-1.4 2.8.1.8-1.1 1-.2 3.8.2 4-1.8 3.9 2.3 4.6-.6-.3-3.2 2.7 1.7-1.1 4-1.2.7Z"
          />
          <path
            d="m896.3 1.4 19.9 3-6.7 1.4-13 .2-18.5.4 1.4.7 12.3-.5 9.7 1.4 7-1.2 2.4 1.4-4.5 2.4 9.2-1.6 17.1-1.5 10 .8 1.7 1.7-14.8 2.9-2.2 1-11.4.8 8.1.2-4.9 3.2-3.6 2.9-1.2 5.2 3.7 3.2-5.9.1-6.5 1.6 6.3 2.6-.1 4.2-4.2.5 4.1 4.3-8.7.4 4 2-1.6 1.8-5.7.8-5.5.1 4.2 3.4-.5 2.4-7.3-2.2-2.4 1.4 5 1.3 4.6 3.2.6 4.3-7.4 1-2.7-2.1-4.2-3 .5 3.6-5.4 2.8 10.7.2 5.5.3-11.9 4.7-12.2 4.3-12.7 1.8-4.6.1-4.9 2.1-7.5 5.8-10.2 3.9-3 .3-6.1 1.3-6.6 1.4-4.8 3.4-1.4 4-3.4 3.8-8.6 4.6.3 4.5-3.6 4.8-4.1 5.7-6.5.4-5-4.8-9-.1-3.2-3.2-.8-5.6-4.8-7.2-.7-3.7 1.5-5.1-3.7-5.1 3.3-4.1-1.9-2 7-6.4 7.2-2.1 2.6-2.2 2.8-4.2-5.5 1.9-2.6.8-4.1.7-4.2-1.7 1.5-3.7 3-2.8 3.8-.1 7.6 1.5-5.3-3.4-2.7-1.8-4.4.7-2.6-1.3 7-4.8-1.3-2L768 46l-1.4-5.4-3.6-1.9 1.4-2.1-8.1-2.9-7.7-.4-10.1.2-9.5.4-3.1-1.6-3.8-3.1 11-1.5 7.6-.2-14.6-1.3-6.5-1.9 2.2-1.8 15.7-2.2 15-2.2 2.8-1.6-8.1-1.6 4.6-1.7 14.7-2.9 5.4-.4.2-1.8 9-1.1 11-.6h10.4l2.8 1.2 10.6-2.2 7.1 1.5 4.6.3 6.2 1.3-6.7-2.1 1.6-1.7 12.7-2.2 11.6.2 5.1-1.4L870 1l26.3.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GL",
            })}
            id="GL"
          />
          <path
            d="m488.1 387.5-.7 5.1-1.3 7.2h1.7l1.7 1.2.6-1 1.5.8-2.8 2.5-2.9 1.8-.5 1.2.3 1.3-1.3 1.6-1.4.4.3.8-1.2.7-2 1.6-.3.9-2.8-1.1-3.5-.1-2.4-1.3-2.8-2.6.4-1.9.8-1.5-.7-1.2 3.3-5.2h7.2l.4-2.2-.8-.4-.5-1.4-1.9-1.5-1.8-2.1 2.5-.1.5-3.6h5.2l5.2.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GT",
            })}
            id="GT"
          />
          <path
            d="m662.9 463.5-1 5.8-3.5 1.6.3 1.5-1.1 3.4 2.4 4.6h1.8l.7 3.6 3.3 5.6-1.3.3-3.2-.6-1.8 1.7-2.6 1.1-1.8.3-.6 1.3-2.8-.3-3.5-3-.3-3-1.4-3.3 1-5.4 1.6-2.3-1.2-3-2-.9.8-2.9-1.2-1.4-3 .2-3.7-4.8 1.6-1.8v-3l3.5-1 1.4-1.2-1.8-2.4.5-2.3 4.7-3.8 3.6 2.4 3.3 4.1.1 3.4 2.1.1 3 3.1 2.1 2.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GY",
            })}
            id="GY"
          />
          <path
            d="m519.6 405.5-1.9-.1-.9.9-2 .8h-1.4l-1.3.8-1.1-.2-.9-1-.6.2-.9 1.5-.5-.1-.2 1.4-2.1 1.7-1.2.8-.6.8-1.5-1.3-1.4 1.7h-1.2l-1.3.1-.2 3.2h-.8l-.8 1.5-1.8.3-.8-2-1.7-.6.7-2.6-.7-.7-1.2-.4-2.5.7-.1-.8-1.6-1.1-1.1-1.2-1.6-.6 1.3-1.6-.3-1.3.5-1.2 2.9-1.8 2.8-2.5.6.3 1.3-1.1 1.6-.1.5.5.9-.3 2.6.6 2.6-.2 1.8-.7.8-.7 1.7.3 1.3.4 1.5-.1 1.2-.6 2.5.9.8.2 1.6 1.2 1.5 1.4 1.9 1 1.3 1.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "HN",
            })}
            id="HN"
          />
          <path
            d="m1081.5 207.6 1.5 2.5 1.7 1.8-1.7 2.4-2.4-1.4-3.5.1-4.5-1.1-2.3.1-1 1.4-2-1.5-.8 2.6 2.7 3 1.3 1.9 2.5 2.4 2.1 1.4 2.1 2.7 4.8 2.4-.5 1-5-2.3-3.2-2.3-4.8-1.9-4.7-4.6 1-.5-2.5-2.7-.3-2.1-3.3-1-1.4 2.7-1.6-2.1v-2.2l.1-.1 3.6.2.8-1 1.8 1 2 .1-.1-1.7 1.7-.7.3-2.5 3.9-1.7 1.6.8 4 2.7 4.3 1.2 1.8-1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "HR",
            })}
            id="HR"
          />
          <path
            d="m586.8 375.3.1 3.4-.7 2.5-1.5 1.1 1.3 1.9-.3 1.8-3.6-1.1-2.7.4-3.4-.4-2.7 1.2-2.8-2 .7-2.1 5.1.9 4.1.5 2.2-1.4-2.3-2.8.4-2.5-3.5-1 1.5-1.7 3.4.2 4.7 1.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "HT",
            })}
            id="HT"
          />
          <path
            d="m1096.2 191.9 3 1.7.5 1.7-2.9 1.3-1.9 4.2-2.6 4.3-3.9 1.2-3.2-.3-3.7 1.6-1.8 1-4.3-1.2-4-2.7-1.6-.8-1.2-2.1-.8-.1 1.3-4-1.1-1.4h2.8l.2-2.6 2.7 1.7 1.9.6 4.1-.7.3-1.3 1.9-.2 2.3-.9.6.4 2.3-.8 1-1.5 1.6-.4 5.5 1.9 1-.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "HU",
            })}
            id="HU"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1667.5 567.6-2.4.1-7.1-4.5 5.4-1.3 2.8 2 1.8 1.9-.5 1.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1692.3 558.9.5 1.3-.1 1.9-4.1 4.8-5 1.4-.6-.7.7-2.2 2.8-3.9 5.8-2.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1652.7 553.8 1.9 1.7 3.6-.5 1.2 2.7-6.7 1.3-3.9.9-3.1-.1 2.2-3.7h3.2l1.6-2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1681 553.8-1.1 3.6-8.6 1.8-7.5-.8.2-2.4 4.6-1.3 3.4 1.9 3.8-.5 5.2-2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1600.8 545.3 10.8.7 1.4-2.7 10.3 3.1 1.8 4.2 8.4 1.2 6.7 3.8-6.6 2.4-6.1-2.6-5.1.2-5.8-.5-5.2-1.1-6.4-2.5-4.1-.6-2.4.8-10.2-2.7-.8-2.7-5.1-.5 4.2-6.1 6.8.4 4.4 2.5 2.4.5.6 2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1748.7 541.7-3.2 4.4-.2-4.8 1.1-2.3 1.3-2.2 1.2 1.9-.2 3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1707.3 524-2.2 2.2-3.8-1.2-1-2.8 5.7-.3 1.3 2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1725.7 521.7 1.8 4.9-4.6-2.7-4.7-.5-3.3.4-3.9-.2 1.5-3.5 7-.3 6.2 1.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1785.5 518.5-1 20.9-1.6 21-4.6-5.3-5.6-1.3-1.5 1.8-7.2.2 2.8-5.2 3.7-1.8-1-7-2.3-5.3-10.7-5.5-4.6-.5-8.3-6-1.8 3.2-2.2.5-1.1-2.3.1-2.8-4.2-3.2 6.2-2.3 4 .1-.4-1.7h-8.3l-2.2-3.8-5-1.2-2.3-3.2 7.6-1.5 2.9-2.1 9.1 2.6.9 2.4 1.3 10.4 5.7 3.8 5-6.8 6.6-3.8h5l4.8 2.2 4.1 2.3 6.1 1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1696.4 492.7-4.5 6.4-4.3 1.2-5.4-1.2-9.5.3-4.9.9-.8 4.9 5 5.7 3.1-2.9 10.6-2.2-.5 2.9-2.5-.9-2.5 3.8-5.1 2.5 5.1 8.2-1.1 2.2 4.8 7.4-.3 4.2-3.1 1.9-2.1-2.3 3-5.2-5.7 2.5-1.3-1.8.8-2.5-3.9-3.8.7-6.2-3.9 1.9.2 7.5-.2 9.2-3.7.9-2.3-1.8 1.9-5.9-.6-6.2-2.4-.1-1.6-4.4 2.5-4.2.9-5.1 3-9.7 1.1-2.6 4.8-4.8 4.5 1.9 7.1.9 6.5-.3 5.6-4.6 1 1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1716 494.6-.3 5.6-2.9-.7-.9 3.9 2.3 3.4-1.6.8-2.2-4.1-1.7-8.2 1-5.1 1.8-2.3.5 3.5 3.4.5.6 2.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1608 488.9 1 4.3 3.9 3.7 3.7-1.3 3.6.4 3.3-3.2 2.7-.6 5.4 1.8 4.6-1.4 2.6-8.9 2.1-2.2 1.7-7.3h6.5l5 1.1-3 5.8 4.4 6-.9 3 6.4 5.9-6.7.8-1.8 4.4.2 5.8-5.5 4.4-.4 6.4-2.5 9.8-.7-2.3-6.6 2.9-2.1-3.9-4-.4-2.8-2.1-6.8 2.4-1.9-3.2-3.8.4-4.6-.7-.6-8.6-2.8-1.8-2.7-5.5-.8-5.6.6-6 3.3-4.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ID",
            })}
            d="m1585.2 539.4-6.2.1-4.5-5.3-7.1-5.3-2.3-3.9-4.1-5.2-2.7-4.8-4.2-9-4.9-5.4-1.7-5.5-2.2-5-5.2-4-3.1-5.5-4.4-3.6-6.2-7.1-.6-3.3 3.6.3 8.9 1.2 5.2 6.3 4.6 4.4 3.2 2.6 5.5 6.9 5.8.1 4.8 4.4 3.4 5.4 4.3 3-2.3 5.2 3.3 2.2 2 .2.9 4.5 1.9 3.5 4.1.6 2.6 4.1-1.7 8-.7 9.9Z"
          />
          <path
            d="m1427.6 308-2.8 3-.9 6 5.8 2.4 5.8 3.1 7.8 3.6 7.7.9 3.8 3.2 4.3.6 6.9 1.5 4.6-.1.1-2.5-1.5-4.1-.2-2.7 3.1-1.4 1.5 5.1.4 1.2 5.5 2.5 3.2-1 4.7.4 4.5-.2-.5-3.9-2.6-2.1 4.2-.8 3.9-4.8 5.4-4 4.9 1.5 3.2-2.7 3.6 4-1.2 2.7 6.1 1 1 2.4-1.7 1.2 1.4 3.9-4.2-1.1-6.2 4.4.9 3.7-2 5.4.3 3.1-1.6 5.3-4.6-1.5.9 6.7-1 2.2 1 2.7-2.5 1.5-4.4-10.2h-1.5l-.3 4.2-3.6-3.4 1.2-3.6 2.4-.4 1.6-5.4-3.4-1.1-5.1.1-5.4-.9-1.2-4.5-2.7-.3-4.9-2.8-1.2 4.4 4.6 3.4-3 2.4-.9 2.3 3.7 1.7-.3 3.9 2.6 4.8 1.6 5.3-.5 2.4-3.8-.1-6.6 1.3.9 4.8-2.4 3.8-7.5 4.4-5.3 7.5-3.8 4.1-5 4.2.3 2.9-2.6 1.6-4.8 2.3-2.6.3-1.2 4.9 1.9 8.4.7 5.3-1.9 6.1.7 10.9-2.9.3-2.3 4.9 1.9 2.2-5.1 1.8-1.7 4.3-2.2 1.9-5.6-6-3.1-9-2.5-6.5-2.2-3-3.4-6.2-2-8-1.4-4-5.9-8.8-3.5-12.5-2.6-8.2-.8-7.8-1.7-6-7.7 3.9-4-.8-8.1-7.8 2.4-2.3-1.9-2.5-7.1-5.5 3.2-4.3h12.1l-1.8-5.5-3.5-3.2-1.4-5-4-2.8 4.9-6.8 6.5.5 4.5-6.7 2.2-6.5 3.9-6.5-1-4.6 3.8-3.7-5.1-3.1-2.9-4.4-3.3-5.6 2-2.8 8.5 1.6 5.7-1 3.8-5.4 7.7 7.6.8 5.2 3 3.3.6 3.3-4.1-.9 3.2 7.1 6.2 4 8.6 4.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IN",
            })}
            id="IN"
          />
          <path
            d="m956.7 158.2.7 4.4-3.9 5.5-8.8 3.6-6.8-.9 4.3-6.4-2.1-6.2 6.7-4.8 3.7-2.8.9 3.2-1.2 3.3 3-.1 3.5 1.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IE",
            })}
            id="IE"
          />
          <path
            d="m1229 253.2 1.8-.2 5.3-4.7 1.9-.5 1.9 1.9-1.2 3.1 3.9 3.4 1.3-.4 2.5 4.8 5.3 1.3 4.3 3.2 7.7 1.1 8-1.7.2-1.5 4.4-1.2 3-3.7 3.6.2 2-1.2 3.9.6 6.6 3.3 4.3.7 7.3 5.6 4 .3 1.7 5.3-.6 8-.5 4.7 2.5 1-1.6 3.5 2.7 5.1 1.2 4.1 4.3 1.1 1.1 4.1-3.9 5.8 3.2 3.4 2.8 3.9 5.7 2.8 1 5.6 2.7 1.1.9 2.9-7.5 3.4-1.1 7.4-10.6-1.9-6.2-1.5-6.3-.8-3.3-7.9-2.8-1.1-4.1 1.1-5.1 3.1-7-2.1-6.1-5-5.5-1.8-4.4-6.1-5.2-8.5-2.8 1-3.7-2.1-1.7 2.5-3.5-3.4-.5-3.4h-1.7l.2-4.7-3.5-4.8-7.1-3.6-4.6-6.1.5-5 2.3-2.2-.9-3.7-3.8-2-4.7-7.6-3.8-5.1.7-2-2.9-7.3 3.3-1.9 1.2 2.5 3.2 2.9 3.8.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IR",
            })}
            id="IR"
          />
          <path
            d="m1223.5 263.2 4.7 7.6 3.8 2 .9 3.7-2.3 2.2-.5 5 4.6 6.1 7.1 3.6 3.5 4.8-.2 4.7h1.7l.5 3.4 3.5 3.4-3.3-.3-3.7-.6-3.3 6.2-10.2-.5-16.8-12.9-8.6-4.5-6.8-1.8-3.1-7.8 11-6.7 1-7.7-1.2-4.7 2.7-1.6 2.1-4 2.1-1 6.3.9 2.1 1.6 2.4-1.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IQ",
            })}
            id="IQ"
          />
          <path
            d="m924.8 84.5-1.4 3.6 4.4 3.8-6.1 4.3-13.1 3.9-3.9 1.1-5.6-.9-11.9-1.8L892 96l-9-2.7 7.9-1.1.1-1.7-8.8-1.3 3.6-3.7 6.6-.8 6 3.8 7-3 5.1 1.5 7.3-2.9 7 .4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IS",
            })}
            id="IS"
          />
          <path
            d="m1179.1 288.2.4 2.6-.6 1h.1l-.7 2-2.1-.8-.7 4.2 1.5.7-1.3.9-.1 1.7 2.5-.8.4 2.5-1.8 10.2-.7-1.6-3.9-9.4 1.4-2.1-.4-.4 1.1-3 .6-4.8.6-1.7H1177.3l.4-1.1 1.4-.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IL",
            })}
            id="IL"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IT",
            })}
            d="m1068.2 256.4-1.7 5.1.9 1.9-.9 3.3-4.2-2.4-2.7-.7-7.5-3.2.5-3.3 6.2.6 5.4-.7 4-.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IT",
            })}
            d="m1034.2 237.4 3.3 4.5-.4 8.5-2.4-.4-2.1 2.1-2-1.7-.5-7.7-1.3-3.6 2.9.3 2.5-2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "IT",
            })}
            d="m1055.9 203.9-.4 3.1 1.4 2.7-4.1-1-3.9 2.3.4 3.1-.5 1.8 1.9 3.2 5 3.2 2.9 5.3 6.1 5.1 4-.1 1.4 1.4-1.4 1.3 4.8 2.3 4 1.9 4.7 3.4.6 1.1-.8 2.3-3.1-3-4.6-1-1.9 4.1 3.9 2.4-.4 3.3-2.1.4-2.5 5.5-2.2.5-.1-2 .9-3.4 1.1-1.4-2.3-3.7-1.8-3.2-2.2-.8-1.8-2.7-3.4-1.2-2.4-2.6-3.8-.4-4.3-2.8-4.9-4.2-3.7-3.6-1.9-6.3-2.6-.7-4.2-2.1-2.3.8-2.9 3-2.1.4.5-2.7-2.8-.8-1.5-4.9 1.7-1.9-1.5-2.4.1-1.8 2.2 1.4 2.5-.3 2.7-2.2.9 1 2.4-.2 1-2.5 3.8.8 2.1-1.1.3-2.5 3.1.9.5-1.2 4.9-1.1 1.3 2.1 7.3 1.7Z"
          />
          <path
            d="m556.5 387.1-1.8 1.1-3-1.1-2.9-2.3.8-1.5 2.4-.4 1.3.2 3.7.6 2.7 1.5.8 1.8-4 .1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "JM",
            })}
            id="JM"
          />
          <path
            d="m1198.1 295.3-.9 1-10.4 3.2 6 6.5-1.6 1-.7 2.2-4.1.9-1.1 2.3-2.1 2-6.2-1.1-.3-.9 1.8-10.2-.4-2.5.6-1.9-.4-4 .7-2 6.3 2.6 9.7-6.9 3.1 7.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "JO",
            })}
            id="JO"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "JP",
            })}
            d="m1708.5 282.6 1.6 2.2-1.3 3.9-3.1-2.1-2.1 1.5.1 3.7-4.3-1.8-1.2-3 1.3-3.9 3.4.8 1-2.7 4.6 1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "JP",
            })}
            d="m1733.1 263.4.6 5.1 2.5 3.2-.6 4.5-5.4 3-9.2.4-4.4 7.4-4.7-2.5-2.4-4.8-8.6 1.4-5.1 3-6.2.2 7.4 4.7.8 10.9-2.5 2.7-3.6-2.5-.9-5.8-4.1-1.8-4-4.4 4.3-2 1.1-4.1 3.9-3.3 2-4.4 9.7-1.9 6.3 1.3v-11.4l5.1 3.1 4.5-6.4 1.7-2.5-1-7.8-5.1-7.2-.2-4 4.8-1.2 8.2 8.9 2.8 5.1-1.3 6.5 3.6 6.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "JP",
            })}
            d="m1721.2 218.6 4.5 1.3 1.8-2.6 6 7.1-6.4 1.7-.4 6.3-10.9-4.3 1.6 6.9-5.7.1-4.7-6.3-.6-4.9 5.2-.3-4.4-8.8-1.8-4.9 10.5 6.6 5.3 2.1Z"
          />
          <path
            d="m1338.3 160.5 4.4-.3 9.2-5.8-.8 2 8.4 4.7 18.3 15.6 1.1-3.2 8.4 3.5 6.2-1.6 3.3 1.1 4.1 3.6 4 1.2 3.3 2.7 6-.9 4.4 3.8-1.9 4.2-3.8.6 2.5 6.2-1.6 2.9-10.8-2.1 1 11.3-2 1.4-9.1 2.5 8.8 11-2.9 1.6 1.7 3.7-3.5-1-3.4-2.3-7.9-.6-8.6-.2-1.6.7-8.2-2.7-2.5 1.4.5 3.7-9.2-2.2-3.1.9-.3 2.8-2.6 1.2-5.4 4.4-.9 4.6h-2l-2.3-3-6.7-.2-2.5-5.2-2.6-.1-1.5-6.4-7.6-4.6-8.6.5-5.7.9-6.6-5.7-4.8-2.4-9.2-4.5-1.1-.5-12 3.7 6.2 23.4-2.6.3-4.8-5-3.9-1.8-5.6 1.3-1.8 2.2-.6-1.6.6-2.6-1.5-2.2-6.5-2.2-3.7-5.7-3.2-1.6-.6-2.1 5.1.6-1-4.6 4.1-1 4.7.9-.7-6.1-1.9-3.9-5 .3-4.7-1.5-5.1 2.7-4.4 1.4-2.8-1.1-.2-3.2-4.3-4.2-3.6.2-5.3-4.2 1.7-4.8-1.8-1.2 2.2-6.9 6 3.6-.6-4.5 8.1-6.7 7.6-.2 12 4.3 6.6 2.5 4.4-2.6 7.7-.1 7.3 3.2.8-1.9 7 .3.2-2.9-9.4-4.3 3.5-3-1.5-1.6 4-1.6-5.1-4.2 1.4-2.1 17-2.1 1.7-1.5 10.9-2.3 3.1-2.5 9.1 1.3 4.4 6.3 4.3-1.5 7.1 2.1 1.1 3.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KZ",
            })}
            id="KZ"
          />
          <path
            d="m1223.5 476.7-4.9 7.2.2 23.4 3.3 5.3-4 2.6-1.4 2.7-2.2.4-.8 4.6-1.9 2.6-1.1 4.2-2.3 2.1-8.1-6.4-.3-3.7-20.5-13.1.4-4.7-1.4-2.5v-.3l1.6-2.6 2.8-4.2 2.1-4.7-2.6-7.4-.7-3.2-2.7-4.5 3.4-3.8 3.8-4.2 2.9 1.1.1 3.6 1.9 2.1h4l7.2 5.4 1.8.1 1.3-.2 1.3.7 3.8.6 1.6-2.7 5.2-2.7 2.3 2.2h3.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KE",
            })}
            id="KE"
          />
          <path
            d="m1400.5 230.2-.2 1.4-6.9 3.4-1 2.6-6.4.7-.6 4.1-5.8-.9-3.2 1.3-4.1 3 1.2 1.5-1.1 1.4-9.6 1-7.1-2.1-5.5.5-.6-3.6 6 1 1.4-1.9 4.1.6 5.3-4.6-7.2-3.4-3.2 1.6-4.6-2.4 3-4.1-1.7-.6.3-2.8 3.1-.9 9.2 2.2-.5-3.7 2.5-1.4 8.2 2.7 1.6-.7 8.6.2 7.9.6 3.4 2.3 3.5 1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KG",
            })}
            id="KG"
          />
          <path
            d="m1589.8 410.6 1.8 4.3.1 7.7-9 5 2.8 3.8-5.9.5-4.6 2.6-4.8-.9-2.6-3.4-3.5-6.6-2.1-7.8 3.1-5.3 7.1-1.2 5.3.9 5 2.5 2-4.4 5.3 2.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KH",
            })}
            id="KH"
          />
          <path
            d="M1652.9 259.5v-.6l2.5.2.6-2.8 3.6-.4 2-.4V254l8.3 7.5 3.3 4.2 3.4 7.4-.5 3.5-4.3 1.2-3.1 2.7-4.6.5-2.1-3.5-1.1-4.8-5.3-6.6 3.4-1.1-6.1-5.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KR",
            })}
            id="KR"
          />
          <path
            d="m1247.5 309.4 1.5 2.8-.3 1.5 2.4 4.8-3.9.2-1.7-3.1-5-.6 3.3-6.2 3.7.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KW",
            })}
            id="KW"
          />
          <path
            d="m1589.8 410.6-5.3-2.3-2 4.4-5-2.5 1.5-2.9-.4-5.4-5.3-5.6-1.3-6.4-5-5.2-4.3-.4-.8 2.2-3.2.2-1.9-1.1-5.3 3.8-1-5.8.4-6.7-3.8-.3-.9-3.9-2.7-2 .8-2.3 4.1-4.2.8 1.5 3 .2-2-7.4 2.7-.9 4 5.1 3.5 5.8h6.8l3 5.6-3.3 1.7-1.2 2.3 7.3 3.9 5.7 7.6 4.4 5.6 4.9 4.5 2 4.5-.2 6.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LA",
            })}
            id="LA"
          />
          <path
            d="m1179.1 288.2-1.4.1-.4 1.1h-1.8l1.3-5.3 2.2-4.5v-.2l2.5.3 1.2 2.5-2.7 2.5-.9 3.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LB",
            })}
            id="LB"
          />
          <path
            d="m938.6 452.5-.2 1.8.5 3.1-1.2 2.9 1.6 1.8 1.8.4 2.4 2.7.2 2.5-.6.8-.4 5.3-1.5.1-5.8-3.1-5.2-4.9-4.8-3.5-3.8-4.1 1.4-2.1.3-1.9 2.6-3.4 2.6-3 1.3-.2 1.4-.7 2.4 3.9-.4 2.6 1.1 1.4h1.6l1.1-2.6 1.6.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LR",
            })}
            id="LR"
          />
          <path
            d="m1122.6 299.1-1.7 3.1 1 2.8-1.1 3.9 2 5.2 1.3 22.8 1 23.7.5 12.8h-6.4v2.7l-22.6-12.3-22.5-12.3-5.5 3.5-3.8 2.4-3.2-3.5-8.8-2.8-2.5-4-4.5-3-2.5 1.2-2.1-3.6-.2-2.7-3.4-4.7 2.2-2.7-.6-4 .6-3.5-.4-3 .8-5.2-.4-3-1.9-5.7 2.6-1.4.4-2.8-.6-2.6 3.6-2.5 1.6-2.1 2.6-1.8.1-4.9 6.4 2.2 2.3-.6 4.5 1.1 7.3 2.9 2.8 5.7 4.9 1.2 7.8 2.7 6 3.2 2.5-1.7 2.5-2.9-1.6-4.9 1.5-3.2 3.7-3 3.7-.8 7.4 1.3 2 2.8 2 .1 1.8 1.1 5.4.7 1.5 2.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LY",
            })}
            id="LY"
          />
          <path
            d="m1445.9 462-4.8 1.5-2.9-5.1-1.4-9.2 2-10.4 4.1 3.5 2.8 4.5 3.1 6.7-.6 6.7-2.3 1.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LK",
            })}
            id="LK"
          />
          <path
            d="m1139.1 697.9-2 .7-3.7-5 3.2-4 3.1-2.5 2.7-1.4 2.2 2 1.7 2-1.9 3.1-1.1 2.1-3.1 1-1.1 2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LS",
            })}
            id="LS"
          />
          <path
            d="m1111.1 147.6 1 2.7-3.6 2-.5 3.4-4.8 2.3h-4.7l-1.4-1.9-2.5-.7-.6-1.5.2-1.7-2.2-.9-5.1-1.1-1.7-5.1 5.1-1.8 7.9.4 4.5-.6.9 1.2 2.5.4 5 2.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LT",
            })}
            id="LT"
          />
          <path
            d="m1016.9 185.4-1.4.1-1.1-.5.4-3.5 1.3-.2 1 1.4-.2 2.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LU",
            })}
            id="LU"
          />
          <path
            d="m1112.8 136.5 2.5 1.3 1 2.9 2.1 3.6-4.6 2.3-2.7 1-5-2.9-2.5-.4-.9-1.2-4.5.6-7.9-.4-5.1 1.8-.5-4.5 1.7-3.8 4.1-2 4.4 4.5 3.7-.2.1-4.6 3.8-1 2.1.7 4.4 2.2 3.8.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LV",
            })}
            id="LV"
          />
          <path
            d="m974.8 276 1.9 4.1.3 3.9 1.9 6.8 1.4 1.4-1 2.5-7.1 1.1-2.5 2.3-3.1.6-.3 4.8-6.4 2.5-2.1 3.2-4.5 1.7-5.4 1-8.9 4.8-.1 7.6h-.9l.1 3.4-3.4.2-1.8 1.5h-2.5l-2-.9-4.6.7-1.9 5-1.8.5-2.7 8.1-7.9 6.9-2 8.9-2.4 2.9-.7 2.3-12.5.5h-.1l.3-3 2.2-1.7 1.9-3.4-.3-2.2 2-4.5 3.2-4.1 1.9-1 1.6-3.7.2-3.5 2.1-3.9 3.8-2.4 3.6-6.5.1-.1 2.9-2.5 5.1-.7 4.4-4.4 2.8-1.7 4.7-5.4-1.2-7.9 2.2-5.6.9-3.4 3.6-4.3 5.4-2.9 4.1-2.7 3.7-6.6 1.8-4 3.9.1 3.1 2.7 5.1-.4 5.5 1.4h2.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MA",
            })}
            id="MA"
          />
          <path
            d="m1129.4 210.3-1.3-2.9.2-2.7-.6-2.7-3.4-3.8-2-2.6-1.8-1.8-1.6-.7 1.1-.9 3.2-.6 4 1.9 2 .3 2.6 1.7-.1 2.1 2 1 1.1 2.6 2 1.6-.2 1 1 .6-1.3.5-3-.2-.6-.9-1 .5.6 1.1-1.1 2.1-.6 2.1-1.2.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MD",
            })}
            id="MD"
          />
          <path
            d="m1267.9 588.9.4 7.7 1.3 3-.7 3.1-1.2 1.8-1.6-3.7-1.2 1.9.8 4.7-.7 2.8-1.7 1.4-.7 5.5-2.7 7.5-3.4 8.8-4.3 12.2-2.9 8.9-3.1 7.5-4.6 1.5-5.1 2.7-3-1.6-4.2-2.3-1.2-3.4v-5.7l-1.5-5.1-.2-4.7 1.3-4.6 2.6-1.1.2-2.1 2.9-4.9.8-4.1-1.1-3-.8-4.1-.1-5.9 2.2-3.6 1-4.1 2.8-.2 3.2-1.3 2.2-1.2 2.4-.1 3.4-3.6 4.9-4 1.8-3.2-.6-2.8 2.4.8 3.3-4.4.3-3.9 2-2.9 1.8 2.8 1.4 2.7 1.2 4.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MG",
            })}
            id="MG"
          />
          <path
            d="m449.3 335.9 2.2-.2-3.2 5.7-1.8 4.6-1.8 8.6-1.1 3.1.4 3.5 1.3 3.2.4 4.9 3 4.8.8 3.7 1.7 3.1 5.7 1.7 1.9 2.7 5.2-1.8 4.3-.6 4.4-1.2 3.6-1.1 3.9-2.6 1.8-3.7 1.2-5.4 1.2-1.9 4-1.7 6.1-1.5 4.9.3 3.4-.6 1.2 1.4-.6 3.1-3.5 3.8-1.8 3.9.9 1.1-1.2 2.8-2.1 5-1.2-1.7-1.1.1-1.1.1-2.5 3.9-.9-.8-.7.3-.1 1-5.2-.1h-5.2l-.5 3.6-2.5.1 1.8 2.1 1.9 1.5.5 1.4.8.4-.4 2.2h-7.2l-3.3 5.2.7 1.2-.8 1.5-.4 1.9-5.6-6.9-2.6-2.1-4.4-1.7-3.2.5-4.8 2.4-2.9.6-3.7-1.7-4.1-1.2-4.8-2.9-4.1-.9-5.9-3-4.3-3.1-1.1-1.7-3.1-.4-5.4-2-1.9-2.9-5.4-3.7-2.2-4-.8-3.2 1.9-.6-.3-1.8 1.6-1.7.4-2.2-1.5-2.9v-2.5l-1.3-3.3-3.8-6.4-4.6-5-1.9-4-4.1-2.6-.7-1.6 1.7-3.9-2.4-1.5-2.5-3.2-.2-4.4-2.8-.6-2.3-3.3-1.7-3.2.3-2-1.5-4.8-.3-4.9.8-2.5-3.1-2.6-1.9.3-2.4-1.7-1.8 2.6-.1 3-1 4.9 1 2.6 2.8 4.4.4 1.6.7.4.1 2.2 1-.1v4.2l1.3 1.6.5 2.3 2.7 3.2.4 6 1 2.8.9 3-.3 3.4 2.6.2 1.6 2.9 1.5 2.9-.3 1.2-2.8 2.3h-1l-.7-3.9-2.9-3.7-3.4-3.1-2.5-1.6 1.2-4.7-.1-3.5-2.1-2-3.1-2.8-.9.8-1-1.7-3-1.5-2.2-3.8.5-.4 2.1.3 2.7-2.4 1-2.9-2.9-4.6-2.6-1.7-.8-4-.6-4.3-.8-5.1-.2-5.8 6.3-.5 7.1-.7-.9 1.3 7 3.1 10.9 4.5H399.8l.8-2.7h9.4l1.3 2.3 2.1 2.1 2.4 2.8.8 3.3.4 3.6 2.3 1.9 4 1.9 4.8-5 4.5-.2 3.2 2.6 1.6 4.4.9 3.8 2.4 3.6.2 4.5.9 3 3.9 2 3.6 1.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MX",
            })}
            id="MX"
          />
          <path
            d="m1105.5 236.6-1 .2-.8 1.1-2.8-.1-1.8 1.4-3.4.5-2.3-1.5-1-2.7.5-2.2.7.1.1-1.3 2.9-1 1.2-.3 1.7-.3 2.4-.2 2.8 2.1.8 4.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MK",
            })}
            id="MK"
          />
          <path
            d="m1010.2 378.8.1 14.8-3.1 4.3-.4 4-5 1-7.7.5-2 2.3-3.6.3h-3.6l-1.4-1.2-3.1.9-5.3 2.7-1.1 2-4.3 2.8-.8 1.7-2.4 1.3-2.7-.9-1.5 1.6-.9 4.4-4.5 5.3.2 2.2-1.6 2.7.4 3.7-2.4 1-1.3.8-.9-2.7-1.6.7-1-.1-1 1.8h-4.4l-1.5-1-.8.6-1.7-1.9.3-1.9-.7-.7-1.2.6.3-2.1 1.1-1.6-2.3-2.7-.6-1.8-1.3-1.4-1.1-.2-1.3.9-1.9.9-1.5 1.4-2.4-.5-1.6-1.7-.9-.2-1.5.9h-.9l-.3-2.4.3-2-.5-2.4-2-1.8-1.1-3.7-.2-4 1.9-1.2 1-3.8 1.8-.1 3.9 1.8 3.2-1.3 2.1.4.9-1.4 22.5-.1 1.3-4.5-1-.8-2.5-27.7-2.4-27.7 8.5-.1 18.6 14 18.7 14 1.3 3 3.5 1.8 2.6 1.1.1 4.1 6.2-.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ML",
            })}
            id="ML"
          />
          <path
            d="m1548.4 364.2-4.1 4.2-.8 2.3-3 1.5-2.8 2.8-3.9.3-1.5 6.9-2.2 1.2 3.5 5.6 4.1 4.7 2.9 4.3-1.4 5.5-1.8 1.2 1.8 3.2 4.3 5.1 1 3.6.2 3 2.7 5.9-2.6 6-2.2 6.6-.9-4.8 1.3-4.9-2.2-3.8-.2-7-2.6-3.4-2.7-7.6-2-8.1-3.1-5.4-3.2 3.3-5.8 4.5-3.3-.5-3.6-1.5.9-8-2-6-5.3-7.4.3-2.3-3.4-.9-4.6-5.2-1.1-5.2 2.1 1-.6-4.6 2.5-1.5-1-2.7 1-2.2-.9-6.7 4.6 1.5 1.6-5.3-.3-3.1 2-5.4-.9-3.7 6.2-4.4 4.2 1.1-1.4-3.9 1.7-1.2-1-2.4 3.1-.5 2.7 3.8 2.7 1.5 1.3 4.9.9 5.3-4.2 5.4.7 7.6 5.6-1.1 2.4 5.9 3.7 1.3-.8 5.3 4.5 2.4 2.6 1.2 3.8-1.9.5 2.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MM",
            })}
            id="MM"
          />
          <path
            d="m1090.6 227.2-.8 1.4-1.4.6-.4-1.2-1.9 3.1.5 2.1-1.1-.5-1.7-2.1-2.3-1.3.5-1 .4-3.5 1.6-1.5.9-.6 1.4 1.1.9.9 1.7.7 2.1 1.3-.4.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ME",
            })}
            id="ME"
          />
          <path
            d="m1496.2 181.5 4-1.2 5.7-.8 5.4.9 6.6 2.9 4.9 3.2h4.6l6.8 1 3.6-1.6 5.9-1 4.4-4.4 3.4.7 3.9 2.1 5.6-.6.6 4.7.3 6.3 2.8 2.5 2.3-.8 5.5 1 2.5-2.3 5.2 2 7.2 4.4.8 2.2-4.4-.7-6.8.8-2.5 1.8-1.3 4.2-6.4 2.4-3.2 3.4-5.9-1.3-3.2-.6-.5 4.1 2.9 2.4 1.9 2.1-2.4 2.2-2 3.4-4.9 2.2-7.6.2-7.2 2.2-4.4 3.4-3.3-1.9h-6.2l-9.4-3.9-5.6-.9-6.4.9-11.3-1.5-5.6.2-4.7-3.8-5-5.8-3.4-.7-8-4-7.2-.8-6.5-1.1-3-2.8-1.4-7.3-5.8-5.1-8.2-2.3-5.7-3.3-3.3-4.4 4.7-1.1 6.7-5.3 5.9-2.9 5.3 1.9 5.2.1 4.8 2.9 5 .2 8 1.6 2.4-4.4-4-3.6 1.3-6.4 7 2.5 4.8.8 6.7 1.6 3.6 4.6 8.5 2.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MN",
            })}
            id="MN"
          />
          <path
            d="M1166.7 673.5h-4.1l-.3-2.9-.6-2.9-.4-2.3 1.4-7.1-1.1-4.6-2.2-9 6.2-7.3 1.7-4.6.8-.6.9-3.8-.8-1.9.4-4.8 1.3-4.4.4-8.2-2.8-2-2.7-.5-1.1-1.6-2.6-1.3-4.7.1-.2-2.4-.4-4.6 17.2-5.3 3.2 3.1 1.5-.6 2.2 1.6.2 2.6-1.3 3 .2 4.5 3.5 4 1.9-4.5 2.5-1.3-.1-8.3-2.2-4.6-1.9-2.1h-.4l-.6-7.3 1.5-6.1 2.2-.2 6.7 1.8 1.5-.8 3.9-.2 2.1-1.9 3.4.1 6.2-2.5 4.6-3.7.9 2.8-.5 6.4.5 5.7-.2 10 .8 3.1-1.9 4.6-2.4 4.5-3.7 4-5.3 2.4-6.5 3.1-6.6 6.9-2.2 1.2-4.2 4.6-2.3 1.4-.8 4.6 2.4 4.9.9 3.7v2l1-.4-.5 6.3-1.1 3 1.2 1.1-1 2.7-2.4 2.3-4.7 2.1-6.9 3.5-2.5 2.4.3 2.7 1.3.4-.7 3.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MZ",
            })}
            id="MZ"
          />
          <path
            d="m959.2 341.5-8.5.1 2.4 27.7 2.5 27.7 1 .8-1.3 4.5-22.5.1-.9 1.4-2.1-.4-3.2 1.3-3.9-1.8-1.8.1-1 3.8-1.9 1.2-3.6-4.4-3.4-4.8-3.6-1.7-2.7-1.8h-3.1l-2.8 1.4-2.7-.5-2 2-.4-3.4 1.6-3.2.8-6-.4-6.4-.6-3.2.6-3.2-1.4-3-2.8-2.8 1.3-2.1h21.7l-.9-9.3 1.5-3.3 5.2-.5.2-16.5 18 .4.2-9.8 20.5 15.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MR",
            })}
            id="MR"
          />
          <path
            d="M1182.3 588.9h.4l1.9 2.1 2.2 4.6.1 8.3-2.5 1.3-1.9 4.5-3.5-4-.2-4.5 1.3-3-.2-2.6-2.2-1.6-1.5.6-3.2-3.1-2.9-1.6 2-6 1.8-2.2-.9-5.4 1.3-5.2 1-1.7-1.3-5.4-2.6-2.9 5.5 1.2 1 1.7-.1.8 1.8 4.1.2 7.7-1.8 3.6 1.6 4.7-.2 2.8 1.2 1.9-.1 2.4.9 1.4 1-1.6 1.9 2.5.2-.8-1-3.4-1.1-.3-.1-.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MW",
            })}
            id="MW"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MY",
            })}
            d="m1564.3 461.9 1.4.6 3.5 3.9 2.5 4.3.6 4.3-.5 2.9.6 2.2.5 3.8 2.1 1.8 2.3 5.7v2.1l-4 .5-5.5-4.8-6.8-5.1-.8-3.3-3.4-4.3-1-5.3-2.2-3.5.4-4.7-1.4-2.7.9-1.1 4.8 2.8.6 3.3 3.7-.8 1.7-2.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MY",
            })}
            d="m1654.1 475.3-5-1.1h-6.5l-1.7 7.3-2.1 2.2-2.6 8.9-4.6 1.4-5.4-1.8-2.7.6-3.3 3.2-3.6-.4-3.7 1.3-3.9-3.7-1-4.3 4.2 2.2 4.3-1.2 1-5.4 2.4-1.2 6.8-1.4 3.8-5.1 2.6-4 2.8 3.3 1.1-2.2 2.7.2.1-4.1.1-3.2 4.1-4.4 2.6-5 2.3-.1 3.1 3.3.4 2.8 3.8 1.8 4.8 1.9-.2 2.5-3.8.3 1.1 3.2-4 2.2Z"
          />
          <path
            d="m1116.2 614.3 4.6-1.4 3.6.3 2.2 1.5v.5l-3.2 1.5h-1.7l-3.7 2.5-2-2.7-8.7 2.3-4.2.2-.8 22.9-5.5.2-.6 18.7-1.1 23.7-5 3.3-2.9.5-3.4-1.2-2.5-.5-.8-2.7-2-1.8-2.8 3.2-3.9-4.9-2-4.6-1-6.3-1.2-4.6-1.6-9.9.1-7.7-.6-3.5-2.1-2.7-2.8-5.3-2.8-7.7-1.1-4-4.4-6.3-.3-4.9 2.7-1.2 3.4-1.1 3.6.2 3.3 2.9.8-.5 22.7-.2 3.8 3 13.5.9 10.4-2.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NA",
            })}
            id="NA"
          />
          <path
            d="m1068.6 355 1.6 10 2.2 1.7.1 2 2.4 2.2-1.2 2.8-1.8 13-.2 8.4-7 6-2.3 8.5 2.4 2.4v4.1l3.7.1-.6 3.1-1.5.3-.2 2.1-1 .1-3.9-7-1.4-.3-4.3 3.6-4.4-1.9-3-.3-1.6.9-3.3-.2-3.3 2.7-2.9.2-6.8-3.3-2.7 1.5-2.9-.1-2.1-2.4-5.6-2.4-6.1.8-1.4 1.3-.8 3.7-1.6 2.6-.4 5.8-4.3-3.7h-2l-1.9 1.9.1-4.4-6.5-1.5-.2-3.1-3.1-4.2-.8-2.9.5-3.1 3.6-.3 2-2.3 7.7-.5 5-1 .4-4 3.1-4.3-.1-14.8 7.8-2.8 16-12.6 18.8-12.3 8.8 2.8 3.2 3.5 3.8-2.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NE",
            })}
            id="NE"
          />
          <path
            d="m1066.2 421.7 2.3 2.5-.6 1.2-.3 2.1-4.7 5-1.4 4.1-.8 3.3-1.2 1.5-1.1 4.5-3 2.6-.8 3.2-1.3 2.6-.5 2.7-3.9 2.2-3.2-2.7-2.1.1-3.4 3.8h-1.6l-2.7 6.2-1.4 4.6-5.9 2.3-2.1-.3-2.2 1.4-4.5-.1-3.1-4.1-1.9-4.6-4-4.2h-9.2l.3-10.3-.2-4.1 1.1-4 1.7-2 2.8-4-.6-1.7 1.1-2.6-1.3-3.8.2-2.1.4-5.8 1.6-2.6.8-3.7 1.4-1.3 6.1-.8 5.6 2.4 2.1 2.4 2.9.1 2.7-1.5 6.8 3.3 2.9-.2 3.3-2.7 3.3.2 1.6-.9 3 .3 4.4 1.9 4.3-3.6 1.4.3 3.9 7 1-.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NG",
            })}
            id="NG"
          />
          <path
            d="m519.6 405.5-.5.7-.5 1.4.4 2.3-1.5 2.2-.8 2.6-.5 2.8.2 1.7-.1 2.9-.9.6-.7 2.8.2 1.7-1.2 1.6.1 1.7.8 1.1-1.4 1.4-1.7-.5-.8-1.3-1.8-.5-1.3.8-3.6-1.7-.9.8-1.8-2-2.5-2.6-1.1-2.1-2.2-2.1-2.5-2.9.7-1 .8 1 .5-.4 1.8-.3.8-1.5h.8l.2-3.2 1.3-.1h1.2l1.4-1.7 1.5 1.3.6-.8 1.2-.8 2.1-1.7.2-1.4.5.1.9-1.5.6-.2.9 1 1.1.2 1.3-.8h1.4l2-.8.9-.9 1.9.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NI",
            })}
            id="NI"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NO",
            })}
            d="m1113.7 67.5-6.4 2.1-3.2.5.8-3.8-5.8-2.1-5.9 1.8-1.1 4-3.4 2.4-4.7-1.3-5.3.2-5.1-2.8-2.2 1.4-2.6.2.1 3.6-8-.9-.6 3.1h-4l-2.3 3.9-3.4 6.1-5.7 7.9 1.8 2-1.3 2.2-4.3-.1-2.4 5.4 1 7.7 3.1 2.9-.8 6.9-3.4 4-1.8 3.4-3.3-3.6-8.6 6.8-6.1 1.4-6.5-3-1.8-6.3-2-13.5 4-3.7 11.3-4.9 8.1-5.9 7.2-7.8L1048 77l6.4-4.1 10.3-6.8 8.5-2.4 6.7.3 5.2-4.4 7.4.2 7-1 13.7 3.9-4.9 1.4 5.4 3.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NO",
            })}
            d="m1076.6 25.2-7.6 1.9-6.8-1.1 2.2-1.2-2.6-1.5 7.3-.9 1.9 1.7 5.6 1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NO",
            })}
            d="m1051 16.7 12.6 3.4-8.6 1.8-1.2 3.4-3 .9-.9 4-4.4.2-8.5-2.9 3-1.7-5.7-1.4-7.7-3.9-3.2-3.5 9.3-1.6 2.3 1.5h5l1-1.5 5.2-.2 4.8 1.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NO",
            })}
            d="m1075.4 13.7 7.4 1.5-4.4 2.4-10.1.5-10.7-.8-1-1.2h-5.1l-4.3-2 10.5-1.2 5.4 1 3.1-1.3 9.2 1.1Z"
          />
          <path
            d="m1469 322.9.2 2.7 1.5 4.1-.1 2.5-4.6.1-6.9-1.5-4.3-.6-3.8-3.2-7.7-.9-7.8-3.6-5.8-3.1-5.8-2.4.9-6 2.8-3 1.9-1.5 4.8 2 6.4 4.2 3.3.9 2.5 3.1 4.5 1.2 5 2.9 6.5 1.4 6.5.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NP",
            })}
            id="NP"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "OM",
            })}
            d="m1283.8 394.9-2.2-4.5-5.2-10.6 16.3-6.4 2.6-12.8-3-4.6v-2.6l1.3-2.6-.2-2.6 2.4-1.3-1.1-.9v-4.2h2.8l3 4.4 3.3 2.3 4.1.9 3.4 1.1 2.9 3.7 1.7 2.1 2 .9.2 1.4-1.7 3.8-.7 1.8-2.2 2.1-1.7 4.4-2.5-.4-1 1.6-.7 3.2 1.1 4.3-.5.8h-2.5l-3.3 2.4-.3 3.1-1.2 1.4-3.5-.1-2 1.6.2 2.6-2.6 1.8-3.1-.6-3.6 2.2-2.5.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "OM",
            })}
            d="m1296.2 336.7-1.3-2.2 1.4-2.1.7.5-.2 2.7-.6 1.1Z"
          />
          <path
            d="m1401.6 273.9-3.8 5.4-5.7 1-8.5-1.6-2 2.8 3.3 5.6 2.9 4.4 5.1 3.1-3.8 3.7 1 4.6-3.9 6.5-2.2 6.5-4.5 6.7-6.5-.5-4.9 6.8 4 2.8 1.4 5 3.5 3.2 1.8 5.5h-12.1l-3.2 4.3-4.2-1.6-2.2-4.6-4.9-4.9-10 1.2-9 .1-7.6.9 1.1-7.4 7.5-3.4-.9-2.9-2.7-1.1-1-5.6-5.7-2.8-2.8-3.9-3.2-3.4 9.6 3.3 5.3-1 3.4.8.9-1.4 3.9.6 6.6-2.7-.8-5.4 2.3-3.7h4.1l.2-1.7 4-.9 2.1.6 1.8-1.8-1.1-3.9 1.4-3.8 3.1-1.7-3.1-4.2 5.2.2.9-2.3-.8-2.5 2-2.7-1.4-3.2-1.9-2.7 2.4-2.8 5.3-1.3 5.9-.8 2.4-1.1 2.9-.8 4.7 3 2.9 5 9.5 2.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PK",
            })}
            id="PK"
          />
          <path
            d="m549.3 446.2-.7.9 1.1 3.8-1.1 1.9-1.8-.5-.9 3.1-1.8-1.8-1-3.5 1.4-1.7-1.4-.4-.9-2.1-2.8-1.8-2.4.4-1.3 2.2-2.4 1.6-1.2.2-.6 1.4 2.5 3.5-1.6.8-.8.9-2.7.4-.8-3.9-.8 1.1-1.8-.4-1-2.5-2.3-.5-1.5-.7h-2.4l-.2 1.4-.6-1 .3-1.3.6-1.3-.2-1.1.9-.8-1.1-.9.1-2.6 2.2-.6 1.9 2.3-.2 1.4 2.2.3.6-.6 1.5 1.6 2.8-.5 2.5-1.6 3.5-1.3 2-1.9 3.1.4-.2.6 3.1.2 2.4 1.2 1.8 1.9 2 1.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PA",
            })}
            id="PA"
          />
          <path
            d="m590.5 529.4-5.1-.3-.8 1-4.6 1.2-6.3 4.4-.3 3-1.4 2.2.7 3.5-3.4 1.8.2 2.8-1.5 1.1 2.6 5.8 3.3 3.9-1 2.8 3.8.3 2.3 3.5 5 .1 4.4-3.7.1 9.7 2.6.7 3.2-1.1 5.5 10.4-1.1 2.1v4.6l.3 5.4-1.9 3.2 1.2 2.4-1.1 2.2 2.9 5.4-2.9 6.9-1.1 3.3-2.8 1.6-5.9-3.7-.8-2.6-11.7-6.4-10.7-7.1-4.7-3.9-2.8-5.3.8-1.9-5.4-8.4-6.4-11.8-6-12.8-2.4-3-2-4.7-4.6-4.2-4.1-2.6 1.7-2.8-3-6.2 1.7-4.5 4.4-4 .7 2.7-1.6 1.5.3 2.3 2.3-.5 2.3.7 2.5 3.3 3.1-2.7.9-4.3 3.4-5.6 6.7-2.5 6.1-6.8 1.7-4.1-.8-4.9 1.5-.6 3.8 3 1.8 3.1 2.6 1.6 3.5 6.7 4.2.9 3.1-1.7 2.1 1.1 3.4-.6 4.4 3-3.5 6.6 1.7.1 2.9 3.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PE",
            })}
            id="PE"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PH",
            })}
            d="m1700.5 447.8.9 4.3.6 3.6-1.6 5.8-2.5-6.5-2.4 3.3 2.1 4.7-1.4 3-6.9-3.7-1.9-4.7 1.5-3-3.8-3.1-1.6 2.7-2.6-.3-4 3.6-1-1.9 1.8-5.4 3.4-1.8 2.9-2.4 2.2 2.9 4.2-1.7.7-2.9 4-.2-.8-4.9 4.9 3 .7 3.2.6 2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PH",
            })}
            d="m1685.9 435.8-1.8 2.1-1.4 4.1-1.6 1.9-3.9-4.4 1-1.8 1.3-1.8.2-3.9 3.1-.4-.5 4.3 3.6-6.2v6.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PH",
            })}
            d="m1655.6 442-7.1 6.1 2.4-4.5 3.8-4 3-4.4 2.3-6.4 1.6 5.3-3.5 3.5-2.5 4.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PH",
            })}
            d="m1673.1 425.5 3.6 2h3.5l.2 2.6-2.3 2.8-3.4 1.9-.5-3 .1-3.3-1.2-3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PH",
            })}
            d="m1693.2 423.7 2.4 7.2-4.5-1.7.3 2.2 1.8 3.9-2.6 1.5-.6-4.6-1.8-.3-1.2-3.9 3.3.5-.3-2.4-4-4.9 5.4.1 1.8 2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PH",
            })}
            d="m1670.2 417.9-.9 5.6-2.7-3.2-3.5-4.9 4.8.2 2.3 2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PH",
            })}
            d="m1663.7 383 3.8 1.9 1.4-1.7.8 1.6-.4 2.7 2.6 4.6-.6 5.3-2.9 2.1-.1 5.2 2 5.1 3 .7 2.4-.7 7.5 3.5-.1 3.5 2.1 1.6-.3 2.9-4.7-3.1-2.5-3.4-1.2 2.4-4-3.9-5 1-3-1.4-.1-2.7 1.6-1.6-1.9-1.5-.4 2.3-3.3-3.7-1.3-2.8-1.1-6.1 2.6 2.1-1.1-10.1.8-5.8h3.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PG",
            })}
            d="m1868.1 545.6-1.6.7-2.3-2.5-2.2-4.1-.8-4.9.8-.6.5 1.9 1.6 1.5 2.4 4 2.5 2.2-.9 1.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PG",
            })}
            d="m1846.7 537-3 .5-1 1.8-3.2 1.6-3 1.5h-3.1l-4.5-1.9-3.1-1.8.6-2 5 1 3.2-.5 1-3.1.9-.2.3 3.4 3.2-.4 1.8-2.2 3.3-2.3-.4-3.8 3.4-.1 1.1 1-.4 3.6-2.1 3.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PG",
            })}
            d="m1782.9 560.4 1.6-21 1-20.9 9.6 4.4 10.3 3.7 3.7 3.3 3 3.2.6 3.8 9.2 4 1.1 3.4-5.2.7.9 4.3 4.7 4.2 3 6.8 3.3-.2-.6 2.8 4.3 1.1-1.8 1.2 5.7 2.7-.9 1.9-3.8.4-1.2-1.6-4.7-.8-5.6-.9-4-4.1-2.8-3.6-2.5-5.6-7.1-2.8-4.9 1.8-3.7 2.2.3 4.7-4.6 2.2-3.1-1.1-5.8-.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PG",
            })}
            d="m1853.6 530.7-1.8 1.7-.9-3.8-1.1-2.4-2.5-2.1-3.1-2.8-4-1.9 1.6-1.5 3 1.8 1.9 1.4 2.3 1.5 2.1 2.7 2.1 2.1.4 3.3Z"
          />
          <path
            d="m1079.9 154.8 5.9.7 8.8-.1 2.5.7 1.4 1.9.6 2.7 1.7 2.3.4 2.4-2.8 1.3 1.9 2.8.5 2.8 3.2 5.4-.3 1.7-2.3.7-3.8 5.2 1.6 2.8-1.1-.4-5-2.4-3.5.9-2.4-.6-2.8 1.3-2.7-2.2-1.9.9-.3-.4-2.6-3.1-3.7-.3-.7-2-3.4-.7-.6 1.6-2.8-1.3.2-1.7-3.7-.5-2.5-2-2.4-3.9.2-2.2-1.5-3.3-1.9-2.1 1.2-1.7-1.4-3.1 3.1-1.8 7.1-2.8 5.8-2 4.8 1 .6 1.5h4.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PL",
            })}
            id="PL"
          />
          <path
            d="m1660.3 229.9 1.4 1.1-2.2-.4-1 2.2-.3 2.1 2.8 4.6-1.9 1.4-.3 1.1-.9 1.9-2.9 1.1-1.4 1.7 1.3 2.7-.3.7 2.6 1.1 4.4 2.8v1.5l-2 .4-3.6.4-.6 2.8-2.5-.2v.6l-3.2-1.2-.1 1.2-1.3.5-.7-1.2-1.7-.6-1.9-1 .1-2.8.9-.8-1-1.1-.4-3.5-.9-1-3.4-.7-3.4-1.7 2.1-4.1 3.9-3.4 1.1-4.6 3.6 2 4.6.3-2.8-3.4 6.4-2.7v-3.6l5.5 3.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KP",
            })}
            id="KP"
          />
          <path
            d="m662.5 631.4 2 3.5.4 8.7 5.9 1.3 2.2-1.3 3.9 1.8 1.2 1.9 1.1 5.9.8 2.4 2.1.3 2-1 2.1 1.1.3 3.6-.3 3.8-.7 3.7-.3 5.6-4.3 5-4.2 1-6.3-1-5.8-1.7 4.2-9.8-1.1-2.8-5.9-2.5-7.3-4.8-4.6-1-11.3-10.4 1.5-7.7-.2-3.5 2.1-5.6 9.6-1.9 5.2.1 5.4 3.3.3 2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PY",
            })}
            id="PY"
          />
          <path
            d="m1178.3 293.8.4 4-.6 1.9-2.5.8.1-1.7 1.3-.9-1.5-.7.7-4.2 2.1.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PS",
            })}
            id="PS"
          />
          <path
            d="m1270.1 343.7-1.5.5-1.8-1.3-.8-4.7 1.1-3.3 1.5-.7 1.8 2 .5 3.7-.8 3.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "QA",
            })}
            id="QA"
          />
          <path
            d="m1118.9 193.1 1.6.7 1.8 1.8 2 2.6 3.4 3.8.6 2.7-.2 2.7 1.3 2.9 2.4 1.2 2.3-1.1 2.4 1.1.4 1.7-2.3 1.3-1.6-.6-.4 7.7-3.1-.7-4-2.3-5.9 1.5-2.3 1.6-7.6-.4-4-.9-1.9.4-1.8-2.6-1-1.1 1-1.1-1.3-.7-1.5 1.4-3.1-1.9-.7-2.6-3.2-1.4-.8-2.1-3-2.4 3.9-1.2 2.6-4.3 1.9-4.2 2.9-1.3 2-1.4 3.2.7h3.2l2.5 1.6 1.6-1 3.6-.6 1-1.5h2.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "RO",
            })}
            id="RO"
          />
          <path
            d="m1158.8 509.1 2.2 3.6-.3 3.8-1.6.8-3.1-.4-1.7 3.7-3.5-.5.6-3.6.8-.5.2-3.8 1.6-1.8 1.4.7 3.4-2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "RW",
            })}
            id="RW"
          />
          <path
            d="m938.9 324.3-.1.4-.1 1.2-.2 9.8-18-.4-.2 16.5-5.2.5-1.5 3.3.9 9.3h-21.7l-1.3 2.1.3-2.7h.1l12.5-.5.7-2.3 2.4-2.9 2-8.9 7.9-6.9 2.7-8.1 1.8-.5 1.9-5 4.6-.7 2 .9h2.5l1.8-1.5 3.4-.2-.1-3.4h.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "EH",
            })}
            id="EH"
          />
          <path
            d="m1240.5 315 5 .6 1.7 3.1 3.9-.2 2.7 5.6 2.9 1.4 1.2 2.3 4 2.7.7 2.6-.4 2.2.9 2.1 1.8 1.8.9 2.1 1 1.6 1.8 1.3 1.5-.5 1.3 2.5.3 1.4 2.7 6.6 16.9 3.2 1-1.4 3 4.6-2.6 12.8-16.3 6.4-15.9 2.5-5 2.9-3.5 6.7-2.6 1.1-1.5-2.1-2.1.3-5.5-.7-1.1-.6-6.4.1-1.5.6-2.4-1.6-1.3 3.1.8 2.7-2.4 2.1-.9-2.8-1.8-1.9-.5-2.6-3.1-2.3-3.3-5.4-1.9-5.2-4.1-4.4-2.5-1.1-4.1-6.1-.9-4.4v-3.8l-3.6-7.2-2.8-2.5-3-1.3-2.1-3.7.2-1.4-1.8-3.4-1.7-1.4-2.5-4.8-3.8-5.1-3.1-4.4h-2.7l.5-3.5.1-2.3.4-2.6 6.2 1.1 2.1-2 1.1-2.3 4.1-.9.7-2.2 1.6-1-6-6.5 10.4-3.2.9-1 6.8 1.8 8.6 4.5 16.8 12.9 10.2.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SA",
            })}
            id="SA"
          />
          <path
            d="m1191 409.2-.7 5.5-2 6.4-3.3 3.1-2.3 5-.5 2.6-2.6 1.8-1.5 6.7v.8l-.8-.2.1-3.2-.8-2.2-2.9-2.5-.9-4.6.6-4.8-2.6-.4-.4 1.4-3.4.4 1.5 1.8.5 3.9-3 3.5-2.7 4.6-2.9.7-4.8-3.7-2.1 1.3-.5 1.8-2.9 1.3-.2 1.3h-5.6l-.8-1.3-4.1-.3-2 1.1-1.6-.5-2.9-3.8-1-1.7-4.1.9-1.5 2.9-1.3 5.8-2 1.2-1.7.7-.5-.3-1.9-1.9-.4-2 .8-2.6V437l-3.3-4-.7-2.7v-1.6l-2.1-1.9-.1-3.7-1.3-2.5-1.9.4.5-2.4 1.4-2.6-.7-2.7 1.8-2-1.2-1.5 1.3-3.9 2.5-4.8 4.8.5-1.1-25.5v-2.7h6.4l-.5-12.8h65.9l2.1 6.3-1.2 1.1 1.2 6.7 2.5 7.6 2.2 1.6 3.2 2.4-2.7 3.6-4 1.1-1.7 2-.3 4.2-2 9.5.7 2.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SD",
            })}
            id="SD"
          />
          <path
            d="m1178.1 441.1.2 5-.8 1.9-3 .2-1.9 3.6 3.5.5 3 3.1 1 2.6 2.6 1.5 3.5 7-3.8 4.2-3.4 3.8-3.5 3h-4l-4.5 1.5-3.6-1.5-2.3 1.8-5.1-4.3-1.4-2.7-3.1 1.3-2.6-.4-1.5 1.1-2.6-.8-3.5-5.3-.9-2-4.3-2.6-1.4-3.8-2.4-2.8-3.9-3.3-.1-2.1-3.1-2.6-3.9-2.5 1.7-.7 2-1.2 1.3-5.8 1.5-2.9 4.1-.9 1 1.7 2.9 3.8 1.6.5 2-1.1 4.1.3.8 1.3h5.6l.2-1.3 2.9-1.3.5-1.8 2.1-1.3 4.8 3.7 2.9-.7 2.7-4.6 3-3.5-.5-3.9-1.5-1.8 3.4-.4.4-1.4 2.6.4-.6 4.8.9 4.6 2.9 2.5.8 2.2-.1 3.2.8.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SS",
            })}
            id="SS"
          />
          <path
            d="m918 408 .2 4 1.1 3.7 2 1.8.5 2.4-.3 2-.8.4-3.1-.5-.4.7-1.2.1-4.1-1.5-2.7-.1-10.4-.3-1.5.8-1.9-.2-3 1-.8-4.9 5.1.1 1.4-.9h1l2.1-1.5 2.4 1.3 2.4.2 2.5-1.5-1.1-1.8-1.9 1h-1.7l-2.2-1.6-1.8.1-1.3 1.6-6.1.1-2.3-5-2.7-2.2 2.5-1.3 2.8-4.5 1.4-3.3 2-2 2.7.5 2.8-1.4h3.1l2.7 1.8 3.6 1.7 3.4 4.8 3.6 4.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SN",
            })}
            id="SN"
          />
          <path
            d="m928.5 447.9-2.6 3-2.6 3.4-.3 1.9-1.4 2.1-1.5-.5-4-2.6-3-3.4-.9-2.4-.7-4.7 3.1-2.9.6-1.7 1-1.4 1.6-.2 1.3-1.2h4.5l1.6 2.3 1.2 2.7-.2 1.9.9 1.7-.1 2.3 1.5-.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SL",
            })}
            id="SL"
          />
          <path
            d="m492.5 415.9-.7 1.5-3.3-.1-2-.6-2.2-1.3-3-.4-1.5-1.4.3-.9 2-1.6 1.2-.7-.3-.8 1.4-.4 1.6.6 1.1 1.2 1.6 1.1.1.8 2.5-.7 1.2.4.7.7-.7 2.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SV",
            })}
            id="SV"
          />
          <path
            d="m1102 218.2-1.1 1.4.7 2.4 2.8 2.7-1.8 2-.6 2 .6.8-.7.8-2.4.2-1.7.3-.3-.5.6-.7.4-1.6-.7.1-1.1-1.2-.9-.3-.8-1-1-.4-.8-.9-.9.4-.5 2.1-1.2.4.4-.5-2.1-1.3-1.7-.7-.9-.9-1.4-1.1 1.1-.3.5-2.9-2.7-2.5 1.1-2.8-1.9.1 1.7-2.4-1.7-1.8-1.5-2.5 3.7-1.6 3.2.3 3 2.4.8 2.1 3.2 1.4.7 2.6 3.1 1.9 1.5-1.4 1.3.7-1 1.1 1 1.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "RS",
            })}
            id="RS"
          />
          <path
            d="m681 464.9-3.1 5.5.3 4.4 2.2 3.8-1.1 2.7-.5 3-1.5 2.7-3.2-1.4-2.7.7-2.3-.6-.6 1.9 1 1.2-.6 1.4-3.1-.6-3.3-5.6-.7-3.6H660l-2.4-4.6 1.1-3.4-.3-1.5 3.5-1.6 1-5.8 6.8 1.3.6-1.2 4.6-.5 6.1 1.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SR",
            })}
            id="SR"
          />
          <path
            d="m1098.1 187.7-1.2 1.7-.7 2.5-1 .6-5.5-1.9-1.6.4-1 1.5-2.3.8-.6-.4-2.3.9-1.9.2-.3 1.3-4.1.7-1.9-.6-2.7-1.7-.7-2.1.3-.8.6-1.4 2.2.1 1.6-.6.1-.6.9-.3.2-1.4 1.1-.3.7-1.1h1.5l.3.4 1.9-.9 2.7 2.2 2.8-1.3 2.4.6 3.5-.9 5 2.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SK",
            })}
            id="SK"
          />
          <path
            d="m1069.8 203.9-3.9 1.7-.3 2.5-1.7.7.1 1.7-2-.1-1.8-1-.8 1-3.6-.2 1.1-.5-1.4-2.7.4-3.1 4.2.5 2.4-1.5 4.4-.1.9-1.1.8.1 1.2 2.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SI",
            })}
            id="SI"
          />
          <path
            d="m1088.2 87-7 1.6-3.5 3.9 1.3 3.5-6.2 4.5-7.8 5-2.1 8.1 3.7 4.1 4.8 3.3-3.3 6.6-4.6 1.4-.6 10-2.1 5.7-5.7-.6-2.2 4.8-5.5.3-1.9-5.7-4.5-6.9-4.2-8.4 1.8-3.4 3.4-4 .8-6.9-3.1-2.9-1-7.7 2.4-5.4 4.3.1 1.3-2.2-1.8-2 5.7-7.9 3.4-6.1 2.3-3.9h4l.6-3.1 8 .9-.1-3.6 2.6-.2 6 2.7 7.2 3.7 1.8 8.5 1.8 2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SE",
            })}
            id="SE"
          />
          <path
            d="m1161.7 667.7.6 2.9.3 2.9-1.4 2.8-3.2.7-3.1-3.5.1-2.2 1.7-2.4.6-1.9 1.7-.4 2.7 1.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SZ",
            })}
            id="SZ"
          />
          <path
            d="m1195 287.5-9.7 6.9-6.3-2.6h-.1l.6-1-.4-2.6.9-3.5 2.7-2.5-1.2-2.5-2.5-.3-1.1-4.9 1-2.7 1.3-1.4 1.2-1.4-.2-3.5 1.9 1.2 5.6-1.8 3 1.2h4.4l5.7-2.4 2.9.1 5.9-1-2.1 4-2.7 1.6 1.2 4.7-1 7.7-11 6.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SY",
            })}
            id="SY"
          />
          <path
            d="m1119.2 376.1 1.1 25.5-4.8-.5-2.5 4.8-1.3 3.9 1.2 1.5-1.8 2 .7 2.7-1.4 2.6-.5 2.4 1.9-.4 1.3 2.5.1 3.7 2.1 1.9v1.6l-3.6 1.1-2.8 2.6-4 7-5.2 3-5.5-.4-1.6.6.6 2.2-2.9 2.3-2.4 2.5-7.1 2.4-1.4-1.4-1-.2-1 1.7-4.6.5.8-1.8-1.8-4.4-.8-2.6-2.5-1.1-3.4-3.8 1.2-3 2.6.6 1.6-.4h3.2l-3.2-5.8.2-4.3-.5-4.2-2.3-4.1.6-3.1-3.7-.1V412l-2.4-2.4 2.3-8.5 7-6 .2-8.4 1.8-13 1.2-2.8-2.4-2.2-.1-2-2.2-1.7-1.6-10 5.5-3.5 22.5 12.3 22.6 12.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TD",
            })}
            id="TD"
          />
          <path
            d="m991.4 431.2-.7 3.4 1.7 1.9 2 2.2.2 3.2 1.2 1.3-.3 14.8 1.4 4.4-4.5 1.4-1.3-2.3-1.5-4.1-.5-3.2 1.3-5.7-1.4-2.4-.6-5v-4.7l-2.3-3.3.4-2 4.9.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TG",
            })}
            id="TG"
          />
          <path
            d="m1577.5 410.2-5.3-.9-7.1 1.2-3.1 5.3 2.1 7.8-5.3-3-4.8.2.3-5.1h-4.9l.2 7.1-2.2 9.4-1.4 5.7.7 4.6 3.7.2 2.7 5.9 1.3 5.5 3.4 3.7 3.4.7 3.1 3.4-1.7 2.6-3.7.8-.6-3.3-4.8-2.8-.9 1.1-2.3-2.4-1.2-3.2-3.2-3.6-2.9-3.1-.7 3.8-1.3-3.6.4-4 1.2-6.1 2.2-6.6 2.6-6-2.7-5.9-.2-3-1-3.6-4.3-5.1-1.8-3.2 1.8-1.2 1.4-5.5-2.9-4.3-4.1-4.7-3.5-5.6 2.2-1.2 1.5-6.9 3.9-.3 2.8-2.8 3-1.5 2.7 2 .9 3.9 3.8.3-.4 6.7 1 5.8 5.3-3.8 1.9 1.1 3.2-.2.8-2.2 4.3.4 5 5.2 1.3 6.4 5.3 5.6.4 5.4-1.5 2.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TH",
            })}
            id="TH"
          />
          <path
            d="m1357 243.6-1.4 1.9-6-1 .6 3.6 5.5-.5 7.1 2.1 9.6-1 3.1 6 1.5-.7 3.7 1.5.5 2.5 1.8 3.6h-5.4l-3.8-.5-2.5 2.9-2.2.6-1.5 1.4-2.7-2.1-.9-5.4-1.7-.3.1-2-3.3-1.4-1.7 2.2.2 2.6-.6.9-3.2-.1-.9 2.9-2.1-1.2-3.4 2-1.8-.7 1.3-6.5-2.4-4.8-4.2-1.5.6-2.8 4.4.3 1.5-3.5.5-4.1 6.5-1.5-.2 3 1.3 1.7 2.1-.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TJ",
            })}
            id="TJ"
          />
          <path
            d="m1338.3 262-1.6-.2-2.9-1.7-.3 2.2-4.2 1.3.2 5.1-2.6 2-4 .9-.4 2.9-3.9.9-5.9-2.5-1.7-5.3-4-.3-7.3-5.6-4.3-.7-6.6-3.3-3.9-.6-2 1.2-3.6-.2-3 3.7-4.4 1.2-1.9-4.5-.6-6.7-4.6-2.2.4-4.3-3.5-.4-.1-5.4 5.3 1.6 4.1-2-4.7-3.9-2.4-3.6-3.8 1.6.6 4.7-2.6-4.1 1.8-2.2 5.6-1.3 3.9 1.8 4.8 5 2.6-.3 5.9-.1-1.7-3.2 3.8-2.2 3.4-3.7 7.9 3.4 1.9 5 2.3 1.3 5.5-.3 2.1 1.2 4.3 6.6 7.1 4.4 4.2 3 6.3 3.1 7.7 2.8.8 3.9z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TM",
            })}
            id="TM"
          />
          <path
            d="m1692.7 562.1.1-1.9-.5-1.3.8-1.5 4.9-1.4 4-.3 1.8-.8 2.1.8-2.2 1.8-6.1 2.8-4.9 1.8z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TL",
            })}
            id="TL"
          />
          <path
            d="m1048.2 289.1-.1 4.9-2.6 1.8-1.6 2.1-3.6 2.5.6 2.6-.4 2.8-2.6 1.4-2.6-11.5-3.4-2.6-.1-1.5-4.5-3.9-.6-4.8 3.2-3.6 1.1-5.3-1-6.1 1-3.3 5.7-2.5 3.7.7v3.3l4.4-2.4.4 1.2-2.5 3.2.1 2.9 1.9 1.6-.5 5.6-3.5 3.2 1.2 3.5 2.8.1 1.4 3.1 2.1 1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TN",
            })}
            id="TN"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TR",
            })}
            d="m1201.7 235.3 5.5-.3 5.6 3.2 1.3 2.2.1 3.1 4.2 1.6 2.4 1.8-3.3 1.9 2.9 7.3-.7 2 3.8 5.1-2.4 1.1-2.1-1.6-6.3-.9-2.1 1-5.9 1-2.9-.1-5.7 2.4h-4.4l-3-1.2-5.6 1.8-1.9-1.2.2 3.5-1.2 1.4-1.3 1.4-2.3-2.9 1.7-2.4-3.2.6-4.6-1.5-3.2 3.7-8 .7-4.7-3.4-5.7-.2-1 2.6-3.6.8-5.4-3.4-5.8.1-3.8-6.4-4.2-3.5 2-5-3.6-3.1 5.1-6.1 8-.2 1.6-4.9 10 .9 5.6-4.1 5.8-1.8 8.5-.2 9.8 4.5 7.9 2.5 5.8-1 4.6.6 5.5-3.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TR",
            })}
            d="m1121.9 239.9 1.2-.7 1.1-4-2.7-1.7 5-2 4.6.8.9 2.5 4.8 2-.7 1.6-6.2.3-2 2-3.9 3.4-2-2.9-.1-1.3Z"
          />
          <path
            d="m1657.9 355.5-1.4 5.3-4-5.5-1.5-4.7 1.9-6.3 3.3-4.9 3 1.9-.1 3.9-1.2 10.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TW",
            })}
            id="TW"
          />
          <path
            d="m1167 508.4-.2 3.9-1.1 4.5 1.6 2.5 2.5-1.5 3.3-.4.7.8 3.3-1.6-2.3-2.2 1.9-2.9 2.8-2.9 20.5 13.1.3 3.7 8.1 6.4-2.8 8 .3 3.6 3.5 2.3.2 1.7-1.7 3.9.3 1.9-.4 3.1 1.8 4 2.2 6.4 2 1.4-4.6 3.7-6.2 2.5-3.4-.1-2.1 1.9-3.9.2-1.5.8-6.7-1.8-2.2.2.1-.1-1.8-2.4-.3-6.8-2.9-3.4-.4 1.2-1-1.7-5.5-1.2-3.2-1.9-3.6-1.1-2.2-1.1-.3-.2-2.7-6.6-.4-3.9-4.5-4.4 1.4-2.4-1.1-2.6.2-2.7-1-.9.3-2.8.6-.1 2-2.3 2.3-3.4 1.4-1.3v-2.1l-1.2-1.5-.3-2.5 1.6-.8.3-3.8-2.2-3.6 2-.8 6.2.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TZ",
            })}
            id="TZ"
          />
          <path
            d="m1179 474.5 2.7 4.5.7 3.2 2.6 7.4-2.1 4.7-2.8 4.2-1.6 2.6v.3l-.2-.4-3-1.3-2.4 1.6-3.6.9-2.6 3.7.3 2.5-6.2-.1-2 .8-3.4 2-1.4-.7.1-4.8 1.3-2.5.3-5.1 1.2-3 2.2-3.3 2.1-1.8 1.9-2.2-2.3-.9.3-7.5 2.3-1.8 3.6 1.5 4.5-1.5h4l3.5-3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "UG",
            })}
            id="UG"
          />
          <path
            d="m1157.2 174.6 2.3 2.7.1 1.2 6.7 2.2 3.6-1 3.6 2.9 2.9-.1 7.7 2 .4 1.9-1.3 3.2 1.8 3.5-.3 2.1-4.8.4-2.2 1.8.4 2.7-3.9.5-3 2.1-4.6.3-4 2.4 1 3.9 2.8 1.5 5.1-.4-.6 2.3-5.4 1.1-6.3 3.6-3.1-1.3.7-2.9-5.9-1.9.7-1.2 4.6-2.1-1.7-1.4-8.1-1.6-.8-2.4-4.5.8-1.3 3.5-3.3 4.6-2.4-1.1-2.3 1.1-2.4-1.2 1.2-.7.6-2.1 1.1-2.1-.6-1.1 1-.5.6.9 3 .2 1.3-.5-1-.6.2-1-2-1.6-1.1-2.6-2-1 .1-2.1-2.6-1.7-2-.3-4-1.9-3.2.6-1.1.9h-2.1l-1 1.5-3.6.6-1.6 1-2.5-1.6h-3.2l-3.2-.7-2 1.4-.5-1.7-3-1.7.7-2.5 1.2-1.7 1.1.4-1.6-2.8 3.8-5.2 2.3-.7.3-1.7-3.2-5.4 2.3-.3 2.4-1.6 3.8-.2 4.9.5 5.7 1.5 3.9.1 1.9.9 1.7-1.1 1.5 1.5 4.3-.3 2.1.6-.3-3.1 1.3-1.4 4.1-.3 1.8.2 1-1.4 1.5.3 4.9-.6 3.8 3.5-.9 1.3.8 1.9 3.9.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "UA",
            })}
            id="UA"
          />
          <path
            d="m699.7 718.6-1.6 4.1-5.4 3.5-4.2-1.3-2.8.7-5.5-2.7-3.6.2-3.9-3.6-.4-4.1.9-1.4-1.2-6.4.4-6.6.5-5.2 3.4-.7 6.3 5 1.9-.2 6.3 4.1 4.8 3.6 3.8 4.3-1.8 3.1 2.1 3.6z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "UY",
            })}
            id="UY"
          />
          <path
            d="m1352.7 230.7 1.7.6-3 4.1 4.6 2.4 3.2-1.6 7.2 3.4-5.3 4.6-4.1-.6-2.1.1-1.3-1.7.2-3-6.5 1.5-.5 4.1-1.5 3.5-4.4-.3-.6 2.8 4.2 1.5 2.4 4.8-1.3 6.5-4.3-1.4h-3l-.8-3.9-7.7-2.8-6.3-3.1-4.2-3-7.1-4.4-4.3-6.6-2.1-1.2-5.5.3-2.3-1.3-1.9-5-7.9-3.4-3.4 3.7-3.8 2.2 1.7 3.2-5.9.1-6.2-23.4 12-3.7 1.1.5 9.2 4.5 4.8 2.4 6.6 5.7 5.7-.9 8.6-.5 7.6 4.6 1.5 6.4 2.6.1 2.5 5.2 6.7.2 2.3 3h2l.9-4.6 5.4-4.4 2.6-1.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "UZ",
            })}
            id="UZ"
          />
          <path
            d="m648.7 448.1-4.7 3.8-.5 2.3 1.8 2.4-1.4 1.2-3.5 1v3l-1.6 1.8 3.7 4.8.7 1.8-2.1 2.5-6.4 2.4-4.1 1-1.7 1.5-4.5-1.6-4.1-.8-1.1.6 2.5 1.6-.3 4.3.7 4.1 4.8.5.3 1.4-4.1 1.8-.7 2.7-2.4 1.1-4.2 1.5-1.1 2-4.4.4-3.1-3.4-1.6-6.4-1.5-2.3-2-1.4 2.9-3.2-.2-1.4-1.5-1.9-1.1-4.3.6-4.6 1.3-2.2 1.2-3.4-2-1.1-3.2.7-4.1-.3-2.3.7-3.8-5.6-3.3-.8-7.3.6-1.2-2.2-1.4-.5-.1-1.4.7-2.4-.3-2.5-1.2-1.5-.6-2.9-2.9-.4 1.8-3.8.9-4.6 1.8-2.4 2.3-1.8 1.6-3.2 3.7-1.1-.2 1.5-3.4.8 1.7 2.9-.3 3.4-2.7 3.7 1.9 5.1 2.5-.4 1.5-4.7-1.7-2.2v-4.9l7.2-2.6-.6-3 2.1-2.1 1.7 4.6 4 .1 3.4 3.5.2 2.2h5l6.1-.6 3.1 2.8 4.2.8 3.3-2 .1-1.6 7.1-.4 6.7-.1-4.9 1.9 1.8 3.1 4.5.4 4.2 3.2.7 5.1 2.9-.1 2.2 1.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VE",
            })}
            id="VE"
          />
          <path
            d="m1586.5 363.5-6.5 5.4-3.7 6.1-.6 4.5 5.3 6.7 6.5 8.4 5.7 4 4.1 5.1 4 11.9.4 11.3-4.3 4.2-6.1 4.2-4.2 5.3-6.6 6-2.3-4.1 1.2-4.4-4.4-3.6 4.6-2.6 5.9-.5-2.8-3.8 9-5-.1-7.7-1.8-4.3.2-6.4-2-4.5-4.9-4.5-4.4-5.6-5.7-7.6-7.3-3.9 1.2-2.3 3.3-1.7-3-5.6h-6.8l-3.5-5.8-4-5.1 2.7-1.6 4.4.1 5.3-.8 4.1-3.4 3.1 2.4 5.3 1.2-.3 3.7 3.1 2.6 5.9 1.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VN",
            })}
            id="VN"
          />
          <path
            d="m1283.8 394.9-4 1.7-.9 2.9v2.2l-5.4 2.7-8.8 3-4.7 4.5-2.5.4-1.7-.4-3.2 2.7-3.5 1.2-4.7.3-1.4.4-1.1 1.7-1.5.5-.8 1.6-2.8-.2-1.7.9-4-.3-1.6-3.8v-3.5l-1-1.9-1.3-4.7-1.8-2.6 1.1-.4-.7-2.9.6-1.2-.4-2.8 2.4-2.1-.8-2.7 1.3-3.1 2.4 1.6 1.5-.6 6.4-.1 1.1.6 5.5.7 2.1-.3 1.5 2.1 2.6-1.1 3.5-6.7 5-2.9 15.9-2.5 5.2 10.6 2.2 4.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "YE",
            })}
            id="YE"
          />
          <path
            d="m1162.1 556.8.3.2 2.2 1.1 3.6 1.1 3.2 1.9 2.6 2.9 1.3 5.4-1 1.7-1.3 5.2.9 5.4-1.8 2.2-2 6 2.9 1.6-17.2 5.3.4 4.6-4.3.9-3.3 2.5-.8 2.2-2 .6-5.1 5.2-3.2 4.2-1.9.1-1.8-.7-6.2-.7-1-.5v-.5l-2.2-1.5-3.6-.3-4.6 1.4-3.6-4-3.6-5.2.8-20.5 11.7.1-.4-2.2.9-2.4-.9-3 .7-3.1-.6-2 1.9.1.3 2 2.7-.1 3.5.6 1.9 2.9 4.4.9 3.5-2 1.2 3.3 4.3.9 2 2.8 2.2 3.5h4.3l-.2-6.9-1.6 1.2-3.9-2.5-1.5-1.2.9-6.4 1.1-7.6-1.2-2.8 1.7-4.1 1.5-.8 7.7-1.1.9.3-.3 1.4 1.9.5 1.2 1.3 1-.3-.5-1.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ZM",
            })}
            id="ZM"
          />
          <path
            d="m1159.4 644.7-2.9-.7-1.9.8-2.7-1.1h-2.2l-3.4-2.9-4.3-1-1.5-4.1.1-2.3-2.3-.7-6.1-7-1.6-3.7-1.1-1.2-1.9-5.1 6.2.7 1.8.7 1.9-.1 3.2-4.2 5.1-5.2 2-.6.8-2.2 3.3-2.5 4.3-.9.2 2.4 4.7-.1 2.6 1.3 1.1 1.6 2.7.5 2.8 2-.4 8.2-1.3 4.4-.4 4.8.8 1.9-.9 3.8-.8.6-1.7 4.6-6.2 7.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ZW",
            })}
            id="ZW"
          />
          <path
            d="m1222.1 512.6-3.3-5.3-.2-23.4 4.9-7.2 1.5-2.1 3.6-.1 5-4.5 7.3-.3 15.6-19.3-4.8.1-18.7-7.6-2.2-2.3-2.2-3.1-2.2-3.6 1.2-2.2 1.9-3.5 1.9 1.2 1.2 2.7 2.7 2.7h2.8l5.2-1.7 6.1-.7 4.9-2 2.8-.4 2-1.2 3.2-.2 1.8-.2 2.5-.9 3-.7 2.5-2.2h2.2l.2 1.8-.4 3.7.2 3.4-1.1 2.3-1.4 7-2.4 7.1-3.3 8.2-4.6 9.4-4.7 7.2-6.6 8.8-5.6 5.2-8.4 6.4-5.3 4.8-6.2 7.8-1.3 3.4-1.3 1.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SO",
            })}
            id="SO"
          />
          <path
            d="m1097.8 230.8-1.2.3-2.9 1-.1 1.3-.7-.1-.6-2.3-1.3-.7-1.2-1.7.8-1.4 1.2-.4.5-2.1.9-.4.8.9 1 .4.8 1 .9.3 1.1 1.2.7-.1-.4 1.6-.6.7.3.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "XK",
            })}
            id="XK"
          />
          <path
            d="m1159.4 644.7 2.2 9 1.1 4.6-1.4 7.1.4 2.3-2.7-1.1-1.7.4-.6 1.9-1.7 2.4-.1 2.2 3.1 3.5 3.2-.7 1.4-2.8h4.1l-1.7 4.7-1 5.3-1.7 2.9-4 3.3-1.1.9-2.6 3.3-1.8 3.3-3.5 4.6-6.7 6.6-4.1 3.8-4.3 3-5.9 2.4-2.7.4-.9 1.8-3.2-1-2.7 1.2-5.7-1.2-3.3.8-2.2-.4-5.8 2.6-4.6 1-3.5 2.4-2.4.2-2.1-2.3-1.8-.1-2.2-2.9-.3.9-.6-1.7.3-3.8-1.5-4.3 1.8-1.2.1-4.9-3.3-6-2.4-5.4v-.1l-3.6-8.3 2.8-3.2 2 1.8.8 2.7 2.5.5 3.4 1.2 2.9-.5 5-3.3 1.1-23.7 1.4 1 3 6.1-.6 3.9 1.1 2.3 4-.7 2.8-2.9 2.7-1.9 1.5-3.1 2.8-1.4 2.3.7 2.5 1.8 4.5.3 3.6-1.4.6-2 1.2-3.1 3-.5 1.8-2.4 2-4.3 5.2-4.8 8.1-4.7h2.2l2.7 1.1 1.9-.8 2.9.7zm-20.3 53.2 1.1-2 3.1-1 1.1-2.1 1.9-3.1-1.7-2-2.2-2-2.7 1.4-3.1 2.5-3.2 4 3.7 5 2-.7z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ZA",
            })}
            id="ZA"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NZ",
            })}
            d="m1886.2 764.4-.8 2.6 5.6-2.6-.5 2.7-2.1 2.7-4.2 2.9-7.1 4.7-4.7 2.6-.6 3-4 .1-6.3 2.4-4.7 4.1-8.2 6.4-6.3 2.8-4 1.8-4.6-.1-1.5-2.1-5.1-.4 1-2.4 6.5-4.6 11.4-6.3 4.3-1.2 5.6-2.4 7-3.3 5.7-3.3 6-4.7 3.1-1.6 3.5-3.6 5.8-2.9-.8 2.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NZ",
            })}
            d="m1915.2 733.9-.4 6.8 2.9-4.4 1.3 1.8-2.4 4.8 2.9 2.1 3.2.5 4.7-2.4 2.2.7-5.2 5.7-4.2 3.7-3.9-.1-2.8 1.9-1.5 2.8-1.6 1.1-4.6 3.5-5.9 4.3-6 2.6.5-1.7-1.5-.9 6.9-5.2.9-3.6-3.8-2.5 1.8-2.3 5.3-2.2 4.2-5 2.5-4.1.6-4.3.8-1.1-.9-2.7-.7-5.6.4-4.6 2.2-.5.9 3.6 3.2 1.6-2 5.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CL",
            })}
            d="m655.1 837.9 6 13.6h5l3 .2-.5 2.4-3.2 1.9-2.4-.2-3.1-.5-4.2-1.8-5.4-.9-7.5-3.4-6.4-3.2-9.8-6.9 4.6 1.3 8.6 4.1 7.3 2.2 1.2-2.8-.3-4.2 3.4-2.6 3.7.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CL",
            })}
            d="m614.4 647.8.9 1.6-1.2 6.7-5.6 3.1 1.6 10.7-.8 2.1 2 2.5-3.3 4-2.6 6-.9 5.9 1.7 6.2-2.1 6.6 4.9 11.1 1.6 1.2 1.4 5.9-1.6 6.2 1.4 5.4-3 4.2 1.6 5.8 3.3 6.3-2.5 2.3.2 5.7.8 6.5 3.3 7.8-1.7 1.3 3.7 7.3 3.1 2.4-.8 2.7 2.8 1.2 1.4 2.4-1.8 1.2 1.8 3.7 1.1 8.3-.7 5.4 1.8 3.2-.1 3.9-2.7 2.8 3.1 6.5 2.6 2.3 3.1-.4 1.9 4.6 3.5 3.6 12.1.8 4.9 1h-4.3l-1.7 1.5-3.4 2.2 1.7 5.7-1.9.1-6.3-1.9-7.5-4.3-7.6-3.5-3.2-3.9-.3-3.6-4.2-4.2-5-10.6-.2-6 3.4-4.8-8.3-1.9 2.7-5.5-2-10.5 6.5 2.2-1.8-13.1-4-1.7 1 7.9-3.5-.9-1.5-9-2-11.8 1.1-4.4-3.3-6.2-2.4-7.2 2.2-.3.6-10.3 1.2-10.3.1-9.5-3.3-9.7.6-5.3-2.1-7.9 1.8-7.8-.9-12.4v-13.4l.1-14.3-1.5-10.5-2.1-9.1 2.8-1.6 1.1-3.3 3.2 4.4 1.2 4.6 3.2 2.7-1.1 6.2 3.7 7.2 3.1 8.9 3.9-.9Z"
          />
          <path
            d="m1016.5 177.1-2.8-1.5-3.1-2.7-4.5 1.3-3.6-.5 2.5-1.7 4-9 6.5-2.6 4 .2.9 2.1-.9 5.6-1.2 2.3h-2.9l1.1 6.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NL",
            })}
            id="NL"
          />
          <path
            d="m946.9 263.7-2.2 1.6-2.8-.9-2.7.7.9-5-.3-3.9-2.4-.6-1.1-2.4.5-4.2 2.2-2.3.5-2.6 1.2-3.8v-2.7l-.9-2.3-.2-2.2 1.9-1.6 2.2-.9 1.2 3.1h3l.9-.8 3.1.2 1.3 3.2-2.4 1.7-.3 5-.8.9-.3 3.1-2.3.5 2 3.8-1.6 4.2 1.8 1.9-.8 1.7-2 2.4.4 2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PT",
            })}
            id="PT"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1689.5 177.4 13.7 11-8.9-2 3.7 9 9.6 6.4 3 4.4-6.5-3.8.1 4.9-4.7-5.3-3.8-6.1-5.6-6.7-2.4-4.8-6.4-8.2-8-6.1-6.8-8.4 1.9-2.8-4.4-2.8 1.3-.9 4.9 4 6.9 5.9 5.2 6.1 7.2 6.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1094.6 155.4-8.8.1-5.9-.7.7-2.6 6.3-2 5.1 1.1 2.2.9-.2 1.7.6 1.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1548.4 48.2-5.9.1-8.9-.6-1-.3.7-2 4.2-.5 8.4 2 2.5 1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1561 38.7-1.1 2-6.9-.4-10.3-2-1.8-1.6 8.3.7 11.8 1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1535.5 36.3 3.1 3.8-14.3-.2-4.6 1.2-12.5-3.3-3.4-3.4 3.5-.9 10.2.2 18 2.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1218.8 61.3-2.2.4-13.5-.7-2.3-2.3-7.9-1.4-2-2.9 3.5-1.1-1.6-2.8 5.4-4.4-4-.6 6.7-4.5-2.5-2.3 6.8-2.6 10.3-3.2 11.7-.9 5-1.8 6.7-.6 4.2 1.9-1.3 1.5-11.4 2.5-9.9 2.3-8.7 4.8-2.8 5-3.3 5 3.1 4.3 10 4.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1661.7 231-1.4-1.1-1.9-3.3 2.5-.1-3.9-7.5-4.7-5.4 2.9-2.2 6.9 1.1-.6-6.2-2.8-6.8.3-2.3-1.3-5.7-6.9 1.9-2.6 2.4h-7.6l-6-5.8-9-4.5-10-2-6.2-6-4.5-3.8-3.8-2.7-7.7-6.2-6-2.2-8.6-1.9-6.2.2-5.1 1.1-1.7 3.1 3.7 1.4 2.5 3.4-1.3 2 .2 6.5 1.9 2.8-4.4 3.9-7.4-2.4-5.6.6-3.9-2.1-3.4-.7-4.4 4.4-5.9 1-3.6 1.6-6.8-1h-4.6l-4.9-3.2-6.6-2.9-5.4-.9-5.7.8-4 1.2-8.5-2.6-3.6-4.6-6.7-1.6-4.8-.8-7-2.5-1.3 6.4 4 3.6-2.4 4.4-8-1.6-5-.2-4.8-2.9-5.2-.1-5.3-1.9-5.9 2.9-6.7 5.3-4.7 1.1-1.7.5-4.4-3.8-6 .9-3.3-2.7-4-1.2-4.1-3.6-3.3-1.1-6.2 1.6-8.4-3.5-1.1 3.2-18.3-15.6-8.4-4.7.8-2-9.2 5.8-4.4.3-1.1-3.3-7.1-2.1-4.3 1.5-4.4-6.3-9.1-1.3-3.1 2.5-10.9 2.3-1.7 1.5-17 2.1-1.4 2.1 5.1 4.2-4 1.6 1.5 1.6-3.5 3 9.4 4.3-.2 2.9-7-.3-.8 1.9-7.3-3.2-7.7.1-4.4 2.6-6.6-2.5-12-4.3-7.6.2-8.1 6.7.6 4.5-6-3.6-2.2 6.9 1.8 1.2-1.7 4.8 5.3 4.2 3.6-.2 4.3 4.2.2 3.2 2.8 1.1-1.4 3.7-4.6 1-3.6 6.5 6 6.1.4 4.2 7.3 7.5-2.5 2.6-.6 1.6-2.4-.5-4.3-3.8-1.5-.2-3.6-1.5-2.1-2.6-5.1-1.3-2.9 1-1.2-1.2-7.6-3.1-7.7-1-4.6-1.1-.4.8-7.6-5.4-6.2-2.4-5.1-3.7 3.6-1 3.2-5.2-3.3-2.5 6.9-2.6-.4-1.4-4.3 1-.4-2.7 2.2-1.8 4.8-.4.3-2.1-1.8-3.5 1.3-3.2-.4-1.9-7.7-2-2.9.1-3.6-2.9-3.6 1-6.7-2.2-.1-1.2-2.3-2.7-3.9-.3-.8-1.9.9-1.3-3.8-3.5-4.9.6-1.5-.3-1 1.4-1.8-.2-2-4-1.5-2 .8-.6 3.9.2 1.6-1.3-1.7-1.6-3.4-1.1v-1.1l-2.1-1.1-3.8-4 .7-1.6-1.1-2.9-4.8-1.4-2.4.7-.9-1.5-5.3-1.5-2.1-3.6-1-2.9-2.5-1.3 1.6-1.9-2.4-5.6 2.6-3.4-.9-1 4.5-3.3-5.4-2.8 8-7.4 3.4-3.4.9-2.9-7.4-3.9.9-3.8-4.9-4.2 1.7-4.8-6.5-6.3 2.9-4.2-7.3-3.7-.4-3.8 3.2-.5 6.4-2.1 3.7-1.9 7.7 3.2 11.7 1.3 17.7 6.2 4.1 2.6 1.5 3.7-3.7 2.9-6.5 1.5-20.2-4.2-2.9.7 8.1 4.1 1 2.6 1.9 5.8 6.1 1.7 3.8 1.5-.2-2.8-3.4-2.4 2.1-2.2 11.6 3.6 3.2-1.4-4.3-4.2 8.1-5.4 4.1.3 4.6 1.9 1.1-3.8-4.7-3.3.8-3.3-4.3-3.4 12.3 1.8 3.6 3-5.1.7 1.2 3.1 4.1 1.9 6-1.2-.4-3.5 7.7-2.7 12.4-4.6 3.2.2-2.5 3.3 5.4.6 2.1-1.9 7.7-.1 5-2.3 6.4 3.3 2.8-3.6-6-3.1 1.2-1.8 13 1.6 6.6 1.7 18.6 6.2 1.1-2.8-5.9-2.9-.8-1.1-5.3-.6-.2-2.5-4.7-4.2-1.1-1.7 4.3-4.7-.6-4.8 2.2-1 11.4 1.4 2.9 2.9-.9 4.2 3.7 1.7 3.8 3.7 3.8 7.4 6.7 3.3.5 3.7-3.5 7.8 5.3.8.5-2 3.8-1.4-.5-2.7 1.9-2.7-4.4-3.1-.4-3.6-4.8-.4-2.9-3-.4-5.4-8.2-4.3 4.7-3.5-3.7-3.7 1.9-.1 4.2 2.8 2.1 5.1 5 1-4.6-3.8 5.1-2.1 8.1-.3 9.6 3-6.9-4.3-4.9-5.5 5.9-1 9.5.2 7.8-.7-5.6-2.6 1.3-3.3 4.2-.2 4.9-2.4 9.3-.7-.2-1.4 9.3-.4 4.3 1.1 5.4-2.6 7 .1-1.5-2.2.9-2 6.2-2 8.3 1.6-3.5 1.2 9.4.7 4.1 2.4 1.9-1.2 10.9.1 11.6 2.4 5.5 1.8 2.5 2.6-2.4 1.5-6.6 2.8-1.1 1.5 5.6.7 7.2 1.3 2.4-1 5.8 3.3.2-1.3 5.2-.8 13.6.8 3.8 2.4 17.4.8-4.8-3.9 9.5.9 6.1-.1 9.9 2.7 6 3.3.4 2.2 10.1 4.2 9 2.1-3-5.5 9.4 2.3 5-1.4 9.8 1.6 1-1.4 7.6.7-9.4-4.9 2.1-2.2 40.4 3.4 7.9 3.1 16.3 4 14.8-1 9.3.9 6.6 2.2 5.1 3.9 7.3 1.5 3.9-1.1 7-.1 9.3 1 6.9-.6 14.3 4.8 2.5-1.7-8.5-3.4-1.8-2.4 15.3 1.5 8-.3 15.8 2.5 9.5 2.4 33.2 22.1-2 2.5-6.2-.4 8.2 3 9.1 4.7 4.2 1.5 3.8 2.4 1 1.5-10-1.2-6.6 4.3-3 .7-1.6 4.1-2 3.6 1.7 2.7-11.5-4.1-6.1 4.6-4.7-2.2-1.4 2.6-7-.9 3.1 3.9 1.1 5.8 2.9 2.4 6.8 1.3 9.1 8.7-4.1.3 3.4 5 4.7 2.6-5 3.1 5.4 7-5.7 1.5 4.5 6.2-1.7 5.8-5.7-4.3-10.5-8.9-16.2-13.6-6.5-8.3.1-3.6-2.8-2.8 5.7-1.3-.2-7.5.7-6 2.5-4.7-6.6-8.2-4.7.5 3.2 4.8-3.6 6.4-12.3-7.2-9.1 2v9.8l7.7 3.6-8.5 1.6-6.4.6-4.3-4.3-8-.9-2.5 2.9-15.1-1-13.2 1.7-3.5 11.7-5 14.2 8.2.8 5.7 3.8 5.8 1.3.4-3 5.6.4 12.8 6.7 4.7 5.2 1.4 6.2 5.5 7.4 5.3 9.9-1 9.1 1.3 4.3-2 7.4-2.1 7.3-.9 3.7-4.6 3.7-3.1.1-5.2-3.1-4.1 4.7.5 2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1367.1 23.1-18.1 1.8-1.3-6.1 2.2-.5 3.1.3 12.6 2.6 1.5 1.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1164.8 13.1-4.3.5-2.9.4v.7l-3.6.7-4.5-1 1.1-1.4-7.8-.1 6.3-.8h5.2l1.5 1.1 1.3-1 2.8-.7 5.8.9-.9.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m1345.1 20.4-7.1.6-11.7-1.3-8.1-1.7-6.6-3.2-5.9-.8 5.4-2.9 6.2-.9 9.6 2 13.7 4.2 4.5 4Z"
          />
          <path
            d="m976.6 223.4 2 2.4 9.5 2.9 1.9-1.4 5.8 2.9 5.9-.8.4 3.7-4.9 4.2-6.6 1.4-.5 2.1-3.2 3.5-2 5.2 2 3.7-3 2.8-1.2 4.2-4 1.3-3.7 4.9-6.8.1-5-.1-3.4 2.2-2.1 2.4-2.6-.5-1.9-2.2-1.4-3.6-4.9-1-.4-2.2 2-2.4.8-1.7-1.8-1.9 1.6-4.2-2-3.8 2.3-.5.3-3.1.8-.9.3-5 2.4-1.7-1.3-3.2-3.1-.2-.9.8h-3l-1.2-3.1-2.2.9-1.9 1.6.5-4.5-2-2.7 7.4-4.6 6.2 1.1h6.9l5.4 1.1 4.3-.4 8.3.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            id="ES"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FR",
            })}
            d="m1035.7 231.4-1.5 4.9-2.4-1.3-1.3-4.2.9-2.4 3.2-2.4 1.1 5.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FR",
            })}
            d="m1014.4 185 1.1.5 1.4-.1 2.4 1.6 7.2 1.2-2.4 4.2-.4 4.5-1.3 1.1-2.3-.6.2 1.6-3.6 3.5v2.9l2.4-1 1.8 2.7-.1 1.8 1.5 2.4-1.7 1.9 1.5 4.9 2.8.8-.5 2.7-4.5 3.6-10.2-1.7-7.4 2.1-.6 3.8-5.9.8-5.8-2.9-1.9 1.4-9.5-2.9-2-2.4 2.7-3.8 1-12.6-5.1-6.6-3.7-3.2-7.6-2.4-.4-4.6 6.5-1.3 8.3 1.6-1.5-7.1 4.7 2.7 11.4-4.8 1.5-5.1 4.2-1.3.8 2.2 2.2.1 2.4 2.5 3.5 2.9 2.5-.5 4.4 2.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m118.8 379.3-1.1 1.1-1.2-.9.6-1.8-.4-2.4.5-.7 1.2-1-.1-1.3.4-.6.4.1 1.9 1.1.9.6.7.8.9 2.3-.2.3-2.5 1.4-2 1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m118.1 369.3-2 .4-.6-1.3-.5-.5v-.4l.7-.6 1.8.6 1.2 1-.6.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m115.1 365.9-.3.7-3-.2.6-.8 2.7.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m110.4 364.9-.4.4-.4-.1-1.9-.2-.3-1.5-.2-.2 1.7-.9.4.4 1.1 2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m102 360.7-.8.6-1.6-1.1.4-.5 1-.6 1.3.1-.3 1.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m539.5 194.5-6.1 2-4.7 2.5-4.6 2.7-.5.9 5.7-1.3 2.1 2.1 4.6-1.5 4.9-2.1 5.4-2.1-3.1 3.3 2.5.8 2.5 2.4 5.1-1.4 5.1-.5.3 1.8 1.5.2 1.2.2 1.5 2.5-4.7.6h-.1l-3.7-.7-4.5 1.2-3.7.6-4.7 4.1-3 2.3.4.7 5.5-4.1h.7l-4.7 4.9-2.9 4.4-2.5 3.6-.6 3.1-.8 1.5-.6 1.7.1 3.3.3.5 1.8-.1 1.6-.7 1.4-.8 3.3-3.1 1.8-4.2-.1-3.9 1.4-2.7 2.6-3.1 2.1-2.2 2.7-1.5-.4 2.1 2.2-3.1 1.3-.6 1.7-2.4 3.8 1.3 2.8 2.4-.8 2.9-1.6 2.9-3.8 2.5-.4 1.6h1l4.3-2.7 1.6.6-.5 3.7-.7 2.6-3.7 3.5-2 2.2-2.7 2.4 2.7 1.3 2.5.4 4-.9 3.7-1.7 3-.9 4.6-1.8 5.8-3.8.1-.6.3-1.9 2.7-.8 3.9.3 4 .5 4.6-2.1.6-2.5-.2-.9 6.8-4.4 2.7-1.1 7.8-.1h9.3l1.1-1.5 1.7-.3 2.5-1 2.8-2.9 3.2-4.9 5.5-4.7 1.1 1.6 3.7-1 1.6 1.8-2.9 8.5 2.2 3.6.2 2.1-6.4 3-6 2.2-6 1.9-4 3.8-1.3 1.4-1.2 3.4.7 3.3 2.1.2.2-2.3 1.1 1.4-1 1.8-3.8 1-2.5-.1-4.2 1.1-2.3.3-3.1.3-5 1.9 8.1-1.2 1.1 1.2-7.9 1.9H601l.4-.8-2.1 1.8 1.4.3-2.5 4.6-5.3 4.9.1-1.7-1.1-.3-1.2-1.6v3.5l1 1.1-.6 2.4-2.4 2.5-4.5 5.1-.4-.2 2.9-4.4-2-2.4 1-5.4-1.9 2.8v4.1l-3.2-1 3 2-1.5 6.1 1.4.5v2.2l-1 6.4-4.6 4.7-6.1 1.9-4.4 3.8-2.8.4-3.4 2.4-1.3 2.1-6.9 4.2-3.8 3.1-3.5 3.8-1.9 4.5v4.5l.6 5.5 1.5 4.5-.5 2.8 1.3 7.4-1 4.4-.6 2.5-2 3.9-1.8.8-2.6-.8-.4-2.8-1.8-1.5-2-5.5-1.6-4.9-.4-2.5 2-4.3-.8-3.5-3.1-5.4-1.9-1-6.1 3-.9-.4-2-3-3-1.6-6.4.9-4.6-.8-4.3.5-2.5 1 .6 1.7-.7 2.6.8 1.3-1.2.8-1.8-.9-2.3 1.2-3.9-.2-3.3-3.4-4.9.8-3.6-1.5-3.5.5-5 1.5-6.1 4.7-6.1 2.8-3.7 3-1.9 2.9-1 4.5-.4 3 .6 2.2-2.2.2-3.6-1.4-3.9-2-.9-3-.2-4.5-2.4-3.6-.9-3.8-1.6-4.4-3.2-2.6-4.5.2-4.8 5-4-1.9-2.3-1.9-.4-3.6-.8-3.3-2.4-2.8-2.1-2.1-1.3-2.3h-9.4l-.8 2.7H384.7l-10.9-4.5-7-3.1.9-1.3-7.1.7-6.3.5.3-3.2-2.1-3.7-2.2-.8.1-1.8-2.9-.4-1.2-1.7-4.8-.6-.9-1.1.8-3.5-2.5-6.4-.5-8.9.9-1.5-1.3-2.1-1.5-5.4 1.8-5.2-.9-3.5 3.9-5.3 2.8-5.4 1.1-4.9 5.5-6 4-5.7 4-5.7 4.3-8.5 1.8-5.3.4-2.9 1.4-1.3 5.8 2.2-1 5.9 2.2-1.7 2.5-5.1 1.6-5.1h137.1l1.3-2.4h1.7l-.9 3.4 1 1 3.3.4 4.6 1 3.9 1.9 4.4-.8 5.4 1.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m275 138.6-7 2.3-.8-1.6 2.3-2.8 6.4-2.1 3.5-.9 2.6.4v1.9l-7 2.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m236 122-3.9.9-1.7-1.1-.8-1.6 5.7-1 3 .6-2.3 2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="m237.2 99.6 1.2 1 3.5-.5 1.6 1.5 3.3.7-1.2.7-4.9 1.2-1.7-1.3-.3-1-4.3.3-.3-.5 3.1-2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "US",
            })}
            d="M410 66.6 385.4 87l-35.6 32.7 4.2.2 2.8 1.6.5 2.6.3 3.8 7.6-3.3 6.5-1.9-.6 3.1.8 2.4 1.6 2.7-1.1 4.2-1.4 6.9 4.6 3.8-3.2 3.8-5.1 2.9-.6-2.2-2.5-2 3.3-5.2-1.6-4.9 2.7-5.6-4.1-.4-7.1-.1-3.8-1.8-3.3-6.1-3.3-1.1-5.7-2.1-6.8.5-6-2.7-2.7-2.5-6.3 1.2-3.5 4.1-2.9.4-6.6 1.2-6.2 2-6.4 1.3 3.2-3.5 8.4-5.8 6.8-1.8.4-1.4-9.4 3.2-7.4 3.9-11.2 4.2.2 2.9-9 4.2-7.7 2.5-6.6 1.9-4 2.6-10.6 3.1-4.5 2.8-8.2 2.6-2.7-.4-6.2 1.6-7 2.1-6.1 2-10 1.8.4-1.1 8.2-2.8 6.6-1.9 8.6-3.3 6.5-.6 5-2.5 10.4-3.6 2.3-1.2 5.7-2.1 5.8-4.5 6.2-3.5-7.3 1.8-.3-1.1-4.9 2.2.4-3-3.6 2.1 1.6-2.9-7.3 2.3h-2.8l3.7-3.5 3.3-2.2-.4-2.1-7.2 1.2-.6-2.8-1.3-1.4 4-3.3-.4-2.5 5.9-3.3 7.7-3.3 5.3-2.9 4.1-.4 1.8.9 7.1-2.8 2.5.5 5.6-1.8 2.5-2.6-1.1-1 6-2.2-2.8.1-6.2 1.2-2.9 1.3-1.8-1.3-6.9.7-4.6-1.4 1.2-2.3-1-3.2 9.2-2.4 13.2-2.7h3.5l-4.3 2.8 9.2-.2 1.2-3.5-2.3-2.1.8-2.8-.7-2.3-3.3-1.7 6.5-2.9 7.5-.2 8.8-2.4 4.8-2.6 7.9-2.6 4.8-.6 11.2-2.4 3.1.4 10.4-2.8 4.4 1.1-.5 2.4 3.3-1 6.3.3-1.9 1.2 4.9.9 4.9-.5 6.2 1.6 7.2.6 2.2.6 6.6-.8 4.1 1.6 3.5.7Z"
          />
          <path
            d="m677.3 487 1.5-2.8.5-2.9 1-2.7-2.1-3.8-.3-4.4 3.1-5.5 1.9.7 4.1 1.5 5.9 5.4.8 2.6-3.4 5.9-1.8 4.7-2.2 2.5-2.7.4-.8-1.8-1.3-.2-1.7 1.7-2.5-1.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GF",
            })}
            id="GF"
          />
          <path
            d="m592.9 422-.5-.2-.5-.5.1-.6.2.3.4.4.3.5v.1z"
            id="AW"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AW",
            })}
          />
          <path
            d="M634.2 384.9h-.2l.3-.4h.3l-.2.3-.2.1z"
            id="AI"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AI",
            })}
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AS",
            })}
            d="m27.7 593.3-.3.4-.2.3-.2.1-.4-.3.2-.2h.3l.1-.2.5-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AS",
            })}
            d="m34.3 593.3-.5.1-.1-.2.4-.1.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AG",
            })}
            d="m640.7 391.9.6.3-.2.3h-.2l-.7.1-.2-.1v-.5l.3-.1.1-.3h.2l.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "AG",
            })}
            d="M640.7 388.2h.2l.2.2.1.4-.1.3-.2.1-.1-.2-.3-.2v-.5l.2-.1Z"
          />
          <path
            d="m1264.1 333.3.3.1.2-.1.4.7-.1.2.1.9v.7l-.2.4-.1-.4-.6-.8.1-.4-.2-.7v-.4l.1-.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BH",
            })}
            id="BH"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m580.4 366-.4.5-.2.5-.6.3h-.5l-.1-.1-.4.2-.5.1-.6-.2-.4.1-.1-.5.3-.2.2-.3.4-.2.3-.4h.4l.3-.2.2.3.5.2.5-.2.7-1h.3v.2l-.3.9Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m580.6 364.3-.2-.6.6-.3.3.3v.2l-.3.1-.4.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m581 357.8.2-.1.5.3h.4l.4.1.3.2v.3l-.2.1-.5-.4h-.4l-.1-.1-.5.2-.5-.2v-.1l.2-.5.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m577.1 356-.2.4v.7l-.1.4-.4.3-.2.4-.4.3-.7.3-.1.2-.2-.2.1-.2.4-.1.2-.2v-.2l.4-.1.2-.4.4-.1.3-.4-.2-.3h-.4l-.2-.2.4-.5.1-.1h.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m575.2 355.7.1.1h.4l.4.2-.4.4-.1-.2h-.2l-.4-.1-.4-.2-.3-.6.3-.1.4.1.2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m566 349.8.6.7.3.2.3.5-.3-.1-.1-.2-.3-.1-.4-.4-.2-.1-.2-.4.3-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m569.7 349.8.3.6.2.5v.4l.2.2.2.7v.9l.2.3.5.2.4.6v.8l-.4-.7v-.2l-.3-.4-.6-.2.2-.2-.3-.3v-.3l.2-.3-.1-.5-.3-.4.1-.1-.3-.4-.1-.6-.2.1.1-.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m572.6 349.8-.3.2-.3-.1-.1-.2.6-.2.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m564.4 347.9-.1-.1-.3-.7h.2l.2.8Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m574.9 347.4-.4.6h-.4l.2-.3.1-.6.4-.3.1.4v.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m556.4 346.2-.3.1-.2.3-.3-.1.6-.4.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m556.6 346.9.4.2.2-.2.1-.5.2-.1.2.6v.5l-.1.3.1.6v.3l-.4.8-.2.1-.4-.2.2-.3.4-.2-.1-.1-.6.4-.2-.2.4-.3h-.4l-.2.1-.2-.2v-.7l.1-.2-.4-.5v-.2l.4-.2.1-.3.3-.1.1-.2.6-.3.1.4-.5.4-.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m570.1 346.3.1.5-.2-.1-.5.1-.4.1-.1-.2.3-.2.4-.3v-.2l-.4-.2-.2-.6-.1-.6-.4-.4v-.2l-.5-.5.3-.3.4.4v.5l.2.3.1.5.3.5.4.3.1.3.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m559.8 340.8.3.2-.6.3-.3-.1-.2.2-.5-.1.2-.3.4-.2h.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m555.6 340.3.4-.2.3.3-.1.2.1.2-.2.4.3.3.2.9.2.3.4.5-.2.7.1.6-.2.3-.3.1-.4.4-.3.2h-.3l-.3.2h-.3v-.4l-.3-.2.1-.6-.3.3-.2-.1-.6-.4-.3-.3-.2-.3.7-.3.5.7.1-.6-.3-.1-.1-.3.1-.3.6-.6.2-.4-.1-.1.3-.4v-.5l-.2-.7.1-.1h.3l.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m563.7 337.7.1.2.3.4.8.7.5.1.1.1.2.4.3.4.5.4v.2l-.2.8-.1.2v.3l-.1.5-.2.3-.1.7-.1.1-.2-.6-.4-.3.1-.2.5.1.2-.2-.1-.2.1-.4.3-.4.1-.5v-.3l-.5-.4-.4-.7-.3-.2-.6-.3-.3-.3-.6-.2-.4.2.4-.9h.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m554.9 330.2.5.2h.1l.7.1.2-.2.2.1h.5l.4-.2h.4l.3-.2.1.5-.1.2h-.7l-1.1.2h-.3l-1.5.4-.7.4h-.4l-.2-.1-.3-.3-.5-.6.6.3.1.2h.5l.5-.2.4-.6-.3-.1.2-.3.1-.3.3.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BS",
            })}
            d="m559.2 328.9.8.2.2-.1.4.3.9 1 .2.6.4.1.7.5v.2l-.2.5.2.7h-.4l-.5.4-.1.2-.3 1-.1.9-.2.2-.3-.2-.1-.4-.4-.1.3-.5h.2l.5-.4-.1-.4.2-.4v-.3l.2-.3v-.6l.2-.1.2-.3.1-.3-.3-.1-.5-.1-.1-.3v-.2l-.4-.2v-.3l-.3-.7-.2-.1-.3.1-.5-.1h-.3l-.6-.4h.5Z"
          />
          <path
            d="m635.2 387-.1-.3.3.1-.2.2z"
            id="BL"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BL",
            })}
          />
          <path
            d="M637.3 294h-.3l-.1.1.1.2-.4.2-.1-.1.2-.1h.1l.1-.3.3-.1.1.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BM",
            })}
            id="BM"
          />
          <path
            d="m651.5 418-.6-.2-.1-.5v-.8l.2-.4.2.2.2.6.5.3.1.4-.5.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BB",
            })}
            id="BB"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KM",
            })}
            d="m1233.2 581.3-.9-.1-.2-.4v-.3l.5.1.7.5-.1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KM",
            })}
            d="m1236.9 579.4.2 1v.7l-.1.2-.2-.3-.4-.3-.1-.2-.3-.1-.6-.4.1-.1.5.2.3-.1.2-.4v-.2l.3-.1.1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KM",
            })}
            d="m1231.2 578.4-.5-.4-.3-.1-.3-.2-.2-.6.1-.3v-.2l.2-1.2-.1-.1.2-.4.5-.1.2.3-.2 1.2.1.3.2.4.1.5.2.6-.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m847.8 406.5-.2.3-.2-.2v-.3l.3-.1.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m849.7 406.6-.2.1-.4-.1-.3-.3-.1-.3.2-.4.5-.3h.4l.2.7-.1.4-.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m853.2 403.5.2.1v.2l.2.2.4.5h.2l.2.3.2.5.2.2-.3.5-.3.1-.5-.1-.3-.1-.3-.3v-.2l-.2-.1-.1-.4.1-.2v-.3l.2-.4-.2-.5h.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m856.3 403.5.3.1.1.6-.1.4-.4.2-.4-.4.2-.4-.1-.2.4-.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m858.3 397.8.3-.2.5.2.1.2v.7l-.4.3-.3.2h-.3l-.5-.2v-.5l.2-.2v-.6l.1-.1.3.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m850.3 395 .4-.1.3.2h.4l.3.2.1.2h-.5l-.7-.3-.2.1-.3.6-.3-.6-.1-.1-.1-.4.3-.1.4.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m858.1 394.5.1.1-.1.6-.2.1v-.5l-.2-.3v-.3l-.1-.3.4-.3.2.2-.1.6v.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m846.8 393.2.2.3.1.3-.7.3-.3-.2-.2-.2.4-.4.5-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CV",
            })}
            d="m846 391.4.3.1v.2l.3.3-.2.4-.6.3-.4.4-.7.1v-.6l-.2-.2v-.2l.2-.2h.2l.2-.2.7-.4h.2Z"
          />
          <path
            d="M599 424.5h-.3l-.4-.3-.3-.1-.3-.3-.1-.2-.3-.1-.2-.4-.3-.3.1-.5.5.3.1.5.4.4.7.2.2.3.3.4-.1.1z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CW",
            })}
            id="CW"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KY",
            })}
            d="m532.7 377.8.3.1.2-.4.4.1h.5l.1.2-.2.2-.2-.1-.4.1-.2.1h-.7l.2-.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KY",
            })}
            d="m540.8 375.3-.7.3.2-.3h.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KY",
            })}
            d="m541.4 375.4-.1-.1.8-.3-.2.3-.5.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CY",
            })}
            d="m1168.2 276.7.1.2.3.4-.4-.1h-.3l-.4.2-.3-.3v-.3l.3-.1.2.1.5-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "CY",
            })}
            d="M1166.5 277.2v.1l-.2.2-.1.6-.1.2h-.3l-.2.2-.5.2-.2.1-.6.3-.4-.1-.5.1-.3.4-.2-.3-.3.1h-.2l-.3-.3-.4.3h-.5l-.5-.2-.5-.1-.4-.3-.3-.6-.3-.3-.2-.7-.2-.3.1-.3.5.3.4-.1.2-.3.1-.3.3-.1.2.1.2-.2h.2l.1.4.5.2.1.2h.6l.6-.5.4.1.3-.2.3.1.4.2.2-.3h.3l.3.4v.6l.3-.2.3.2.1-.1.7.2Z"
          />
          <path
            d="m642 401.7.5.1.2.5v.6l-.1.8-.1.2-.2.1-.4.2.1-.4-.1-.2-.1-.7-.3-.5v-.3l.1-.3v-.3h.2l.2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "DM",
            })}
            id="DM"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="m697.4 836.2.4-.1v.4l-.8-.3.3-.3.2-.1-.1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="m696.7 834.8.2.2.4.1.1.4-.3.1-.1-.4-.2-.2-.1-.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="m702.9 834 .2.1-.1.4-.3-.1-.2-.3.3-.2.1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="M690.8 833.1v.2l.1.3-.4.1-.3-.1-.2-.2-.3-.1-.1-.4h.2l.1-.2.3-.1.2.1-.3.3.3.1.3-.3.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="m693.7 831.8-.4-.2-.5-.3-.8-.3.1-.4-.7-.1-.3-.1-.3-.4.2-.1.8.3.8.4.5.1.4.1.3-.3.1-.3.2.1.4-.2.1.2h.5v.3h.3l.9-.2.1.2h.3l.4-.1-.3-.2-.1-.3h.4l.6.2.1.4-.4.5.1.3-.2.2h-.4l-.3.8-.3.3-.3.6-.1.3-.5.3-.1-.2h-.4v.3l-.8-.1-.1.1.3.4-.1.1-.2.4h-.4l-.3.4-.3.1h-.2l-.2-.3-.4-.3v-.2h-.5l.6.4h-.4l-.5-.3-.2-.1-.4-.2-.3-.2v-.2l.7.2.6-.2-.5-.2-.1-.1h.9l.4.1.3.2v-.2l.4-.1.1-.3-.4-.2-.2-.5.1-.2h.6l.2.1.4-.1-.1-.3h-.8v.1l-.4.2h-.6l-.5-.3v-.3l.7.2.6-.2h.3l.5-.1.4.2v-.1l-.4-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="M695.3 829.9h.3l.3.3-.3.1h-.3v-.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="M694.3 829.9h-.3l-.1-.3.4.1v.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="m692.9 829.7.6-.1.2.3-.3.4-.2-.1-.3.1-.3-.2.3-.2.3.2.1-.2-.5-.1.1-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="M700.1 829.8h.6l.1-.1.5-.1.4.2.4.3.1.3v.1l-.5.1-.2-.3-.2-.1-.1.3.2.1.1.3.3-.2.2.1.1.4.3.1.1-.1.5.3.1-.4-.8-.2.1-.5.3-.2 1.5-.1.7.6.2.1v.4l-.6-.1-.5-.2-.6.2.3.2.4.1.9.1.3.1.1.2-.2.5h-.5l-.1.1-.7.1-.5.2.3.2-.9.4-.4-.1-.5.1h-.7l-.6-.2-.6-.4v.3l.3.2.6.2.3.3.2-.1.4.1.4.3-.2.1.2.5h-.2l-.3-.3-.4-.1-.5.4-.2-.3-.3-.2h-.3l-.5-.2-.2.1.2.4h.3l.2.2-.2.1.7.6-.2.1-.4-.2h-.3l-.3-.3-.3-.1-.3-.1-.1.6.5.1v.3l-.1.2-.4-.1-.1-.2-.5-.2-.1-.2h-.2l-.4-.5.3-.4v-.2l-.4-.5v-.2l.5-.2-.1-.2.5-.1-.1-.3.6-.4.6-.2.4.4v.4l.3-.1-.5-.6.1-.3-.6-.2-.4-.3.1-.2.4.2.1-.5-.7-.2.1-.3.2.1.3-.2h.3l.2-.3-.3-.3h.4l.5.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="M695.1 829.4h.7l.2.2.2-.2.2.1.2.3-.2.1-.4-.1-.4-.2-.8-.1.1-.2.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FK",
            })}
            d="m688.3 828.3-.5-.1.1-.2.4.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FO",
            })}
            d="m955.6 112 .4.2h.3l.1.2v.4l.2.3-.1.2-.6-.4-.2-.4-.2-.2-.2-.3h.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FO",
            })}
            d="m955.9 110.4.8.2.2.2-.1.4-.1.1-.4-.5-.5-.1-.2-.4.3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FO",
            })}
            d="m954.62 109.04.08.16h.3v.3h-.4l-.2.2-.6-.2-.2-.1-.2-.3.5-.1.1-.1.55714286.09285714L954.3 108.8l.2-.8.5.1.3.5v.1l.6.2.3.5.3.2-.1.6-.5-.4-.2-.2-.2-.1-.1-.2-.2-.2h-.5l-.08-.06Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FO",
            })}
            d="m958.3 108.4-.2-.2.3-.2-.1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FO",
            })}
            d="m955.9 108.9-.4-.2-.3-.3-.1-.3.1-.1.4-.1h.3l.6.4-.1.2.1.2.6.2v.2l-.4.3-.8-.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FO",
            })}
            d="m958.1 108.3-.3.4-.3-.2h-.3l.2-.3-.1-.4.1-.1.2.4.5.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FO",
            })}
            d="M957.2 108.3h-.2l-.2-.4.1-.3.2.4.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FM",
            })}
            d="m1909.4 467.7-.2.3-.5-.1v-.2l.5-.4.2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FM",
            })}
            d="M1881.2 457.1h.4l.3.2.1.4-.2.1.1.2-.1.2h-.6l-.2-.2v-.2l-.2-.3v-.3l.4-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FM",
            })}
            d="m1766.5 440.5.1.3h-.3l-.3.5-.1-.1.3-.8.4-.1-.1.2Z"
          />
          <path
            d="m639.2 424.5-.4.3-.2-.1-.1-.5.2-.5.3-.4h.3l.1.3-.1.7-.1.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GD",
            })}
            id="GD"
          />
          <path
            d="m1800.8 415.5-.1.4v.6l-.1.3h-.3l-.2-.3-.1-.5v-.5l.6-.5.1-.2.1-.5.2-.1.1.2.4.1-.2.5-.5.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GU",
            })}
            id="GU"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KN",
            })}
            d="M636.3 392h-.3l-.1-.2.2-.4h.2l.1.2-.1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "KN",
            })}
            d="m635.6 390.5-.1.3h-.2l-.4-.2-.2-.2.3-.4.5.4.1.1Z"
          />
          <path
            d="m643.7 413.8-.2-.2-.4-.2-.1-.2v-.6l.1-.2.7-1.1.3.2v.7l-.1.8-.1.4-.2.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "LC",
            })}
            id="LC"
          />
          <path
            d="m634.2 386-.4-.1.2-.3.3-.1-.1.5z"
            id="MF"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MF",
            })}
          />
          <path
            d="M1402.9 474.8v.2l-.2-.1.2-.2v.1z"
            id="MV"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MV",
            })}
          />
          <path
            d="m1953.8 456 1 .4h-.2l-.8-.4z"
            id="MH"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MH",
            })}
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MT",
            })}
            d="m1063.9 271.7-.2.3-.5-.2-.5-.3v-.5l-.1-.1h.6l.4.3.2.2.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MT",
            })}
            d="m1062.3 270.6-.5-.1v-.2l.4-.1.4.3-.3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MP",
            })}
            d="m1802.5 411.1-.1.1-.2-.1-.1-.2.5-.2.2.2-.3.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MP",
            })}
            d="M1804 406h-.2l-.3-.6.1-.3h.3v.3l.2.2-.1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MP",
            })}
            d="m1804.5 404.4-.2.2.1.3h-.4v-.7l.1-.2.4-.2-.1.5.1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MP",
            })}
            d="M1802.6 396.9h-.3l-.1-.2h.4v.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MP",
            })}
            d="m1800.7 385.9-.1-.2v-.5l.3-.1.2.3-.4.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MP",
            })}
            d="m1799.5 381.6-.4-.1v-.3l.2-.1.2.2v.3Z"
          />
          <path
            d="m638.2 393.9.2.4v.3l-.2.2-.2-.1-.1-.3.3-.5z"
            id="MS"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MS",
            })}
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MU",
            })}
            d="m1307.7 630.8.4.9-.2.6-.4.4.1.3-.3.3-.5.2h-.5l-.6-.1-.1.1-.3-.3.2-.2.1-.4.1-.7.2-.4.5-.4.1-.2.2-.5.4-.3.4.1.2.6Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MU",
            })}
            d="m1339.5 628.7-.3-.3.4-.2.3-.1.2.1-.1.2-.5.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1915.2 646.9-.2.1-.2.4-.4-.2.2-.5.1-.2.3.1.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1919.6 639.1-.1.1.2.4h.3l.4-.2-.1.6-.2.2-.1.4-.5.3-.4-.2v-.1l-.3-.3.1-.2-.2-.2.1-.4-.1-.4h.1l.4.1.4-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1916.9 634.8-.2.5v.4l-.2.3.3.2.2.1.1.2-.1.2.3.4h-.2l-.2.5-.2.2-.3-.1-.2-.3-.1-.2-.6-.1-.3-.5v-.2l-.1-.3h.3l.3-.2.4-.3.1-.3-.4-.2-.4.1.2-.4.3-.1.2.1.4-.3.4.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1913.5 633.2-.3.6-.1.3h.3l-.5.5-.2.2-.1-.2.3-.4.2-.5.4-.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1913.5 633.2-.2-.4h.4l.1.4h-.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1899.6 630.8.2.1.5.9.3.3.3-.1.2-.3.9.5.3.5.7.6.3.4.1.3.4.4.1.2h.2l.3.3.9.2.1.3v.4l.3.4.4.1-.3.5.1.2.4.5h.1l.4.5-.1.4.7.2.4.5h.3l.3.2.5.4-.1.3h.3l.4.5.6.4v.2l.3.1.3.3v.2l.3.6.4.4.1-.1.4.6.5.1.3.3v.4l.1.4.1.1-.2.6-.7.4-.1-.3-.3.1-.3.3-.6-.8h-.4l-.1-.2h-.2l-.2.3-.9-.9h-.2l-.4-.5.1-.8h-.7l-.3-.2-.1-.2-.2-.1h-.3v-.3l-.2-.5-.4.1-.8-.5-.1-.2v-.3l-.3.2-.6-.3-.1-.4-.4-.3-.2-.5-.5-.1.2-.2-.3-.3-.3-.1-.3-.7v-.4l-.2-.3h-.3l-.2-.6.1-.2-.7-.4-.3-.2-.4-.6.3-.2-.2-.2-.2-.3v-.5l-.5-.3v-.6l-.2-.3h.3l.1-.3-.1-.2h-.6l-.2-.3.5-.7-.3-.3.2-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1900.7 631.1-.3-.1.1-.4.2.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NC",
            })}
            d="m1898.4 628.7-.2.2-.1-.4.2-.2.1.4Z"
          />
          <path
            d="M1933 505.3h-.2l-.1-.3h.3v.3z"
            id="NR"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "NR",
            })}
          />
          <path
            d="m1747.7 453.1-.2.4.1.1-.2.6.1.2-.5.2-.2-.7.3-.2-.2-.2.3-.6.3-.1.2.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PW",
            })}
            id="PW"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PR",
            })}
            d="m607.1 385.9-.3-.2.1-.2h.3l.1.1-.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PR",
            })}
            d="M621.7 385.4h-.2l-.9.3h-.6l.2-.2.4-.2.4-.1.6.1.1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PR",
            })}
            d="m612.2 383 .6.1h.6l.3.1.6-.1.3.1.4-.1.2.1.5-.1.4.1h.3l.8.2v-.2l.6.2.1-.1.8.1.2.2h.2l.6.3.2-.1-.1.7.2.3-.9.3-.3.4-.3.6-.3.2-.3.1h-.4l-.6.1-.3.2-.7-.1-.2-.2-.5.2-.3-.3-.7.2-.9-.1-.3.1-.6.1-.2.1-.2-.2-.4-.1-.3.2-.6-.1.3-.7v-.4l.2-.4-.2-.6-.2-.1-.1-.4.4-.2.2-.1v-.5l.4-.2.5.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m195.3 679.3-.1-.1-.2-.3.1-.2.3.2-.1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m205.6 641.2-.1.1-.3-.2.2-.2.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m199.4 616.5-.2-.1.2-.6.5-.4h.3v.2l-.2.4-.6.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m151.7 615.5.7.2.3.4v.3l-.2.1-.5-.1-.4-.6-.1-.2-.6.2h-.2l-.6-.1-.2-.4-.3-.5v-.3l.1-.2.5-.1h.5l.5.2.2.4.1.6.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m148.7 614-.2.6-.5-.2.1-.3.5-.2.1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m141.1 609.7-.2.1-.2-.3.3-.1.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m139 610.1-.3.2h-.3l-.2-.8.2-.2.7.8h-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m138 608.3.2.1v.5l-.4-.2-.1-.3.3-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m166.3 605.4-.3.1.1-.3.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="M204.3 569.5h-.3v-.4l-.2-.3.4.1.1.4v.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="M201.2 566h-.2v-.4l.2-.3.3.2-.2.2-.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="M202.4 564.4v.3l-.4.1h-.6v.3l-.4-.1-.2-.2-.1-.3.7-.4h.3l.2.2.5.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="M195.5 561.8V562.4h-.3l-.3-.4.3-.3.3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m197.9 558.8.3.1.1.1-.6.2-.1-.3.3-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "PF",
            })}
            d="m194.2 558.2.9.1.3.3v.2l-.4.3h-.8l-.1-.5-.1-.4h.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1926.8 576.2.3.2-.1.4h.3v.2h-.8l-.3-.5.2-.3h.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="M1888.5 575.6h.2l1 .8.5.3.9.7-.1.3h-.2l-.2.2-.2-.3h-.1l-.2-.2-.1-.4-.4-.1v-.3l-.3-.1-.1.1h-.2l-.9-.4-.2-.4.3-.4.3.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1925.4 574.1-.2.3-.3-.2v-.2l.3-.2.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1923.1 570.2.1.1h.3l-.1.4-.5.2h-.3l-.4.1-.4.6-.1-.3-.3.1-.2-.2v-.3l.5-.1v-.2l.3-.4.7.1.4-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1896.8 567.4.3-.1.6.3.5.5.3.3h.2l.2.2h.2l.3.3.3-.1.4.1.2.2h.4l.3-.1.2.3.2.8.3.3v.5l-.2.2.1.3-.4-.2-.3.2-.3-.1-.5-.3h-.2l-.6-.2-.4-.1-.2-.3-.3-.2-.3-.1-.2-.3-.4-.2.2-.4-.1-.4v-.4l-.2-.1-.6-.2-.3.1-.1-.2.1-.3.1-.3h.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1900.8 564-.1.2v.7l-.2-.2v-.5l.3-.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1897.9 562.2.3.9.2.4v.4l.1.5-.2.3-.4-.7-.1.3-.3-.5.1-1 .1-.2v-.3l.2-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="M1889.5 562.4h.3l.3-.1.4.1.1-.1h1.3l.2.3.3.1.2.3h.2l.2.1.4.4v.6h.2l.4.2.1.3v.6l-.1.1-.7.2-.2.1-.4-.1-.4-.2h-.4l-.1-.2-.5-.3h-.6l-.5.1h-.5l-.5-.1-.3-.2-.3.1-.3-.4-.3-.2-.3-.8-.2-.4.2-.2-.1-.2v-.7l.1-.3.6-.3.4.2.4.5.1.3.3.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1891.8 560 .5.5-.3.3-.3-.2v-.1l.1-.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1891.8 560-.2.4h-.1l-.4-.3-.3.1-.2-.1-.1-.2.3-.1.2-.2.5.1.3.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1885.2 559.5.1.2.2.1-.2.4-.4.2-.3-.4.6-.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1876.7 557.7.2.3-.1.3-.8-.4.5-.3.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1880.1 558.5-.3-.2.1-.3.3-.3v.5l.1.2-.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1879.2 556.7.2-.1h.4v.2l-.4.3.2.2v.3l-.4.4-.2.1-.3-.1-.4-.4.1-.6.3-.1.2-.4.3-.1v.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1875.6 556.8-.2.1-.2.5.4.5-.5-.2v-.2l-.1-.3-.4-.4v-.2l.4-.2.1-.3.4-.3.3.2v.4l-.2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1888.5 556.3.2.2-.1.2-.2-.1-.6-.5.2-.4.3-.1.2.2-.1.3.1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1895 555.5.4.8.6.8v.3l-.4.2v.8l.1.2h.2l.2.3.5.4.1.5.1.3.2.2-.2.2.3.3-.1.1.1.5-.2.2.3.3.1.5.2.5v.6l-.1.1-.3-.3-.3-.5v-.3l-.3-.4-.4-.3-.3-.3-.5-.6-.4-.3-.3-.9-.2-1-.2-.7v-.5l-.1-.4.4-.4-.1-.3-.5-.7-.1-.3.1-.1.4.1.2.1.3-.3.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1874.3 555.2-.2-.4-.3-.3h.4l.1.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1874.2 554.2.4.1.1.1.1.5h-.2l-.2-.4-.2-.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1877.3 554.4-.1.3h.7l.4.7v.2l.2.3.1.5-.2.2v.3l-.6-.2-.2-.2h-.3l-.4-.3-.1-.2-.1-.3.4.1-.3-.8-.1-.2-.5.1-.2.1h-.4l-.3.4-.4-.2v-.6l.2-.2h.4v-.4l.4-.6.4-.3.3-.2.4.3.2.4-.1.7.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="M1871.4 554.4h-.1l-.2-.8.1-.3v-.4l.2.1.1.4v.7l-.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1874.8 553.9-.3.2-.1-.1h-.4l-.3-.3-.1-.3-.1-.3.1-.3.3-.4.5-.2.2.2.3.5v.6l-.1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1871.8 550.4.4.5v.1l.7.4-.1.3-.6.7v.3l-.3.1v-.4h-.2v-.4l-.2-.4-.3-.2-.1-.3.1-.3.2-.2.2-.2h.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1882.1 550.5.3.2-.2.1-.5.1-.1-.3.2-.2.3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1883 550.5.2-.1.5.3.3.1.2.2.3.5.3.1.3.3v.3l.5.1v.3l.3.1.3-.1.1.1.4.2.1.2.3-.1.3.1.1.3.4.3.3.3.4.3 1 1-.3.4.3.5.1.6-.3-.1-.3-.4-.7-.8-.4-.1-.5-.4-.6-.1-.1-.3-.6-.2-.5-.5h-.2l-.8-.6-.5-.3v-.2l-.4-.2-.2-.2-.2-.4-.4-.3-.1-.2v-.4l-.4-.5-.2-.1v-.3l.7.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1881.5 549.9.2.2.2-.1.3.2-.1.2-.3-.1-.3-.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="M1877 549.3h.5l-.2.2-.3-.1v-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1881.3 549.3-.2.5-.1-.2.3-.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1878.6 549.7-.5.1-.2-.2.3-.4.3.1.1.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1866.1 548.8.2.3-.2.2-.3-.1-.1-.1.4-.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1867.6 546.9.3.2-.1.3-.7.2-.3-.3.3-.6.2-.1.3.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="M1869.3 546v.5l-.2-.2v-.2l.2-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SB",
            })}
            d="m1872.2 544.5.3.1.4.5.3.2.3.1.3.3.8.4.4.5v.4l.1.6.2.2.3.3h.2l.1.4.7.3.4-.1.1.1v.3l-.3.1-.2.3-.5-.2-.8-.4h-.5l-.3-.4-.7-.4-.6-1-.6-1-.5-.3-.7-.7v-.7l.3-.2.3.1.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ST",
            })}
            d="M1023.9 501.3h-.2l-.2.3h-.2l-.1-.4-.2-.8v-.3l.4-.5.3-.1.3-.3.4.1.2.4.1.3-.1.4-.2.3-.3.4-.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ST",
            })}
            d="m1028.5 491.5-.1.3-.2.1-.3-.1v-.3l.2-.1v-.3l.2-.2.3.1-.1.5Z"
          />
          <path
            d="M634.2 386v.1l-.4-.1v-.1l.4.1z"
            id="SX"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SX",
            })}
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SC",
            })}
            d="m1249 562.1-.3.2h-.5l-.4.2h-.4v-.2h.5l.4-.1.4-.3h.2l.1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SC",
            })}
            d="m1248.5 561.8-.2.1h-.4v-.2l.6.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "SC",
            })}
            d="m1300.4 531.5.4.4-.2.3-.2-.3-.3-.2.2-.5.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TC",
            })}
            d="M587.7 361.6h.7l.3.4h-.3l-.3-.1-.5.1-.1-.3.2-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TC",
            })}
            d="m585 361.5.3.4.6-.1-.2.2h-.6l-.4-.2.3-.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TC",
            })}
            d="M587.2 360.9v.5l-.5-.2-.1-.3.1-.1.5.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TO",
            })}
            d="m14.7 639.5-.5-.3v-.2l.3-.2.2.7Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TO",
            })}
            d="M11.9 637.4h.3l.4.3.3.1.2-.4.3.3-.3.3.1.2-.1.2-.2-.1-.3-.3-.7-.2v-.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TO",
            })}
            d="m11.1 628.8-.2.1-.1-.5.2.1.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TO",
            })}
            d="m15.5 621.3-.5.3h-.2l-.1-.1.3-.5.3.1.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TO",
            })}
            d="m1.4 602-.1.1-.3-.1.1-.2h.3v.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TT",
            })}
            d="m642.8 432.2-.2.5-.3.4-.2.1-.1.4.2.6-.2.1v.7l.2.3.2.2-.2.2-.1.3v.7l-.2.1-.4.2-.5.1h-.3l-.5.1-.5-.1-.4.1-.3-.1-.5.2-.4-.2h-.6l-.3.2-.3-.1.5-.2.3-.3.4-.1.4-.3.2-.3.6.1.3-.4-.2-.8.2-.4v-.7l-.3-.4-.3-.1-.4-.1-.1-.1.4-.3 1.1-.1.2-.2h1.1l.1-.1 1.2-.2h.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TT",
            })}
            d="m645.2 429-.1.5-.3.1-.4.3h-.2l-.7.4-.2-.2.3-.3.7-.5.9-.3Z"
          />
          <path
            d="M1998.9 556.6v-.2h.1v.1l-.1.1z"
            id="TV"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "TV",
            })}
          />
          <path
            d="m642.2 417.4-.1.1-.5-.3v-.4l.2-.3.2-.5h.4l.1.4-.1.8-.2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VC",
            })}
            id="VC"
          />
          <path
            d="m626.1 383.4-.4.2h-.1l-.3.2-.1-.1.1-.3.6-.1.2.1z"
            id="VG"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VG",
            })}
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VI",
            })}
            d="m624.5 387.8.3.3-1.1.2-.1-.5.7-.2.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VI",
            })}
            d="m625.2 384-.2.2h-.5v-.2l.3-.1.4.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VI",
            })}
            d="m623.8 383.8.4.3-.2.2-.3-.2h-.5l.2-.2.4-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1931.8 631.8-.5-.2.2-.4.5-.1.2.4-.1.2-.3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="M1930.6 628h-.2l-.3-.1-.4-.5-.1-.4v-.4l.2-.2.1-.4.3-.1h.4l-.2.3v.5l.7.5-.3.3-.2.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="M1930.6 622.1h.3l.1.2-.5.1.1.3.4.2.1.3-.1.4-.4.1-.4-.3h-.4l-.2-.2-.3-.2.1-.4v-.3l.2-.5.3-.4h.5l.2.1-.1.4.1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1927.6 614.5.6-.1.1.1.2.6.2.3.1.1-.4.6-.8.2-.3-.3-.1-.5-.3-.1-.4.3-.1-.1.2-.4.4-.3.4-.5.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1929.9 610.6-.1-.3h.3l-.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1928.3 608.2.1.5v.2l.4.1.2.5h.5v.4l-.1.1-.3-.3-.3-.1-.6.2-.3-.1-.1-.2-.1-.4.2-.5.2-.3.2-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="M1929.2 608h-.1l-.1-.3h.2v.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1929.4 606.6-.2.2h-.6l-.3.1-.2-.2-.4-.1-.5-.4.1-.2.5-.2.4-.1.4-.3.1-.3h.2l.1.3v.6l.5.4-.1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1924.7 605.3.2.3.6.4.7.7.1.1v.4l.2.3-.3.2-.4.4v-.2l-.3-.1h-.4l-.2.1v.2l-.4.2-.3-.1v-.7l-.1-.6.1-.6.1-.5-.2-.5-.6.3-.2-.2-.1-.3v-.3l.3-.3v-.4l.1-.3.3-.1.6.3-.1.2.2.5-.1.2.2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="M1924.1 602.9h-.3l-.5-.3v-.1l.2-.3.2-.1.5.1-.1.4v.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1923.6 601.9.4-.3.1.1.1.3h-.5l-.1-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1929.3 604.5-.2-.1.1-1.2-.1-.3.1-.5.3-.8.1-.5.2.6-.1.3v1.6l-.1.6-.3.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="M1928 601.2h-.7l-.3-.1v-.2l.9-.7.5-.2.5-.1v.2l-.3.4-.2.3-.4.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="M1929.9 600.5v.2h-.3l.1-.3.2-1.3v-.1l.1-1.2.2.1-.1 1.3.1.3-.1.5-.2.5Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1923.6 601.9-.9-.1-.6.3-.1.2h-.2l-.1-.6-.2-.1-.4-1 .4-.8v-.4l-.1-.2v-1.4l-.1-.3v-.5l.2-.3v-.3l.2-.3v-.2l.3-.1.1.5.2.4.2.3.1 1.3-.1.8v.1l.6-.1.3-.3.2-.8v-.2l.3-.2.3.1-.1.4v.9l.3.1v.5l-.2.1.3.4-.2.2v.5l.2.5-.1.2h-.3l-.5.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1927.8 592.6.4.3-.1.4-.3.3-.2.2h-.6v-.4l.1-.4.2-.3.5-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1928.4 590.7-.3.2-.2.1v.2l-.2.1v-.3l-.2-.2-.1-.3.1-.4.2-.1.4-.2.1.2.1.4v.1l.1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "VU",
            })}
            d="m1923.4 586.5-.1-.1.1-.5.2.2-.2.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "WS",
            })}
            d="m21.9 591.3.3.1.3.1.3.2-.1.3h-1l-.3-.1-.3.1-.2-.1-.4-.2-.3.1-.3-.2-.2-.2-.6-.3.1-.4.4-.2h.9l.9.4.5.1v.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "WS",
            })}
            d="m17.4 588.5.6.6.2.7-.1.3.1.3h-.3l-.3-.2-.3.2-.9.1-.3-.3-.2-.4-.2-.1-.3-.3-.5-.4-.2-.2v-.2l.4.1.3-.1.6-.2h.4l.5-.1h.3l.2.2Z"
          />
          <path
            d="M602 424.6h-.2l-.1-.5.1-.3-.1-.3-.4-.1-.3-.3.1-.3 1.2.6-.1.2v.4l-.2.2v.4z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "BQ",
            })}
            id="BQBO"
          />
          className=
          {classNames("transition duration-300", {
            "fill-blue": highlighted === "SE",
          })}
          <path d="m634.3 389.6-.2.1v-.2l.1-.1.1.2z" id="BQSE" />
          className=
          {classNames("transition duration-300", {
            "fill-blue": highlighted === "SA",
          })}
          <path d="M632.8 388.7h-.1l.1-.2.1.1-.1.1z" id="BQSA" />
          <path
            d="M644 406.9v.2l.4-.1-.2.5.2.2v.2l.2.2.2.9-.3.3-.1-.4-.1.1-.6-.1h-.4l-.2-.3.6-.5h-.4l-.4-.4-.1-.5-.2-.5.3-.4.4.1.5.3.2.2z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "MQ",
            })}
            id="MQ"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m888.4 323.4-.3.5-.4.5-.3-.4h-.4l-.2-.2.2-.3.4.1.4-.4.3-.2.2.1.1.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="M902 321.1v.5l.2.4-.2.7.1.3-.4.4-.5.2-.2.2-.6-.2-.5-.5-.2-.4v-.6l.6-.4.1-.5v-.2l.6.1h.4l.3.1.3-.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="M892.1 321.9h-.2l-.3-.2-.2-.3.1-.4.1-.3h.6l.5.4.1.3-.5.5h-.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="M898.2 318.4v.2l-.6.3-.4.5-.3.2v.4l-.4.7-.1.4-.5.6-.1.2h-.2l-.6.2-.1-.1-.1-.4-.3-.4-.1-.2-.2-.3v-.3l-.4-.6.5-.3.3.2.6-.2h.4l.5-.2.5-.4v-.2l.6-.3h.6l.3-.1.1.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m908.4 321.2-.3.4-.4.1-.3-.1h-.4v-.2h.3l.6-.2.4-.3.3-.3.1-.5.1-.3.2-.5.3-.4.3-.6.2-.8.2-.2.4-.1.3.3.1.5-.1.5-.1.5v.5l-.1.1-.3.7-.3.3-.6.1-.7.3-.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="m888.8 316.7.3-.1.2.3.2.5-.2.3.1.4-.6 1-.1-.1-.1-.4-.4-.9-.1-.3-.1-.2.2-.4.3-.2.3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "ES",
            })}
            d="M912.9 314.7v.4l-.2.5-.7.5-.5.1-.4.5-.5-.2v-.1l.2-.4v-.4l.2-.3.3-.2h.3l.3-.3h.5l.1-.1.2-.5.2-.1.2.2-.2.4Z"
          />
          <path
            d="m1240.2 583.1.2.3.5.2v.3l-.2.2.1.2-.3.6.1.2-.3.1-.2-.3v-.3l.2-.2-.2-.7-.1-.1-.1-.2.3-.3z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "YT",
            })}
            id="YT"
          />
          <path
            d="M1295 635.8h.4l.4.2.3.3v.3l.1.5.3.2.2.2.1.2-.2.6-.1.4-.2.2-.4.1h-.9l-.2-.2-.8-.4-.3-.5v-.3l-.3-.6.1-.4.2-.2.2-.4h.1l.5-.2h.5z"
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "RE",
            })}
            id="RE"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GP",
            })}
            d="M643 399.9h-.3l-.2-.4.1-.2.3-.3.3.2.1.3v.2l-.3.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GP",
            })}
            d="M641.2 397.3h.3V397.6l-.2.1V398.9l-.2.2-.6.3v-.2l-.2-.2-.1-.5v-.5l-.1-.5v-.3l.2-.3.3-.1.5.3.1.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "GP",
            })}
            d="m642.6 396.9.4.1.5.4-1.3.3-.3.1-.4-.3.1-.6.2-.1-.1-.6.1-.2.3-.2.3.4v.4l.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1989.1 624.9-.3.1.1-.4.2.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1981.6 623.3.2.2.3.1v.3l-.5.2-.5-.3-.5.3h-.3l-.2.3.1.3-.4-.1-.1.2-.4-.1-.1.1-.4-.2.3-.1.2-.1.2-.2.4.1.3-.3.2-.3.5-.1.5-.3h.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1982.5 623.2-.2.1-.2-.1.2-.2.2.2Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1988.4 617.1.1.5-.2.6-.1-.2-.1-.4h-.2l.1-.5.2-.1.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="M1985.8 615.7h-.1l-.1-.4.2-.2.4-.1v.4l-.2.2-.2.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1983.6 613.2-.1.4.3.2.1.3.3.4.3.1.1.3h.2l.1.4-.3.5.1.2.1.5-.3.2v.5h.2l.1.5-.3.3-.6.2-.1-.2-.3.1-.1.2-.3-.3-.8.3-.8.7-.3-.1-.4.2-.3-.1-.6.1-.3-.2-.9-.3-.3-.1-.6-.1-.2-.1-.5-.2-.2-1 .3-.7h.3l.3-.1.1-.5.3-.1.1-.4-.2-.2.6-.4.4-.5.1.1.6-.5h.2l.9-.4.6.2.3-.1.5-.2.6-.1.3-.3.4.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1989.9 613.4-.2.1.2-.9h.4l-.1.4-.3.4Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1978.5 611.4-.2.3-.5.3v-.3l.4-.4.3.1Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1993.4 611-.2-.2.1-.2.5-.5.3-.5-.3 1.1-.4.3Z"
          />
          <path
            className={classNames("transition duration-300", {
              "fill-blue": highlighted === "FJ",
            })}
            d="m1994.4 606-.4.4-.8 1.1-.3.1-.7.4-.2.6-.4.2-.2.3-.1.2.3.1.6-.3.1-.1.3-.3.2-.3.6-.3.3-.3.6-.3v.3l-.5.7-.2.1.1.6-.3.3-.3-.3h-.4l-.5.1-.4.3-.7.1h-1l.5-.5-.4-.2-.6.2-.4.2v.2l-.3.1-.2.1-.1.4-.2.3-.3-.1v-.2l-.4-.1-.4.2-.2.5-.3.2h-.3v-.7l-.2-.4.1-.2-.1-.1-.6.2v-.4l.4-.3h.1l-.1-.5.3-.1.5.3.6-.4h.2l.3-.3h.2l.3-.3v-.2l.8-.1.9-.3.3-.1.4.1.5-.2.2-.4h.2l.2-.4.4.1.1-.2.2.1 1-.5.1.3.2-.1.2.1.3-.3.5-.2.1.1-.5.4h-.2Z"
          />
          <circle cx="997.9" cy="189.1" id="0" />
          <circle cx="673.5" cy="724.1" id="1" />
          <circle cx="1798.2" cy="719.3" id="2" />
        </svg>
      </div>
    </div>
  );
};

World.defaultProps = {};

export default World;
